import axios from 'axios';
import DOMPurify from 'dompurify';
import spinning_small from '../assets/images/spinning_small.gif';
import spinning_large from '../assets/images/spinning_large.gif';
import personSmall    from '../assets/images/person-small.png';

import "./components.css";

import { getSupportRequestUrlByHostname, 
         getLangCode,
         isAdvancedExchangeServiceType, 
         isHpUser                 } from "../common/utils.js";

import { ProfileIcon, 
         NotificationIcon, 
         NewsIcon,
         ChatbotIcon,
         ChatbotSandy,
         SearchIcon               } from './icons.jsx';

import { DownloadTableAsShownXLSX } from './DownloadTableAsShownXLSX.js'
import { toast                    } from 'react-toastify';
import { OrderNotes               } from '../notes/notes.jsx'
import { NotificationModal        } from '../orderNotifications/orderNotifications.jsx'
import { Cases                    } from '../widget/hCases.jsx';
import ProductImage                 from './productImage/productImage.jsx';

import * as Formatter from './formatter.jsx'
import * as _ from "lodash";
import showdown from '../vendors/showdown.min.js';

export const exportExcelMaxLimit   = 50000;
export const showAllOrdersMaxLimit = 50;

var _wikiUrl  = "https://oss-wiki.hpcloud.hp.com/";
var sessionId = "696d656761014f53535f746573745f75736572016f73735f7465737421";

var moment    = require('moment');
var React     = require('react');
var ReactDOM  = require('react-dom');
var PropTypes = require('prop-types');

var minSearchChars = 2;


//----------------------------------------------------------------------
//  L   --  localization / translation
//          just calls global T / i18n function
//
//----------------------------------------------------------------------
export class L extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return T(this.props.children);
  }

};


function ConvertBRs(t) {


    if ( t == null || t == undefined || typeof t.split != "function") return t;
    var a = t.split('<br>');

    if (a.length < 2) { return t }

    var out = [ a[0] ]
    for (var i=1; i<a.length; i++) {
      out.push(React.createElement('br', {}));
      out.push( a[i] );
    }

    return out;
}

export class DeclareSVGIcons extends React.Component {
  render() {
    return (
      <svg display="none">
        <symbol id="bell-ring-outline" viewBox="0 0 24 24" style={{ transform:"rotate(360deg)"}}>
          <path d="M10 21h4a2 2 0 0 1-2 2a2 2 0 0 1-2-2m11-2v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6l2 2m-4-8a5 5 0 0 0-5-5a5 5 0 0 0-5 5v7h10v-7m2.75-7.81l-1.42 1.42A8.982 8.982 0 0 1 21 11h2c0-2.93-1.16-5.75-3.25-7.81M1 11h2c0-2.4.96-4.7 2.67-6.39L4.25 3.19A10.96 10.96 0 0 0 1 11z" 
                fill="currentColor"/>
        </symbol>
        <symbol id="bell-ring" viewBox="0 0 24 24" style={{ transform:"rotate(360deg)"}}>
          <path d="M21 19v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6l2 2m-7 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m9.75-17.81l-1.42 1.42A8.982 8.982 0 0 1 21 11h2c0-2.93-1.16-5.75-3.25-7.81M1 11h2c0-2.4.96-4.7 2.67-6.39L4.25 3.19A10.96 10.96 0 0 0 1 11z" 
                fill="currentColor"/>
        </symbol>
        <symbol id="pin" viewBox="0 0 24 24" style={{ transform:"rotate(360deg)"}}>
          <path d="M19 17c0-2.038-1.188-3.836-3-4.92V5h.5a1.5 1.5 0 0 0 0-3h-9a1.5 1.5 0 0 0 0 3H8v7.08C6.188 13.164 5 14.962 5 17h6v4c0 .55.45 1 1 1s1-.45 1-1v-4h6z" 
                fill="currentColor"/>    
        </symbol>
      </svg>
    )
  }
};

export class Restrict extends React.Component {
  render() {
    if (this.props.to && UserSettings.memberOf( this.props.to ) ) {
      return <div style={{"display":"inline"}}>{this.props.children}</div>
    }
    return <noscript/>;
  }
};

export class ModalTitle extends React.Component {
  render() {

    var style  =  this.props.style ? this.props.style :{} ;
    if (this.props.noAutoClose) {
       var closeIcon =
          <button type="button" className="close" aria-hidden="true"
                  onClick={this.props.handleClose}>x</button>                            
    } else {
       var closeIcon =
          <button type="button" className="close" data-dismiss="modal" aria-hidden="true"
                  onClick={this.props.handleClose}>x</button>                            
    }

    if (this.props.hideClose) {
        closeIcon = null;
    }
     
    return (
      <div className="modal-header">
        {closeIcon}
        <img id="spinningIcon" src= {spinning_small} height="20" width="20"
             style={{ display: "none", margin: "4px 20px", float: "right"  }}/>
        <h3 className="modal-title" style={style}>
         {this.props.children}
        </h3>
      </div>
    )
  }
};
class HdrFlags extends React.Component {
  render() {
    if (this.props.myorder == 'Y') {
      return (
        <div className="badge badge-red badge-hdr">Critical Deal</div>
      );
    } else {
      return ( <span> </span> );
    }
  }
};

export class ModalBody extends React.Component {
  render() {
    var h = 590;
    if (this.props.maxHeight) {
      h = window.innerHeight - 165;
    }
    if (this.props.height) {
      h = this.props.height;
    }
    h = h + 'px';
    return (
      <div className="modal-body" style={{ "minHeight": h,  "maxHeight": "77vh" }}>
        {this.props.children}
      </div>
    )
  }
};

export class ModalFooter extends React.Component {
  render() {
    return (
      <div className="modal-footer">
        {this.props.children}
      </div>
   )
  }
};

export class Modal extends React.Component {
  render() {
    var width = "940px";
    if (this.props.width) {
      width = this.props.width
    }
    return(
      <div className="modal" id={this.props.id} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" style={{ MinWidth: width,"width":"95%" }} >
          <div className="modal-content">
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
};

export class ModalWithClose extends React.Component {
  render() {
    var width = "940px";
    if (this.props.width) {
      width = this.props.width
    }
    var styles = {
        marginRight: "-15px"
    }
    if (this.props.show) {
        styles.display = "block";
    }
    if (this.props.top) {
        styles.top = this.props.top;
    }
    var buttonsTmpl;
    // Check if footer buttons are specified and render those
    // else proceed with close button rendering
    if(typeof this.props.footerButtons !== "undefined" ) {
      buttonsTmpl = this.props.footerButtons.map(function(eachButton, i) {
        var btnContent;
        if (eachButton.autoClose != undefined && eachButton.autoClose == false) {
          btnContent = <button className={eachButton.className}
                         onClick={eachButton.onClick}>{eachButton.buttonText}</button>
        } else {
          btnContent = <button className={eachButton.className}
                         onClick={eachButton.onClick}>{eachButton.buttonText}</button>
        }
        if (eachButton.restrictTo != undefined) {
          btnContent = <Restrict to={eachButton.restrictTo}>{btnContent}</Restrict>
        }
        console.log('Restricting buttons', btnContent);
        return btnContent;
      });
    } else {
      buttonsTmpl = <button className="btn btn-primary" data-dismiss="modal" 
                            onClick={this.props.handleClose}>{this.props.closeButtonText}</button>
    }
    return(
      <div className="modal" id={this.props.id} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style={styles}>
        <div className="modal-dialog modal-lg" style={{ width: width }} >
          <div className="modal-content">
            {this.props.children}
            <ModalFooter>
              {buttonsTmpl}
            </ModalFooter>
          </div>
        </div>
      </div>
    )
  }
};


var handleCloseModal = function() {
  window.parent.postMessage('hp_close_orderstatus_widget', '*');
}

export class ModalWidgetWaiting extends React.Component {

  render() {

    var width = "940px";
    if (this.props.width) {
      width = this.props.width;
    }
    var size = "large";
    var spinningGif = spinning_large;
    if (this.props.size) {
      size = this.props.size;
      switch (size) {
        case "large" :
          width="940px"; break;
        case "medium":
          width="620px"; break;
        case "small" :
          width="310px"; spinningGif = spinning_small; break;
      }
    }
    return (
      <ModalWithClose id="ossOrderModal" handleClose={handleCloseModal} closeButtonText={T('Close')} width={width}>

        <ModalTitle handleClose={handleCloseModal}>
          <L>Loading ...</L>
        </ModalTitle>

        <ModalBody>
          <div id="errorPane" style={{ display: "none", position: "relative" }}>
            <div id="errorPaneText" className="alert alert-danger errorPaneWidget"
                 role="alert">
              error text
            </div>
          </div>
          <img src={spinningGif} style={{ "marginLeft": "50%",  "marginTop":"250px"}}/>
        </ModalBody>

      </ModalWithClose>
    );
  }
};

export class Tab extends React.Component {
  render() {
    return (
      <li><a href={'#'+this.props.name} onClick={this.props.onClick} data-toggle="tab">{this.props.label}</a></li>
    )
  }
};

export class Progress extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var widthString = Math.round(this.props.value,2) + "%";
    var width = { width: widthString};

    return (
      <div className="progress">
        <div className="progress-bar" role="progressbar" aria-valuenow={this.props.value} aria-valuemin="0" aria-valuemax="100" style={width} ></div>
      </div>
    )
  }
};

export class TabBar extends React.Component {

  // this code should be rewritten completely as it overwrites the Tab component above
  // out of convenience i modify it now, and hope the change can be done soon.
  // TODO
  constructor(props) {
      super(props);
      this.handleHdrToggle     = this.handleHdrToggle.bind(this);
    }
    handleHdrToggle(e) {
        let sid     = "#"+this.props.id;
        let current = document.querySelector(sid);
        let oelem   = current.nextElementSibling;
        let elem    = e.target;

        if(elem.className.match("up")) {
          elem.className = elem.className.replace("up","down");
          oelem.style.display = "none";
        } else {
          elem.className = elem.className.replace("down","up");
          oelem.style.display = "block";
        }
        setTimeout( function() {
                var event = document.createEvent('HTMLEvents');
                event.initEvent('resize', true, false);
                window.dispatchEvent(event);
        }, 200);
    }
    render() {
      var toggleHTML = "";
      if(this.props.toggle) {
        let title  =  this.props.title ? this.props.title : "" ;
        let style  =  this.props.style ? this.props.style :{} ;
        toggleHTML = <div className={this.props.class}  title={title} style={style} onClick={this.handleHdrToggle}></div> ;

      }
      if (Array.isArray(this.props.children)) {
         var tabs = this.props.children;
      } else {
         var tabs = [ this.props.children ];
      }

      var tabSwitchers = tabs.map(function(tab) {

        if (!tab || tab.props == undefined) return "";

        if (tab.props.activeTab == tab.props.name) {
          var classString = 'active';
        }

        if (tab.props.activeTab == undefined) {
          var classString = tab.props.active ? 'active' : '';
        }

        if (typeof tab.props.disabled != "undefined" && tab.props.disabled) {
          classString = classString + ' disabledPrice';
        }

        var onClick = function(ev) {
            var ret = 0;
            if (tab.props.onClick) {
                ret = tab.props.onClick(ev);
            }
            // force a window resize event in order to trigger an
            // auto-re-alignment of other components (like SimpleDataGrid)
            setTimeout( function() {
                var event = document.createEvent('HTMLEvents');
                event.initEvent('resize', true, false);
                window.dispatchEvent(event);
            }, 200);
            return ret;            
        } 

        if (tab.props.badgeColor && tab.props.amount) {

          var badge = "badge badge-" + tab.props.badgeColor;

          var label = (
            <span>
              { typeof tab.props.label === 'string' ? T(tab.props.label) : tab.props.label }
              <div className={badge}>{tab.props.amount}</div>
            </span>      
          );

          return (
            <li key={tab.props.name} className={classString}><a href={'#'+tab.props.name} onClick={onClick} data-toggle="tab">{label}</a></li>
           )

        } else {
          return (
            <li key={tab.props.name} className={classString}><a href={'#'+tab.props.name} onClick={onClick} data-toggle="tab">{tab.props.label}</a></li>
           )
        }



      });

      var tabContents = tabs.map(function(tab) {

        if (!tab || tab.props == undefined) return "";

        if (tab.props.activeTab == tab.props.name) {
          var classString = 'tab-pane active';
        } else {
          var classString = 'tab-pane';
        }

        if (tab.props.activeTab == undefined) {
          var classString = tab.props.active ? 'tab-pane active' : 'tab-pane';
        }

        return (
         <div className={classString} key={tab.props.name} id={tab.props.name}>
           {tab.props.children}
         </div>
        )

      });

      return (
        <div>
          {toggleHTML}
          <ul key={this.props.id} id={this.props.id} className="nav nav-tabs">
            {tabSwitchers}
            {/* Optional extension slot for caller-provided content appended after the default items. */}
            {this.props.afterLastTab ? this.props.afterLastTab : null}
          </ul>
          <div className="tab-content" >
            {tabContents}
          </div>
        </div>
      )
  }

};


export class TimeAgo extends React.Component {

  render() {

    var t   = new Date(this.props.time);
    var now = new Date();

    var msPerMinute = 60 * 1000;
    var msPerHour   = msPerMinute * 60;
    var msPerDay    = msPerHour * 24;
    var msPerMonth  = msPerDay * 30;
    var msPerYear   = msPerDay * 365;

    var elapsed = now - t;
    var ago = t.toGMTString();

    var approx = 'approximately ';
    if (this.props.short) {
      approx = '';
    }

    if (elapsed < msPerMinute) { ago = 'few seconds ago';
    } else
    if (elapsed < msPerHour  ) { ago = Math.round(elapsed/msPerMinute) + ' minutes ago';
    } else
    if (elapsed < msPerDay   ) { ago = Math.round(elapsed/msPerHour ) + ' hours ago';
    } else
    if (elapsed < msPerMonth ) { ago = approx + Math.round(elapsed/msPerDay)+ ' days ago';
    } else
    if (elapsed < msPerYear )  { ago = approx + Math.round(elapsed/msPerMonth)+ ' months ago';
    } else                     { ago = approx + Math.round(elapsed/msPerYear )+ ' years ago';
    }
    return <abbr className="timeago" title={t.toGMTString()}>{ago}</abbr>
  }
};



export class LabelGrid extends React.Component {

  constructor(props) {
    super(props);
    this.labelGridRef = React.createRef();
  }

  componentDidMount() {

    var labelgrid = this.labelGridRef.current;
    var tds = labelgrid.getElementsByTagName('td');
    for (var i=0; i < tds.length; i++) {
        tds[i].onmouseenter = function () {
            this.previousSibling.classList.add('hover');                 
        }         
        tds[i].onmouseleave = function () {
            this.previousSibling.classList.remove('hover');                 
        }         
    }
  }

  render() {
    var diffMode = this.props.diffMode || false;
    var fixedSize = this.props.fixedSize || false;
    
    var rows = this.props.data.map((rowData, r) => {

      if (diffMode) {
        let rowElements = [];

        for (let i = 0; i < rowData.length; i += 3) {
          const fieldName = rowData[i];
          const newValue = rowData[i + 1];
          const oldValue = rowData[i + 2];
    
          rowElements.push(
            <th key={`${r}-${i}`}>
              {typeof fieldName === "string" ? `${fieldName}:` : <DDLabel field={fieldName} />}
            </th>,
            <td key={`${r}-${i + 1}`} style={{ backgroundColor: "lightgreen" }}>
              {typeof oldValue === 'object' ? JSON.stringify(newValue) : newValue}
            </td>,
            <td key={`${r}-${i + 2}`}> {typeof oldValue === 'object' ? JSON.stringify(oldValue) : oldValue}</td>
          );
        }

        return <tr key={r}>{rowElements}</tr>;
        
      } else {

        var row = rowData.map(function(elem, i) {

          if (i%2) {
            if (elem == '') return (<td key={i}></td>);
            return (<td key={i}>{elem}</td>);
          }
          else {
            if (elem) {
              if (typeof elem === 'string') {
                return (<th key={i}>{elem}:</th>);
              } else {
                return (<th key={i}><DDLabel field={elem} /></th>);
              }
            } else {
              return (<th key={i}>{elem}</th>);
            }
          }
        })
    
        return <tr key={r}>{row}</tr>;
      }
    
    });

    return (
      <div className="hdrGridContainer">
        <table
          className="hdrGrid"
          ref={this.labelGridRef}
          style={fixedSize ? { tableLayout: 'fixed', width: '100%' } : {}}
        >
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    )
  }

};

function SimpleDataGrid_HandleToggleAll(e)
{
  var sid  = "#multiShipToOrders";
  var elem = e.target;

  document.querySelectorAll(sid).forEach(function(item) {
    if( ( elem.className.match("down") && item.children[0].className.match("up") ) ||
        ( elem.className.match("up")   && item.children[0].className.match("down") )
      )
      {
        item.click();
      }
  });
  elem.className = (elem.className.match("up") ? elem.className.replace("up","down") :elem.className.replace("down","up"));
}

function fadeColumns(pCols,cCols,colOpts,init) {
    var copy = 1 ;
    let nColOp    = JSON.parse(JSON.stringify(colOpts));
    let origColOp = JSON.parse(JSON.stringify(colOpts));
    for(var p=init ; p < pCols.length ; p++) {
        if( pCols[p] == cCols[p] ) {
            nColOp[p]['color']='#c6c2c2';
        } else {
            copy = 0;
            break;
        }
    }

   var ret =  copy ?  nColOp : origColOp ;
   return ret ;
}

function SimpleDataGrid_HandleToggle(nrRows, evt)
{
    var tr = $( evt.target ).closest( "tr" );


    var g = tr.find("i.glyphicon");
    if (g.hasClass('glyphicon-chevron-up')) {
      g.removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
      for (var i=0; i < nrRows; i++) {
        tr = tr.next();
        tr.find("td i.glyphicon").removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
        tr.hide();
      }
    } else {
      g.removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
      for (var i=0; i < nrRows; i++) {
        tr = tr.next();
        tr.find("td i.glyphicon").removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
        tr.show();
      }
    }
    // force a window resize event in order to trigger an
    // auto-re-alignment of other components (like SimpleDataGrid)
    setTimeout( function() {
        var event = document.createEvent('HTMLEvents');
        event.initEvent('resize', true, false);
        window.dispatchEvent(event);
    }, 200);

}

export function SimpleDataGrid_formatRow(showBundleGroup, showCollapse, nesting, nrRowsToCollapse, colOpts, row, item_subitem, colHeader, order, expandedByDefault)
{
  if (showBundleGroup && showCollapse) {
    setTimeout( function() {
      $('#_table tr td:first-child').each(function(){
        if ($(this).text() == item_subitem) {
          $(this).parent('tr').addClass("tableRowHighlight");
        } else {
          $(this).parent('tr').addClass("rowHover");
        }
      });
    }, 100);

    if (row.main) {


    } else {

      return row.map(function(cell, i) {
        if (i==0) {
          return ( <td key={i} style={colOpts[i]} className={"simpleDataGridBundleCollapse"+nesting}
                       onClick={SimpleDataGrid_HandleToggle.bind(null,nrRowsToCollapse)}
                   >
                      {cell}&nbsp;
                      <i style={{ "color": "#0096d6", "fontSize": "10px"}} className="glyphicon glyphicon-chevron-down"/>
                   </td>
                 );
        }
        return ( <td key={i} style={colOpts[i]}>{cell}</td> );
      });
    }
  } else
    setTimeout( function() {
      $('#_table tr td:first-child').each(function(){
        if ($(this).text() == item_subitem) {
          $(this).parent('tr').addClass("tableRowHighlight");
        } else {
          $(this).parent('tr').addClass("rowHover");
        }
      });
    }, 100);
  if (showBundleGroup && !showCollapse) {


    if (row.main) {
      
    } else {
     
      return row.map(function(cell, i) {
        if (i==0) {
          return ( <td key={i} style={colOpts[i]} className={"simpleDataGridBundle"+nesting}>{cell}</td> );
        }
        return ( <td key={i} style={colOpts[i]}>{cell}</td> );
      });
      
    }

  } else
     setTimeout( function() {
      $('#_table tr td:first-child').each(function(){
        if ((typeof $(this).text() != 'undefined') && ($(this).text()).trim() == item_subitem) {
          $(this).parent('tr').addClass("tableRowHighlight");
        } else {
          $(this).parent('tr').addClass("rowHover");
        }
      });
    }, 100);

  if (!showBundleGroup && showCollapse) {

    if (row.main) {
  
    } else {

      return row.map(function(cell, i) {
        if (i==0) {
          return ( <td key={i} style={colOpts[i]} className={"simpleDataGridCollapse"+nesting}
                       onClick={SimpleDataGrid_HandleToggle.bind(null,nrRowsToCollapse)}
                   >
                    {cell}&nbsp;
                    <i style={{ "color": "#0096d6", "fontSize": "10px"}} className={"glyphicon " + (expandedByDefault ? "glyphicon-chevron-up": "glyphicon-chevron-down")}/>
                   </td> );
        }
        return ( <td key={i} style={colOpts[i]}>{cell}</td> );
      });
    }

  } else {

    if (row.main) {
      
    } else {
      return row.map(function(cell, i, activeRow) {
        if (i==0) {
          return ( <td key={i} style={colOpts[i]} className={"simpleDataGridNothing"+nesting}>{cell}</td> );
        }
        return ( <td key={i} style={colOpts[i]}>{cell}</td> );
      });
    }
  }
}

function SimpleDataGrid_DeepLength (row)
{
  var rows = 0;
  if (row.akey != undefined) {
    row.children.map(function( child, childPos ) {
        rows += 1+SimpleDataGrid_DeepLength (child);
    });
  } else
  if (row.group != undefined) {
    row.children.map(function( child, childPos ) {
        rows += 1+SimpleDataGrid_DeepLength (child);
    });
  } else
  if (row.main) {
    rows += row.children.length;
    row.children.map(function( grandchild ) {
        if (grandchild.main) {
            rows += grandchild.children.length;
        }
    });

  } else {
    rows += 0;
  }
  return rows;
}

function  getBaseUrl() {
    return typeof GlobalUserSettings != 'undefined'
      ? GlobalUserSettings.config.links.LegacyIntURL.replace(/\/os\/.+/,'')
      : ''
}

export function getCompleteURL(config) {
  let url = "" ;
  if( !(config.lookupType && config.lookupValue )) return "";

  switch(config.type) {
      case "ext"   :
                      url = getBaseUrl() + "/os/osWidgetWrapper.html?lookupType=" + config.lookupType + "&lookupValue=" + config.lookupValue + "&session=" + sessionId;
                      break;
      case "int"   :
                      url = getBaseUrl() + "/static/dist/osWidgetWrapperInt.html?lookupType=" + config.lookupType + "&lookupValue=" + config.lookupValue ;
                      break;
      case "osv"   :
      default      :
                      url = getBaseUrl() + "/static/dist/OrderStatusViewer.html?lookupType=" + config.lookupType + "&lookupValue=" + config.lookupValue ;
  }
  return url;
}

function GetInnerText(el) 
{
    //console.log("GetInnerText", el);

    if (typeof el == "string") return el;
    if (typeof el == "undefined") { return el };
    var str = "";
    
    var cs = el.childNodes;
    var l = cs.length;
    for (var i = 0; i < l; i++) {
      switch (cs[i].nodeType) {
        case 1: // ELEMENT_NODE
            //console.log("node", cs[i].nodeName );   
            if (!(
                  (cs[i].nodeName == "SPAN" && cs[i].className == "dd-label-popup")
               || (cs[i].nodeName == "SPAN" && cs[i].className == "mouseover-popup-content")
               || (cs[i].nodeName == "SPAN" && cs[i].className.match(/texticon-info/))
               || (cs[i].nodeName == "SPAN" && cs[i].className.match(/texticon-success/))
            )) {
                if (cs[i].nodeName == "SPAN" && cs[i].className.match(/redbold/)) {
                    str += "<span style='color:red;font-weight:700;'>"+GetInnerText(cs[i])+"</span>"
                } else {
                    str += GetInnerText(cs[i]);
                }
            }
            // console.log("  str='"+str+"'"); 
            if (str == '' && cs[i].childNodes.length==0) {
               if (cs[i].nodeName == 'IMG') {
                    if (cs[i].getAttribute('label')) {
                        str = cs[i].getAttribute('label');
                    }
                }
            }
            break;
        case 3: // TEXT_NODE
            str += cs[i].nodeValue;
            break;
      }
    }
    return str;
}    





/*----------------------------------------------------------------------------
|   SimpleDataGrid
|
|
|   properties:
|
|   header={this.state.shipmentData.header}
|   data={this.state.shipmentData.data}    
|   downloadName='foobar'
|
|   optional:
|   enableDownload={true}
|   sortable={true}
|   leftLabel="Label to show on left side"
|   actions={actions}
|       either a single action:
|       { 
|          label: '...',
|          href:  urlString
|          ?target: "_blank"?
|       }
|
|       or a longer menu:
|       {
|
|           label: "foo Bar",
|           menu: [ { label: "...",
|                      href: urlString,
|                      ?target: "_blank"?
|                   or action: callback
|                   }, 
|                   { label: "Download all shipment details",
|                     href: exportShipmentXLURL             
|                     ?target: "_blank"?
|                  or action: callback 
|                   }                          
|           ]
|       }  
|
|
\---------------------------------------------------------------------------*/
export class SimpleDataGrid extends React.Component {

  constructor(props) {
    super(props);

    // https://reactjs.org/docs/components-and-props.html#props-are-read-only
    //this.props.doUpdate = true;

    this.state = {
      filterStr: this.props.filterStr  ? this.props.filterStr : '',
      doUpdate: this.props.doUpdate,
      showCustomizeModal: false,
      data: this.props.data,
    };
    this.handleFilterChange   = this.handleFilterChange.bind(this);
    this.handleDownloadAsShown = this.handleDownloadAsShown.bind(this);
    this.showModal            = this.showModal.bind(this);
    this.handleCustomizeFieldsCancel = this.handleCustomizeFieldsCancel.bind(this);
    this.handleCustomizeFieldsChange = this.handleCustomizeFieldsChange.bind(this);
    this.gridRef = React.createRef();
    this.handlefilter      = this.handlefilter.bind(this);
    this.handleSearchReset = this.handleSearchReset.bind(this);
  };

  handleDownloadAsShown() {
    var c = this.gridRef.current;
    var t = c.querySelectorAll(".grid-container-table")[0];
    DownloadTableAsShownXLSX ( t, this.props.downloadName );
  }
  
  adjustHeader(c, invokes ) {

    if (invokes === undefined) invokes = 0;
    //console.log("adjustHeader: invokes=",invokes);
    var frozenDiv = c.querySelectorAll(".frozen-grid-header")[0];
    if (frozenDiv.hasChildNodes() ) {
        if (invokes == -1) { 
            while (frozenDiv.firstChild) {
                frozenDiv.removeChild(frozenDiv.lastChild);
            }
        } else {
            // already created the second table header
            return; 
        }
    }
    
    var t = c.querySelectorAll(".grid-container-table")[0];
    var head = t.querySelectorAll("thead")[0];
    var nt = document.createElement("table");
    nt.className = t.className;
    nt.classList.remove("grid-container-table");
    nt.classList.remove("sortable");
    nt.style["margin-bottom"] = '0px';
    //nt.classList.add("table");
    //nt.classList.add("table-hover");

    //Veracode Sanitize all th within thead
    var clonedHead = head.cloneNode(true);
    var clonedHeaders = clonedHead.querySelectorAll('th');
    clonedHeaders.forEach(function(header) {
      if (!header.querySelector('.dd-label')) { 
        // Only sanitize headers that are pure text or simple HTML
        var originalText = header.innerHTML;
        header.innerHTML = DOMPurify.sanitize(originalText);
      }
    });
    nt.appendChild(clonedHead);

    if (t.classList.contains("sortable")) {
        ts_makeSortable(nt);
        nt.classList.add("sortableFrozen");
    }
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        
    var el = head.querySelectorAll("tr th");  
    var hel = nt.querySelectorAll("tr th");  

    //console.log("adjustHeader:", el, hel);

    var hasAuto = 0 ;
    for (var i=0; i < el.length; i++) {
      //console.log('width: el ', i, el[i].offsetWidth, getComputedStyle(el[i]).width );
      var w = getComputedStyle(el[i]).width;
      if (w == "auto") {
         hasAuto = 1;
         break;
      }
      if (isIE11) {
        var w_no =  Math.round(parseFloat(w));
        hel[i].style["min-width"] = (w_no + 9) + 'px';
        hel[i].style["max-width"] = (w_no + 9) + 'px';
      } else {
        hel[i].style["min-width"] = (parseFloat(w) - 0) + 'px';
        hel[i].style["max-width"] = (parseFloat(w) - 0) + 'px';
      }   
    }
    frozenDiv.appendChild(nt);
    if (hasAuto) {
        console.log("adjustHeader delay");
        frozenDiv.removeChild(nt);
        var self = this;
        if (invokes != -1) {

            setTimeout( function() {
                // var clrect = c.getBoundingClientRect(); 
                // c.style.height = (window.innerHeight - clrect.top - 10) + 'px';
                self.adjustHeader(c, invokes+1 );
            }, 1000);
        }
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if ( this.props.wrapper == 'zmso' && ( prevProps.data !== this.props.data) ) {
      this.setState({ data : this.props.data });
    }
  }

  componentDidMount() {
    var c = this.gridRef.current;
    var self = this;
    c.addEventListener('scroll', function () {
      self.adjustHeader(c);
      var nt = c.querySelectorAll(".frozen-grid-header")[0];
      if (nt) {
        //console.log('scroll', c.scrollLeft, c.scrollTop);
        nt.style.top = c.scrollTop +'px';
      }                              
    });

    if (self.props.stretchTo && document.querySelectorAll(self.props.stretchTo).length > 0) {
        var sTo = document.querySelectorAll(self.props.stretchTo)[0];
        var sToRect = sTo.getBoundingClientRect();
        var clrect = c.getBoundingClientRect(); 
        var smargin = 1;
        if (self.props.stretchMargin) { 
            smargin = parseInt(self.props.stretchMargin);
        }
        c.style.height = (sToRect.top - clrect.top - smargin)  + 'px';
    }

    window.addEventListener('resize', function () {
      //console.log('window resize detected');
      if (self.props.stretchTo) {
          var sTo = document.querySelectorAll(self.props.stretchTo)[0];
          if (sTo) { 
              var sToRect = sTo.getBoundingClientRect();
              var clrect = c.getBoundingClientRect(); 
              var smargin = 1;
              if (self.props.stretchMargin) { 
                  smargin = parseInt(self.props.stretchMargin);
              }  
              c.style.height = (sToRect.top - clrect.top - smargin)  + 'px';
          }
      }
      setTimeout( function() {
          self.adjustHeader(c,-1);
      }, 330);
    });

    setTimeout( function() {
        console.log('delayed adjust via resize ...'); 
        // force a window resize event in order to trigger an
        // auto-re-alignment
        var event = document.createEvent('HTMLEvents');
        event.initEvent('resize', true, false);
        window.dispatchEvent(event);
    }, 500);

  } 

  handleFilterChange(event) {
    this.setState( { 
                      filterStr: event.target.value, 
                      doUpdate: true
                    } 
                  );  

    //this.props.doUpdate = true 
  }

  showModal(e) {
    this.setState({
      showFieldCustomization: true,
      title: e.currentTarget.textContent,
      actionType: e.currentTarget.value
    });
  };

  handleCustomizeFieldsChange(fields) {
    //console.log('handleCustomizeFieldsChange fields=',fields);

    this.setState({
      showFieldCustomization: false 
    });

    this.props.onChange(fields)

  }

  handleCustomizeFieldsCancel() {
    console.log('handleCustomizeFieldsCancel');
    this.setState({
        showFieldCustomization: false 
    });
  }

  setRowColor(row, i, val) {

    var statusIndex = (val && val.statusIndex && val.statusIndex != '') ? val.statusIndex : 4 ;

    // Design Flaw, this may need change if iActiveItems Component fields are individualized
    // as we expect elemtn 4 out of the row array to be always the item status
    if (!!row[statusIndex] && row[statusIndex] !== undefined && row[statusIndex] !== "") {
      if (typeof(row[statusIndex].props) == 'object') {
        if (["ShipmentCanceled", "CANCELED"].includes(row[statusIndex].props.field)){
          return "#ffeceb";
        }
      }
      if(["ShipmentCanceled", "CANCELED"].includes(row[statusIndex])) {
        return "#ffeceb";
      }
    }

    //Quick Fix and should be changed with new HOM (as prod localization is a dynamic field, status index is shifted )
    if (!!row[3] && row[3] !== undefined && row[3] !== "") {
      if (typeof(row[3].props) == 'object') {
        if (["ShipmentCanceled", "CANCELED"].includes(row[3].props.field)){
          return "#ffeceb";
        }
      }
      if(["ShipmentCanceled", "CANCELED"].includes(row[3])) {
        return "#ffeceb";
      }
    }

    if (val && val.dColor) {
      return val.dColor;
    }
    if ((i % 2) == 1) {
      return '#e6e6e6';
    }
    return "#ededed";
  }

/*  shouldComponentUpdate(nextProps, nextState) {

    //GEGA TODO! ASK JOLO!!
    // JOLO answered: no need to do this, as setState triggers the page rerendering and no hack like this needed anymore 
    if (this.state.doUpdate) {
      this.setState( {doUpdate: false }); 
      return true;
    }
    return false;

  }*/
  handlefilter(e) {
        var searchText  = $("#textbox-zmso-item-search").val() || "";
        var backupList  = this.props.data;
        var updatedList = {};

        if (searchText.length < minSearchChars ) {
            this.setState( { data: backupList } );
            return;
        }
        updatedList.data = backupList.filter( function(item) {
            if (searchText.length >= minSearchChars) {
                return  item.moreInfo.composed_value.toLowerCase().search(searchText.toLowerCase()) !== -1
            } else {
                return true;
            }
        });
        this.setState( { data: updatedList.data } );
  }
  handleSearchReset() {
    this.textboxSearch.value = "";
    this.handlefilter();
  }

  render() {

    var nrCols = this.props.header.length;
    var item_subitem = this.props.item_subitem;
    var headerObject = this.props.header;
    var orderObject = this.props.order;
    var expandedByDefault = this.props.expandedByDefault;
    var initialChildRowState = expandedByDefault ? 'table-row': 'none';
    var translationPrefix = this.props.translationPrefix;

    var id = ''

    if (this.props.id) {
        id = this.props.id;
    }

    var colOpts = [];
    var statusIndex = '';
    var header = this.props.header.map(function(col, i) {

       //console.log('SimpleDataGrid header:', i, col);
       if(!statusIndex) {
        statusIndex = (col && col.internalName && (col.internalName == "status" )) ? i: statusIndex;
        statusIndex = (col && col.name && col.name.dd_label && (col.name.dd_label == "status"))? i:statusIndex;
       }

       if (typeof col == 'string') {
         colOpts.push({ "whiteSpace": "nowrap" });
         return ( <th key={i}>{col}</th> )
       } else {
         var opt = {};
         if (col.ellipsis) { opt['overflow' ] = 'hidden';
                             opt['text-overflow' ] = 'ellipsis';
                           }
         if (col.width)    { opt['maxWidth' ] = col.width;
                             opt['width' ] = col.width;
                           }
         if (col.right)    { opt['textAlign' ] = 'right'; }
         if (1 || col.nowrap) { opt['whiteSpace'] = 'nowrap'; }
         if (col.wrap)     { opt['whiteSpace'] = 'normal'; }
         colOpts.push(opt);
         if (col.name) {
           if (typeof col.name === 'string') {
             return ( <th key={i}>{col.name}</th> )
           } else {
             return ( <th key={i}><DDLabel field={col.name} /></th> )
           }
         } else if (col.internalName) {
           return ( <th key={i}><DDLabel field={col.internalName} /></th> )
         }

       }
    });

    var filterDiv = null;

    if (this.props.filter) {
      filterDiv =
        <div style={{ "textAlign": "right", "backgroundColor": "#f0f0f0", "color": "#777", "padding": "5px"}} >
         filter: <input type="text" value={this.state.filterStr}
                        onChange={this.handleFilterChange} size="40"/>
        </div>

    }
    var filterStr = this.state.filterStr.toLowerCase();

    var tbody = [];
    var actionToggleAll = "";
    var searchList      = "";
  if( this.props.wrapper == 'zmso' ) {
    actionToggleAll =
           <span>
             <i className="tabbar-toggle tabbar-toggle-down" style={{position:"relative" ,lineHeight: "20px",left:"20px" }} title="Collapse / Expand Child Orders" onClick={SimpleDataGrid_HandleToggleAll.bind()} ></i>
           </span>

    searchList = <span style={{ "paddingLeft" : 40 }}>
                            <div className="btn-reset-x-container">
                                <input className="form-control" style={{width:'600px' , outline:'none' , borderColor:'#e8e8e8' , height:28 ,paddingLeft: "25px" ,  border: "1px solid #ccc",  borderRadius: "3px",  lineHeight: "2.2px" ,  color: "#555" }} id="textbox-zmso-item-search" type="text"
                                       placeholder={"Search item by Ship To Attention to Email (eg:my_name@domain.com) (Min. " + minSearchChars + " Chars)"}
                                       ref={input=> this.textboxSearch = input}
                                      onChange={this.handlefilter}/>
                                <span onClick={this.handleSearchReset} className="btn-reset-x" style={{ "height" : 26 , "lineHeight": '27px' }}>X</span>
                            </div>
                    </span>
    searchList = ""; // time being just hiding ,it may require in future
    for (var i=0; i < this.state.data.length; i++) {
      var row      = this.state.data[i];
      var nlength  = this.state.data[i].children.length;
      var akey     = row.akey;
      var bkey     = "";
      var submitRequestBtn  = null;
      let formattedAKey     = "";
      let formattedBKey     = "";
      let mso_color         = "" ;
      var span = nrCols;
      var tkCols = 4;
      if (span>4) {
        span = 2;
      }
      let url = getCompleteURL({
                                    lookupType  :"so_no",
                                    lookupValue : akey,
                                    type        : this.props.caller
                                });
      var nrRowsToCollapse = SimpleDataGrid_DeepLength(row)  ;

      bkey  = (row.moreInfo && row.moreInfo.composed_value ? row.moreInfo.composed_value :"" )

      if (row.moreInfo && row.moreInfo.type == "child_so_no" ) {
        formattedAKey = <span>
                          <a href={url} target="_blank" style={{ "textDecoration" : "none" }}>{akey} &nbsp; <i className='glyphicon glyphicon-new-window' title='click to open trade order'></i></a>
                            &nbsp;&nbsp;
                        </span>
        formattedBKey = <td colSpan={span} className="simpleDataGridGroupHeader">
                         <a href={url} target="_blank" style={{ "textDecoration" : "none" }}>{bkey} </a>
                        </td>
        //3W Button for external view only
        if ( this.props.caller == 'ext' &&
             this.props.myWidgetMode != 'public' &&
             row.moreInfo.zmso_details &&
             row.moreInfo.zmso_details != {} &&
             row.moreInfo.zmso_details.child_qtcuid &&
             row.moreInfo.zmso_details.child_qtcuid != "") {

          var zmso_details = row.moreInfo.zmso_details;
          var serviceURL   = this.props.order.serviceURL;
          serviceURL       = serviceURL.replace("_ORDERNO_" , row.moreInfo.zmso_details.child_qtcuid);
          zmso_details.serviceURL = serviceURL
          submitRequestBtn = <td colSpan={span}>
                              <span>
                                <InitSFDCWorkflow order={this.props.order} overwrite={zmso_details} locale={I18N.locale} isExternalWidget={true}/>
                              </span>
                             </td>
          tkCols+=span;
        }

        //No punch out for external
        if ( this.props.caller == 'ext') {
          formattedAKey = <span style={{ cursor:"auto" }}>{akey} &nbsp;&nbsp;</span>
          formattedBKey = <td colSpan={span} className="simpleDataGridGroupHeader" style={{ cursor:"auto" }}>{bkey}</td>
        }
      } else
      if (row.moreInfo && row.moreInfo.type == "ship_to_group_id" ) {
        akey          = row.moreInfo.zmso_details && row.moreInfo.zmso_details != {} && row.moreInfo.zmso_details.name1  ? row.moreInfo.zmso_details.name1 : "" ;
        bkey          = row.moreInfo.zmso_details && row.moreInfo.zmso_details != {} && row.moreInfo.zmso_details.email_address  ? row.moreInfo.zmso_details.email_address : "" ;
        mso_color     = '#fff9d9';
        formattedAKey = <span style={{ cursor:"auto" }}>{akey} &nbsp;&nbsp;</span>
        formattedBKey = <td colSpan={span} className="simpleDataGridGroupHeader" style={{ cursor:"auto" }}>{bkey}</td>
      } else {
        akey          = row.moreInfo && row.moreInfo.zmso_details && row.moreInfo.zmso_details != {} && row.moreInfo.zmso_details.name1  ? row.moreInfo.zmso_details.name1 : "" ;
        bkey          = row.moreInfo && row.moreInfo.zmso_details && row.moreInfo.zmso_details != {} && row.moreInfo.zmso_details.email_address  ? row.moreInfo.zmso_details.email_address : "" ;
        formattedAKey = <span style={{ cursor:"auto" }}>{akey} &nbsp;&nbsp;</span>
        mso_color     = '#fff9d9';
        formattedBKey = <td colSpan={span} className="simpleDataGridGroupHeader" style={{ cursor:"auto"}}>{bkey}</td>
      }
      var rowColorConfig = {dColor: mso_color , statusIndex: statusIndex};

      var groupCell = (
        <React.Fragment key="group">
        <td colSpan={span} className="simpleDataGridGroupHeader">
          {formattedAKey}
          <span onClick={SimpleDataGrid_HandleToggle.bind(null,nrRowsToCollapse)} id="multiShipToOrders">
                <i style={{ "color": "#0096d6", "fontSize": "10px"}}  className="glyphicon glyphicon-chevron-up"/>
          </span>
        </td>
          {formattedBKey}
          {submitRequestBtn}
        </React.Fragment>
        );
      var rowData = [groupCell];
      for (var j = 0; j < (nrCols -tkCols); j++) {
        rowData.push( <td key={"empty-" + j} style={{ "borderBottom": "1px solid #D6EBF6" }}>&nbsp;</td> );
      }
      var rowColor = this.setRowColor(row, i);
      tbody.push( <tr key={"row-" + tbody.length} className="simpleDataGridGroupHeader">{rowData}</tr> );

      for (var k=0; k < nlength; k++) {
        var rowColor = '#ededed';
        if ((i % 2) == 1) {
            rowColor = '#e6e6e6';
        }
          row=this.state.data[i].children[k];

        if (row instanceof Array) {

          if (this.props.filter) {
            if (row[0].toLowerCase().indexOf(filterStr) < 0) {
              continue;
            }
          }
          rowColor = this.setRowColor(row, k,rowColorConfig);
          tbody.push( <tr key={"row-" + tbody.length} style={{ backgroundColor:rowColor}}>{SimpleDataGrid_formatRow( false, false, 0, 0, colOpts, row, item_subitem, headerObject, orderObject)}</tr> );

        } else
        if (row.group != undefined) {
            // -- format a group header line ..........
            var span = nrCols;
            if (span>4) {
              span = 4;
            }
            var nrRowsToCollapse = SimpleDataGrid_DeepLength(row);
            var groupCell = (
              <td key="group" colSpan={span} className="simpleDataGridBundleHeader"
                  onClick={SimpleDataGrid_HandleToggle.bind(null,nrRowsToCollapse)}
              >
                {row.group}&nbsp;
                      <i style={{ "color": "#0096d6", "fontSize": "10px"}} className="glyphicon glyphicon-chevron-up"/>
              </td>
            );
            var rowData = [groupCell];
            for (var j = 0; j < (nrCols -4); j++) {
              rowData.push( <td key={"empty-" + j} style={{ "borderBottom": "1px solid #D6EBF6" }}>&nbsp;</td> );
            }
            tbody.push( <tr key={"row-" + tbody.length} style={{ backgroundColor:rowColor}}>{rowData}</tr> );

            // -- now output all row which are children of the group
            var self = this;
            row.children.map(function( child, childPos ) {

              if (child.main) {
                nrRowsToCollapse = SimpleDataGrid_DeepLength(child);
                rowColor = self.setRowColor(child.main,0,rowColorConfig);
                tbody.push( <tr key={"row-" + tbody.length} style={{ backgroundColor:rowColor}}>{SimpleDataGrid_formatRow(true, true, 0, nrRowsToCollapse, colOpts, child.main,item_subitem, headerObject, orderObject)}</tr> );
                child.children.map(function( grandchild ) {

                    if (grandchild.main) {
                      rowColor = self.setRowColor(grandchild.children,0,rowColorConfig);
                      tbody.push( <tr key={"row-" + tbody.length} style={{display: 'none', backgroundColor:rowColor}}>{SimpleDataGrid_formatRow(true, true, 10, grandchild.children.length, colOpts, grandchild.main, item_subitem, headerObject, orderObject)}</tr> );

                      grandchild.children.map(function( subChild ) {
                        rowColor = self.setRowColor(subChild,0,rowColorConfig);
                        tbody.push( <tr key={"row-" + tbody.length} style={{display: 'none', backgroundColor:rowColor}}>{SimpleDataGrid_formatRow(true, false, 20, 0, colOpts, subChild,item_subitem, headerObject, orderObject)}</tr> );
                      });

                    } else {
                      rowColor = self.setRowColor(grandchild,0,rowColorConfig);
                      tbody.push( <tr key={"row-" + tbody.length} style={{display: 'none', backgroundColor:rowColor}}>{SimpleDataGrid_formatRow(true, false, 10, 0, colOpts, grandchild,item_subitem, headerObject, orderObject)}</tr> );
                    }

                });
               } else {
                 rowColor = self.setRowColor(child,0,rowColorConfig);
                 tbody.push( <tr key={"row-" + tbody.length} style={{ backgroundColor:rowColor}}>{SimpleDataGrid_formatRow(true, false, 0, 0, colOpts, child,item_subitem, headerObject, orderObject)}</tr> );
               }
            });

        } else

        if (row.main) {
          rowColor = this.setRowColor(row.main,0,rowColorConfig);
          tbody.push( <tr key={"row-" + tbody.length} style={{ backgroundColor:rowColor}}>{SimpleDataGrid_formatRow( false, true, 0, row.children.length, colOpts, row.main,item_subitem, headerObject, orderObject, expandedByDefault)}</tr> );
          var self = this;
          row.children.map(function( child ) {
             rowColor = self.setRowColor(child,0,rowColorConfig);
             tbody.push( <tr key={"row-" + tbody.length} style={{display: initialChildRowState, backgroundColor:rowColor}}>{SimpleDataGrid_formatRow( false, false, 10, 0, colOpts, child,item_subitem, headerObject, orderObject)}</tr> );
          });
        }
      }
    }
  } else {

    for (var i=0; i < this.props.data.length; i++) {
      var row = this.props.data[i];
      
      
      var rowColor = '#ededed';
      if ((i % 2) == 1) {
          rowColor = '#e6e6e6';
      }
      if (row instanceof Array) {

        if (this.props.filter) {
          if (row[0].toLowerCase().indexOf(filterStr) < 0) {
            continue;
          }
        }
        var nColOpts = (i > 0 && this.props.fadable ) ? fadeColumns(this.props.data[i-1],this.props.data[i],colOpts,this.props.fadable) : colOpts ;
        rowColor = this.setRowColor(row, i);
        tbody.push( <tr key={"row-" + tbody.length} style={{ backgroundColor:rowColor}}>{SimpleDataGrid_formatRow( false, false, 0, 0, nColOpts, row, item_subitem, headerObject, orderObject)}</tr> );

      } else
      if (row.group != undefined) {
          // -- format a group header line ..........
          var span = nrCols;
          if (span>4) {
            span = 4;
          }
          var nrRowsToCollapse = SimpleDataGrid_DeepLength(row);
          var groupCell = (
            <td key="group" colSpan={span} className="simpleDataGridBundleHeader"
                onClick={SimpleDataGrid_HandleToggle.bind(null,nrRowsToCollapse)}
            >
              {row.group}&nbsp;
                    <i style={{ "color": "#0096d6", "fontSize": "10px"}} className="glyphicon glyphicon-chevron-up"/>
            </td>
          );
          var rowData = [groupCell];
          for (var j = 0; j < (nrCols -4); j++) {
            rowData.push( <td key={"empty-" + j} style={{ "borderBottom": "1px solid #D6EBF6" }}>&nbsp;</td> );
          }
          tbody.push( <tr key={"row-" + tbody.length} style={{ backgroundColor:rowColor}}>{rowData}</tr> );

          // -- now output all row which are children of the group
          var self = this;
          row.children.map(function( child, childPos ) {

            if (child.main) {
              nrRowsToCollapse = SimpleDataGrid_DeepLength(child);
              rowColor = self.setRowColor(child.main);
              tbody.push( <tr key={"row-" + tbody.length} style={{ backgroundColor:rowColor}}>{SimpleDataGrid_formatRow(true, true, 0, nrRowsToCollapse, colOpts, child.main,item_subitem, headerObject, orderObject)}</tr> );
              child.children.map(function( grandchild ) {

                  if (grandchild.main) {
                    rowColor = self.setRowColor(grandchild.main);
                    tbody.push( <tr key={"row-" + tbody.length} style={{display: 'none', backgroundColor:rowColor}}>{SimpleDataGrid_formatRow(true, true, 10, grandchild.children.length, colOpts, grandchild.main, item_subitem, headerObject, orderObject)}</tr> );

                    grandchild.children.map(function( subChild ) {
                      rowColor = self.setRowColor(subChild);
                      tbody.push( <tr key={"row-" + tbody.length} style={{display: 'none', backgroundColor:rowColor}}>{SimpleDataGrid_formatRow(true, false, 20, 0, colOpts, subChild,item_subitem, headerObject, orderObject)}</tr> );
                    });

                  } else {
                    rowColor = self.setRowColor(grandchild);
                    tbody.push( <tr key={"row-" + tbody.length} style={{display: 'none', backgroundColor:rowColor}}>{SimpleDataGrid_formatRow(true, false, 10, 0, colOpts, grandchild,item_subitem, headerObject, orderObject)}</tr> );
                  }

              });
             } else {
               rowColor = self.setRowColor(child);
               tbody.push( <tr key={"row-" + tbody.length} style={{ backgroundColor:rowColor}}>{SimpleDataGrid_formatRow(true, false, 0, 0, colOpts, child,item_subitem, headerObject, orderObject)}</tr> );
             }
          });

      } else

      if (row.main) {
        rowColor = this.setRowColor(row.main);
        tbody.push( <tr key={"row-" + tbody.length} style={{ backgroundColor:rowColor}}>{SimpleDataGrid_formatRow( false, true, 0, row.children.length, colOpts, row.main,item_subitem, headerObject, orderObject, expandedByDefault)}</tr> );
        var self = this;
        row.children.map(function( child ) {
           rowColor = self.setRowColor(child);
           tbody.push( <tr key={"row-" + tbody.length} style={{display: initialChildRowState, backgroundColor:rowColor}}>{SimpleDataGrid_formatRow( false, false, 10, 0, colOpts, child,item_subitem, headerObject, orderObject)}</tr> );
        });
      }
    }
  }

    var exportDiv = null;

    if (this.props.exportexcelreq) {
      exportDiv = <ExportExcel exportexcelreq={this.props.exportexcelreq}/>;
    }

    var specialStyle = {};
    if (this.props.width) {
      specialStyle.width = this.props.width;
    }

    var outerStyle = {
      position: "relative",
      minHeight: "130px",
      width:    "100%",
      padding:  "0px",
      margin:   "0px",
      border:   "1px solid #ccc",
      overflow: "auto",
      scroll:   "auto"
    }
    var frozenStyle = {
      backgroundColor: "#ffffff",
      position: "absolute",
      padding:  "0px",
      margin:   "0px",
      width:    "100%",
      zIndex:   "99"
    }
 
    if (this.props.height && this.props.height > 0) {
      outerStyle.height = this.props.height;
    }

    if (this.props.minHeight) {
      outerStyle.minHeight = this.props.minHeight;
    }

    if (this.props.bgColor) {
      outerStyle["backgroundColor"] = this.props.bgColor;
    }

    if (this.props.border) {
      outerStyle.border = this.props.border;
    }

    var actions = this.props.actions;


    var actionBar = null;

    if (this.props.enableDownload || actions != undefined) {
    
      var actionMenu = null;

      if (actions && actions.label && actions.menu && actions.menu.length > 0 ) {
        actionMenu = 
           <div className="btn-group navbar-right" style={{margin: "0px 5px"}}>
             <button type="button" className="btn btn-primary btn-sm dropdown-toggle" 
                    style={{padding: "0px 5px", "lineHeight": "16px", "fontSize":"13px"}} 
                    data-toggle="dropdown"
             >
                {actions.label}
                &nbsp;
                <i className="glyphicon glyphicon-circle-arrow-down"></i>
             </button>
             <ul className="dropdown-menu" role="menu">
               {actions.menu.map(function(m, i) {
                  if (m.action)
                    return <li key={i}><a style={{cursor: "pointer"}} onClick={m.action} >{m.label}</a></li>
                  else if (m.code) {
                    return m.code
                  }
                  else
                    return <li key={i}><a style={{cursor: "pointer"}} href={m.href} >{m.label}</a></li>
                })
               }
             </ul>
           </div>
          
      }  
    
      if (actions && actions.label && actions.action ) {
        actionMenu = 
           <span>
             {actions.label}
             &nbsp;                
             <i className="glyphicon glyphicon-circle-arrow-down" onClick={actions.action} ></i>
           </span>
          
      }  
      if (actions && actions.label && actions.href ) {
        if (actions.target) {
          actionMenu = 
             <span>
               {actions.label}
               &nbsp;                
               <a href={actions.href} target={actions.target} style={{color: "#fff"}}><i className="glyphicon glyphicon-circle-arrow-down"></i></a>
             </span>
        } else { 
          actionMenu = 
             <span>
               {actions.label}
               &nbsp;                
               <a href={actions.href} style={{color: "#fff"}}><i className="glyphicon glyphicon-circle-arrow-down"></i></a>
             </span>
        }          
      }  
    
      var customize = null;

      if (actions && actions.type == "customizeable") {
        customize =  <button type="button" onClick={this.showModal} className="btn btn-primary btn-sm dropdown-toggle" 
                        style={{padding: "0px 5px", "lineHeight": "16px", "fontSize":"13px"}} 
                        data-toggle="dropdown">              
                        {T('Customize Columns')}
                        &nbsp;
                        <i className="glyphicon glyphicon-cog"></i>
                      </button>
      }

      var itemSliceBox = null;
      if ( this.props.timeSliceSelector && this.props.timeSliceSelector.length > 0 ) {

        // Sort the timeSliceSelector array based on timeslice_id
        const sortedTimeSliceSelector = [...this.props.timeSliceSelector].sort(
          (a, b) => a.timeslice_id - b.timeslice_id
        );

        var sStyle = {
          display: "inline-block",
          outline: "none",
          fontSize: "12px",
          width: "fit-content",
          height: "fit-content",
          color: "#555",
          border: "1px solid #ccc",
          margin: "0 10px",
          borderTopLeftRadius: "3px",
          borderTopRightRadius: "3px",
          backgroundColor: "#fff",
        };

        var itemSliceBox = (
          <span>
            &nbsp;&nbsp;&nbsp; Time slice Selector :
            <select
              name="itemOptions"
              style={sStyle}
              onChange={this.props.timeSliceCaller}
              value={this.props.currentTimeSlice || "Hide_Inactive"}
            >
              <option value="all">All</option>
              <option value="Hide_Inactive">Hide Inactive</option>
              {sortedTimeSliceSelector.map((item) => (
                <option
                  key={item.timeslice_id}
                  value={item.timeslice_id}
                  style={{
                    color:
                      item.timeslice_status === "Canceled"
                        ? "#c1401a"
                        : "inherit",
                  }}
                >
                  {Formatter.fmDate(item.timeslice_start)} - {Formatter.fmDate(item.timeslice_end)} (
                  {item.timeslice_id} - {item.timeslice_status})
                </option>
              ))}
            </select>
          </span>
        );
      }

      actionBar = 
        <div style={{"backgroundColor": "#0096d6", color: "#fff", padding: "4px 5px 2px", "fontSize": "12px" }}>
         <i className="glyphicon glyphicon-circle-arrow-down"  
            title="download grid as shown" 
            onClick={this.handleDownloadAsShown}
            style={{"color":"#fff","fontSize":"13px", marginRight: "8px" }}
         />
          {this.props.leftLabel}
          {itemSliceBox}
          {actionToggleAll}
          {searchList}
         <span style={{ float: "right"}}>
           {actionMenu}
           {customize}
         </span>
        </div>
    }

    if (this.gridRef  && this.gridRef.current) {
        var gridRefCurrent = this.gridRef.current;
        var self = this;
        setTimeout( function() {
            self.adjustHeader(gridRefCurrent , -1);
        }, 330);
    }
 
    if (this.state.showFieldCustomization) {
      var lockedRows = this.props.selectedColumns.reduce((counter, selCol) => selCol.frozen === '1' ? counter += 1 : counter, 0);
    }

    var cls = "grid-container-table table table-hover"
    if (this.props.sortable && this.props.sortable == true) {
        cls += " sortable"
    }

    return (

      <div  id={id} className="simpleDataGridWrapper">
        {exportDiv}
        {filterDiv}
        {actionBar}
        <div ref={this.gridRef} className="sdg-wrapper" style={outerStyle}>
          <div className="frozen-grid-header" style={frozenStyle}></div>
          <table id={id+'_table'} className={cls} style={specialStyle}>
            <thead>
              <tr>{header}</tr>
            </thead>
            <tbody>
              {tbody}
            </tbody>
          </table>
        </div>
        { this.state.showFieldCustomization ?
            <AdvancedFieldCustomizer
              title="Item Details Tab"
              lockedRows={lockedRows}
              standardList={this.props.standardColumns}
              selectedList={this.props.selectedColumns}
              availableList={this.props.availableColumns}
              onChange={this.handleCustomizeFieldsChange}
              onCancel={this.handleCustomizeFieldsCancel}
            />
          : null
        }
      </div>
    )
  }

};

//----------------------------------------------------------------------
//   StatusElements - show the status per mapping 
//
//----------------------------------------------------------------------
export class StatusElement extends React.Component {

  constructor(props) {
    super(props);
    this.handleActiveItemsToggle     = this.handleActiveItemsToggle.bind(this);
  }
 
  handleActiveItemsToggle(event){
    this.props.handleActiveItemsToggle(event.currentTarget.dataset.id)
  }

  render() {

    const tenant = this.props.tenant;
    const serviceType = this.props.serviceType;

    var t = this.props.type;
    if(this.props.isBookmarkFlag){
      let klas = "seen";
      switch (t) {
        case "S":
          klas="seen"
          break;
        case "C":
          klas="current"
          break;
        case "F":
          klas="future"
          break;
        case "H":
          klas="hide"
          break;
      
        default:
          break;
      }
      return (
        <li className={"viz-bookmark " + klas}>{this.props.children}</li>
      );
    }


    var dataID = this.props.dataID;
    const itemGroupsCount = this.props.itemGroupsCount[dataID] ? this.props.itemGroupsCount[dataID] : 0;
    //console.log(itemGroupsCount);
    const currentStatus = dataID ? dataID.toLowerCase() : '';
    if(currentStatus !=='canceled' && t === 'F' && itemGroupsCount > 0){
      t = 'C';
    }

    if (t == "H" || t == "hide") return (<span></span>);

    var checked = null;

    var beg = '';
    if (t == "A" || t == "cancelled_items") beg += 'canceled ';
    if (t == "F" || t == "future")  beg += 'future ';
    if (t == "C" || t == "current") beg += 'current ';
    if (t == "S" || t == "seen")  { 
        beg += 'seen ';
        checked = <i className="glyphicon glyphicon-ok" style={{fontSize: "11px", "paddingLeft": "3px" }}/>    
    }
    beg += 'btn ';

    if (tenant == "HPICS" && isAdvancedExchangeServiceType(serviceType)) {
      if (dataID == "processing") {
        beg += 'btn-first '
      }
    } else {
      if (dataID == "submitted" || dataID == "waitingCustomerUpdate") {
        beg += 'btn-first '
      }

    }
    if (this.props.activeItemButtons[dataID] === true) {
      beg += 'active'
    }

    var t_dataID = "chevron_" + dataID;
    return (   
      <li className={beg}><a onClick={this.handleActiveItemsToggle} data-id={dataID}>
         <span className="status-lbl">
            {T(t_dataID)}
            &nbsp;
            {checked}
            &nbsp;
            { (itemGroupsCount > 0) ? itemGroupsCount : null }
         </span> 
      </a>{this.props.children}</li>
    )
  }
};

//----------------------------------------------------------------------------
//  ExternalOSS top menu
//
//----------------------------------------------------------------------------
export class ExternalOSSMenu extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      generalUser: true,
      newsClass: "collapse news-panel",
      news: "Loading....",
      showLogoutArea: false,
      showChatbot: true,
      maintMsg: "",
      crp: {}
    }

    this.handleMessageVisiblity = this.handleMessageVisiblity.bind(this);
    this.handleLogoutClick = this.handleLogoutClick.bind(this);
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleLogoutIconClick = this.handleLogoutIconClick.bind(this);
    this.waitForUserSettings = this.waitForUserSettings.bind(this);
  }

  waitForUserSettings(callback) {
    const interval = setInterval(() => {
      var userSettings = typeof window.UserSettings != 'undefined' && window.UserSettings.user_id ? window.UserSettings : undefined;
      if (userSettings !== undefined) {
        clearInterval(interval);
        callback(userSettings);
      }
    }, 500);
  }

  deleteCookie(cname = '', path = '/', domain = '') {
    if (domain) {
      //document.cookie = `${cname}=;path=${path};domain=${domain};expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
      document.cookie = `${cname}=;path=${path};expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    } else {
      document.cookie = `${cname}=;path=${path};expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }
  }

  handleMessageVisiblity() {

    if ( this.state.newsClass.includes("in") ) {
      var d = new Date();
      var seconds = Math.round(d.getTime() / 1000);
      d.setTime(d.getTime() + (400 * 86400 * 1000));
      document.cookie = "HPOSS_NEWS_EXT_TS="+seconds+"; expires="+d.toUTCString()+";";
      this.setState({
        newsClass: "collapse news-panel",
      })
    } else {
      this.setState({
        newsClass: "collapse-flex in news-panel",
      })
    }
  }

  componentDidMount() {

    GET("/os/ossui/v1/ex/widget/news", {}, function(res) {

      if (res.status == 'S') {
        let cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)HPOSS_NEWS_EXT_TS\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        if ( res.message > cookieValue) {
          this.setState({
            news: res.data,
            newsClass: "collapse-flex in news-panel",
          })
        } else {
          this.setState({
            news: res.data,
            newsClass: "collapse news-panel",
          })
        }
      }
    }.bind(this));

    this.waitForUserSettings((userSettings) => {
      if (userSettings.maintMsg)
        this.setState({maintMsg: userSettings.maintMsg});

      if (userSettings.genAICfg?.authorized_users && userSettings.genAICfg?.authorized_users.length > 0 && userSettings.user_id)
        this.setState({showChatbot: userSettings.genAICfg.authorized_users.includes(userSettings.user_id)});

      if (userSettings.genAICfg?.restricted_geos && userSettings.genAICfg?.restricted_geos.length > 0)
        if (userSettings.geo && userSettings.genAICfg?.restricted_geos.includes(userSettings.geo))
          this.setState({showChatbot: false});

      if (userSettings.crp && Object.keys(userSettings.crp).length > 0)
        this.setState({crp: userSettings.crp});
    });
  }

  componentDidUpdate() {
    window.scrollTo(0, 0)
  }

  handleLogoutClick = () => {
    this.deleteCookie('session', '/', window.location.host);
    this.deleteCookie('session', '/os', window.location.host);
    this.deleteCookie('OSSHPIDSESSION', '/', window.location.host);
    this.setState({ showLogoutArea: false });
    toast.success("successfully logged out", {
      position: "top-center",
      autoClose: 5000,
    }); 
    //window.close();
    window.location.href = '/logout';
  };

  handleMouseOver = () => {
    this.setState({ showLogoutArea: true });
  };

  handleMouseLeave = () => {
    this.setState({ showLogoutArea: false });
  };

  handleLogoutIconClick = () => {
    this.setState((prevState) => ({
      showLogoutArea: !prevState.showLogoutArea,
    }));
  };

  render() {

    var active = 'home';
    var tenant = 'HPI'
    var user_id = 'unknown';
    var welcome = '';

    var qr_line = '/img/oss_qr_line_prod.png'
    var qr_pwa = '/img/oss_qr_pwa_blue_prod.png'

    if (window.location.hostname.match(/itg/)) {
      var qr_line = '/img/oss_qr_line_itg.png'
      var qr_pwa = '/img/oss_qr_pwa_blue_itg.png'
    }

    var showLineQR = true;
    if (window.OSSSurveyData
      && window.OSSSurveyData.country_code != ""
      && window.OSSSurveyData.country_code != "JP"
    ) {
      showLineQR = false;
    }

    if (this.props.active) {
      active = this.props.active;
    }

    if (this.props.user_id) {
      user_id = this.props.user_id
    }
    if (this.props.tenant) {
      tenant = this.props.tenant
    }
    var isInternalUser = /@hp\.com$/i.test(user_id);
    if (this.props.welcome) {
      welcome = this.props.welcome
    }

    var scriptCode = "InitOSSMenu();"

    var fedStr = '';
    var fedSwitch = null;
    var tmpSwitch = null;
    var hpeTheme1 = {};
    var hpeThemeCSS = null;

    var adhocUrl   = "/os/os.tcl?adhoc=1&amp;dontvalidate=1"
    var brandClass = "navbar-brand dropdown"
    var supportUrl = "https://techdirect.corp.hpicloud.net/techdirect/SubmitRequest?p=sr"
    var trainingUrl = "https://hp.sharepoint.com/teams/pcbits/bitshomepage/SitePages/OSS.aspx"
    var dictionaryUrl = "http://hpi12.sharepoint.hp.com/teams/TeamRecordings/Order%20to%20Cash/OSS/OSS%20Data%20Dictionary/index.htm"
    if (tenant == "HPI") {
      adhocUrl = "/os/ios.tcl?adhoc=1&amp;dontvalidate=1"
      brandClass = "navbar-brand dropdown hpi"
      supportUrl = "https://techdirect.corp.hpicloud.net/techdirect/SubmitRequest?p=sr"
    }

    var supportRequestUrl = "";
    if (this.state.crp && this.state.crp.baseURL && this.state.crp.myRequestEP)
      supportRequestUrl = this.state.crp.baseURL.replace("_LANGCODE_", getLangCode()) + this.state.crp.myRequestEP;

    return (

      <nav className="navbar navbar-default" role="navigation" style={{'borderBottom': '2px solid #0096d6', 'paddingTop': '2px'}}>
        <div className="container-fluid">

          <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
            <ul className="nav navbar-nav">
              <li className={active == 'search'    ? "active": ""}><a href="hpos.tcl?"><L>Order Search</L></a></li>
              <li className={active == 'reporting' ? "active": ""}><a href="hpos.tcl?nr=1"><L>Reporting</L></a></li>
              <li className={active == 'analytics' ? "active": ""}><a href="hpos.tcl?analytics=1"><L>Analytics</L></a></li>
              <li><a key="my-support-request" href={supportRequestUrl} target='_blank'>My Support Requests</a></li>
            </ul>

            <ul className="nav navbar-nav user-gp" style={{float: "right"}}>
               <li className='welcome'>
                  <span>Welcome, {user_id}</span>
               </li>
               <li>
                <a className="profile-icon" title="Show Logout Button" onClick={this.handleLogoutIconClick}><ProfileIcon /></a>
                {this.state.showLogoutArea && (
                  <div className="logout-area" style={{ position: 'absolute'}}>
                    <button className="btn btn-danger" style={{"float":"right"}} onClick={this.handleLogoutClick}>Logout</button>
                  </div>
                )}
               </li>
               <li>
                <a className='show-news' title="Show News" onClick={this.handleMessageVisiblity} href="#news-panel">
                  <NewsIcon />
                </a>
               </li>
               <li className='notification'><a href='hpos.tcl?notifications'><NotificationIcon /><span id='notificationBadge' className='badge'></span></a></li>
               {this.state.showChatbot && (
                  <li key="chatbot-ext">
                    <a title="HP Order Status AI Assistant" onClick={() => window.toggleChatbotExt()} style={{'cursor': 'pointer', 'padding': '5px 1px'}}>
                      <ChatbotSandy width="22px" height="22px" fill="currentcolor" stroke="currentcolor" />
                    </a>
                    <span className="bouncing-rainbow-bubble">
                      <i className="glyphicon glyphicon-fire" style={{paddingRight: "5px"}}></i>
                      Try our new AI Chatbot
                    </span>
                  </li>
               )}
              <li>
                <div className="qrpopup">
                  <i className="glyphicon glyphicon-qrcode" style={{padding: "5px", fontSize: "20px", color: "#777"}}></i>
                  <div className="qrpopupOverlay">
                    Try out our Order Status App
                    <br />
                    <img src={qr_pwa} height="200" width="200" style={{margin: "10px"}} />
                    <br />
                    <a href="/img/HPOrderStatus_MOBILE_Intro_deck_external.pdf" target="_blank" className="btn btn-primary" style={{margin: "7px 0 0 0", color: "white", backgroundColor: "#0096d6"}}>
                      Detail How-to use &nbsp;(PDF)
                    </a>
                  </div>
                </div>
              </li>
              {
                showLineQR
                ? <li>
                    <div className="qrpopup">
                      <i className="glyphicon glyphicon-qrcode" style={{padding: "5px", fontSize: "20px", color: '#06c755'}}></i>
                      <div className="qrpopupOverlay">
                        Try out our LINE bot
                        <br />
                        <img src={qr_line} height="200" width="200" style={{margin: "10px"}} />
                        <br />
                        <a href="/img/HPOrderStatus_MOBILE_Intro_deck_LINE_bot.pdf" target="_blank" className="btn btn-primary" style={{margin: "7px 0 0 0", color: "white", backgroundColor: "#0096d6"}}>
                          Detail How-to use &nbsp;(PDF)
                        </a>
                      </div>
                    </div>
                  </li>
                : null
              }
              <li>
                <a title="Learn more about Order Status Suite (OSS)" href="hpos.tcl?extdocs=1" target="_blank" style={{padding: "5px"}}>
                  <i className="glyphicon glyphicon-question-sign" style={{fontSize: "20px"}}></i>
                </a>
              </li>
              <li>
                <a title="Provide Feedback" href="mailto:OSS_Feedback@external.groups.hp.com?subject=OSS: External Portal Feedback" style={{padding: "5px"}}>
                  <i className="glyphicon glyphicon-bullhorn" style={{fontSize: "20px"}}></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div id="internalWidget"></div>
        <div id="notesbody" />
        <div id="news-panel" className={this.state.newsClass} style={{"marginTop":"0px"}}>
          <div className="news-panel-hdr">
            Order Status Suite - News Update <button type="button" className="btn btn-danger" style={{"float":"right"}} onClick={this.handleMessageVisiblity} data-target="#news-panel">X</button>
          </div>
          <div className="news-panel-body" dangerouslySetInnerHTML={{__html: this.state.news}} />
        </div>
        <script type="text/javascript" dangerouslySetInnerHTML={{__html: scriptCode}} />
        {
          this.state.maintMsg
          ? <MaintMsgModal msg={this.state.maintMsg} />
          : null
        }
      </nav>
    )
  }

};


export class SandyLink extends React.Component {

  constructor(props) {
    super(props);
    this.handleOpenSandyLink = this.handleOpenSandyLink.bind(this);
  }

  handleOpenSandyLink() {
    if (typeof GlobalUserSettings != 'undefined') { 
        UserSettings.config = GlobalUserSettings.config;
    }
    var LegacyIntURL = UserSettings.config.links.LegacyIntURL;
    var order = this.props.order;
    var legacyno = order.legacy_order_no;
    var orderno = order.order_no;
    var sandyUrl = LegacyIntURL+"?o="+legacyno+"&os_no="+orderno;
    window.open(sandyUrl, "_blank", "toolbar=yes, scrollbars=yes, resizable=yes, top=10, left=10, width=1360, height=860");
  }

  render() {
    var order = this.props.order;
    return (
      <button type="button" className="btn btn-primary btn-sm" onClick={this.handleOpenSandyLink}>
        <i className="glyphicon glyphicon-new-window"/>&nbsp;
        Open in SANDY
      </button>
    )
  }
};

export class ExportExtExcelOrder extends React.Component {

  render() {
    var order = this.props.order;
    var legacyno = order.legacy_order_no;
    var orderno = order.order_no;
    var lookupType = "legacy_order_no";
    var locale = I18N.locale;
    var size = typeof this.props.size !== 'undefined' ? "btn-" + this.props.size: "btn-sm";
    let btnClass = typeof this.props.inverted !== 'undefined' && this.props.inverted ? "" : "btn-primary"

    console.log('ExportExtExcelOrder b2bparameters=',this.props.b2bparameters);

    if (window.location.href.indexOf("/os.tcl")   >= 0 
      || window.location.href.indexOf("/ios.tcl") >= 0
      || window.location.href.indexOf("/eos.tcl") >= 0
      || window.location.href.indexOf("/fos.tcl") >= 0
      || window.location.href.indexOf("/hpos.tcl") >= 0
      || window.location.href.indexOf("/osWidgetWrapper.html") >= 0
      || window.location.href.indexOf("/osWidgetLaunch.tcl")   >= 0)
    {
      var exportURL = "/os/ossui/v1/ex/exportDashboardTemplateWidget/"+lookupType+"/"+legacyno+"/"+locale;   
    } else {
      var exportURL = "/os/ossui/v1/ex/exportDashboardTemplateWidget/"+lookupType+"/"+legacyno+"/"+locale;
    }
    var exportURL = RewriteRESTURL(exportURL);
    if (this.props.b2bparameters) {
      exportURL += '?b2bparameters='+this.props.b2bparameters;
    }
    if (this.props.sfdcSignedRequest || sfdcSession) {
      var exportURL = "/os/api/widget/sfdc/extractOrder/"+legacyno+"/"+locale;
      exportURL += '?signedRequest=&sfdcSession='+encodeURIComponent(sfdcSession);
    }
    if (window.mobileMode) {
        exportURL = "/ext"+exportURL;
    }
    var locTitle = T("Export data of this order into Excel");
    return (
      <a className={`btn ${btnClass} ${size}`}
         title={locTitle}
         style={{"color":"#0096d6"}}
         href={exportURL}>&nbsp;<i className="glyphicon glyphicon-circle-arrow-down"/>&nbsp;</a>
    );
  }
};

export class ExportExcelOrder extends React.Component {

  render() {
    var order = this.props.order;
    var legacyno = order.legacy_order_no;
    var orderno = order.order_no;
    var type = "preDefTemplate";
    var locale = I18N.locale;
    var exportURL = "/os/ossui/v1/in/exportDashboardTemplateWidget/"+type+"/"+legacyno+"/"+locale;
    if (window.mobileMode) {
        exportURL = "/ext"+exportURL;
    }
    var c = "btn btn-primary btn-sm"
    if (this.props.size && this.props.size == "smallest") {
        c = "btn btn-primary btn-smallest"
    }    
    return (
      <a className={c} style={{ color: "#fff" }}
         title="Export data of this order into Excel"
         href={exportURL}><i className="glyphicon glyphicon-circle-arrow-down"/></a>
    );
  }
};

class ExportExcel extends React.Component {
  render() {
    var order = this.props.order;
    var exportexcelReq = this.props.exportexcelreq;
    var length = state.drilldownData.rows.length;
    var drilldownTplName = this.props.exportexcelreq.drilldownTplName;
    var locale = I18N.locale;
    var exportExcelURL = "/os/ossui/v1/in/exportDashboardTemplate/"+exportexcelReq.type+"/preDefTemplate/"+exportexcelReq.alertid+"/"+locale;
    var exportExcelTemplate = "/os/ossui/v1/in/exportDashboardTemplate/"+exportexcelReq.type+"/drillDown/"+exportexcelReq.alertid+"/"+locale;

    if (length > exportExcelMaxLimit) {
        var withOutTemplate = (
          <div id="drillDownHeader" style={{"background": "#0096d6","minWidth": "30px","padding": "3px 3px 3px 6px","textAlign": "left"}}>
          <div className="btn-group"><a href="#" data-toggle="dropdown" className="dropdown-toggle">
             <i className="glyphicon glyphicon-circle-arrow-down" style={{"color": "#fff"}} />
          </a>
               <ul className="dropdown-menu">
                    <li className="disabled"><a disabled title="Export Limit of {exportExcelMaxLimit} orders reached">Export Data by Pre-Defined Template</a></li>
                </ul>
            </div>
          </div>
        );
    } else {
        var withOutTemplate = (
          <div id="drillDownHeader" style={{"background": "#0096d6","minWidth": "30px","padding": "3px 3px 3px 6px","textAlign": "left"}}>
          <div className="btn-group"><a href="#" data-toggle="dropdown" className="dropdown-toggle">
             <i className="glyphicon glyphicon-circle-arrow-down" style={{"color": "#fff"}} />
          </a>
               <ul className="dropdown-menu">
                    <li><a href={exportExcelURL}>Export Data by Pre-Defined Template</a></li>
                </ul>
            </div>
          </div>
        );
    }
    if (length > exportExcelMaxLimit) {
        var withTemplate = (
          <div id="drillDownHeader" style={{"background": "#0096d6","minWidth": "30px","padding": "3px 3px 3px 6px","textAlign": "left"}}>
          <div className="btn-group"><a href="#" data-toggle="dropdown" className="dropdown-toggle">
             <i className="glyphicon glyphicon-circle-arrow-down" style={{"color": "#fff"}} />
          </a>
               <ul className="dropdown-menu">
                    <li className="disabled"><a disabled title="Export Limit of {exportExcelMaxLimit} orders reached">Export Data by Pre-Defined Template</a></li>
                    <li className="disabled"><a disabled title="Export Limit of {exportExcelMaxLimit} orders reached">Export Drill Down Data</a></li>
                </ul>
            </div>
          </div>
        );
    } else {
        var withTemplate = (
          <div id="drillDownHeader" style={{"background": "#0096d6","minWidth": "30px","padding": "3px 3px 3px 6px","textAlign": "left"}}>
          <div className="btn-group"><a href="#" data-toggle="dropdown" className="dropdown-toggle">
             <i className="glyphicon glyphicon-circle-arrow-down" style={{"color": "#fff"}} />
          </a>
               <ul className="dropdown-menu">
                    <li><a href={exportExcelURL}>Export Data by Pre-Defined Template</a></li>
                    <li><a href={exportExcelTemplate}>Export Drill Down Data</a></li>
                </ul>
            </div>
          </div>
        );
    }

    if (drilldownTplName == "order" || drilldownTplName == "shipment" || drilldownTplName == "invoice"
        || drilldownTplName == "SMO Open Orders"
    ){
        return withTemplate;
    } else {
        return withOutTemplate;
    }
  }
};

export class ShowNotes extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      toastId: {}
    }

    this.handleShowNotes = this.handleShowNotes.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  handleShowNotes() {
    $('#ossNotesModal').modal('hide');
    ReactDOM.render(
      <OrderNotes order={this.props.order} width={"940px"} />
      , document.getElementById('notesbody')
    );
    $('#ossNotesModal').modal( { backdrop: 'static'} );
  }

  handleError(statusText) {
    toast.dismiss(this.state.toastId);

    if (statusText == "error") {
      toast.error('Sorry! error occurred, could not retrieve order notes');

    } else if (statusText == "timeout") {
      toast.error('Sorry! timeout occurred, could not retrieve order notes');
    }
  }

  render() {
    var noteColor = "#999";

    var now = new Date();
    var t = new Date( this.props.order.overall_notes_lupd );
    var timeDiff = ((now - t) / 1000) / 3600.0;

    if (timeDiff <  12.0) { noteColor = "#0b0" }
    else if (timeDiff <  48.0) { noteColor = "#ffd500" }
    else if (timeDiff >= 48.0) { noteColor = "#0096d6" }

    return (
      <a onClick={this.handleShowNotes} style={{"margin":"3px", "fontSize":"12px", "color": "#0096d6" }}>
        <i className="glyphicon glyphicon-tags" style={{"cursor": "pointer", "color": noteColor}}/>
      </a>
    )
  }
}

export class Notification extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      subscribed: false,
      showModal: false
    }
    this.handleNotificationChange = this.handleNotificationChange.bind(this);
    this.handleNotificationCancel = this.handleNotificationCancel.bind(this);
  }

  componentDidMount() {

    var legacy_order_no = this.props.legacy_order_no
    
    var notifications = [];
    var self = this;

    GET('/os/ossui/v1/in/widgetExpert/getSingleSubscription', {legacy_order_no : legacy_order_no}, function( notificationObj ) {

      if (notificationObj.length > 0) {
        self.setState({
          user_id : notificationObj[0].user_id,
          legacy_order_no : notificationObj[0].legacy_order_no,
          subscribed: true,
          loading: false
        }, () => {
          console.log("done loading");
        })
      }

    });
  
  }

  handleSubscribe(e) {
    console.log('handleSubscribe', e.target);
    var self = this;
    var lno  = this.props.legacy_order_no;
    
    if (this.state.subscribed) {

      axios.post('/os/ossui/v1/in/widgetExpert/delSubscription', {
        lno: lno
      })
      .then(response => {
        var message = "unsubscribed for notifications";
        toast.success(message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });  
        self.setState({
          subscribed: false,
        });
      })
      .catch(error => {
        toast.error(error.response.statusText, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });  
      });
    } else {

      axios.post('/os/ossui/v1/in/widgetExpert/saveSubscription', {
        lno: lno
      })
      .then(response => {
        var message = "subscribed for notifications";
        toast.success(message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });  
        self.setState({
          subscribed: true,
        });
      })
      .catch(error => {
        toast.error(error.response.statusText, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });  
      });
    }

  }

  mouseOver() {
    if (window.notifModalTimeOut) {
      clearTimeout(window.notifModalTimeOut);
      window.notifModalTimeOut = undefined;
    }
    window.notifModalTimeOut = setTimeout(() => {
        this.openCustomizeNotification();
    }, 2000);
  }

  mouseLeave() {
      if (window.notifModalTimeOut) {
          clearTimeout(window.notifModalTimeOut);
          window.notifModalTimeOut = undefined;
      }
  }

  openCustomizeNotification(){
    this.setState({
      showModal: true,
    });
  };

  handleNotificationCancel(){
    this.setState({
      showModal: false 
    });
  }

  handleNotificationChange(){
    this.setState({
      showModal: false 
    });
  }

  render() {
    return (
      <div style={{"display":"inline", cursor: 'pointer'}}>
        { this.state.showModal 
          ? <NotificationModal legacy_order_no={this.props.legacy_order_no}
                               hp_order_no={this.props.hp_order_no}
                               onCancel={this.handleNotificationCancel}
                               onChange={this.handleNotificationChange}/> 
          : null
       }
       { this.state.subscribed 
         ?  <span title='event notification enabled' onMouseOver={this.mouseOver.bind(this)} onMouseLeave={this.mouseLeave.bind(this)}>
             <svg onClick={this.handleSubscribe.bind(this)} className='icon_on' style={{ color: "#00AA00"}}>
               <use xlinkHref='#bell-ring'/>
             </svg>
            </span>
         : <span title='no event notification'>
             <svg onClick={this.handleSubscribe.bind(this)} className='icon_off'>
               <use xlinkHref='#bell-ring'/>
             </svg>
            </span>
       }
     </div>)
  }

}
export class Cases3WModal extends React.Component {

  handleCloseCaseModal = e => {
    this.props.onClose && this.props.onClose(e);
  };

  constructor(props) {
    super(props);

    this.state = {
      order_no: null, 
      orderData: null,
      status: 'L'
    }
    this.loadOrderAndCases = this.loadOrderAndCases.bind(this);

  }

  loadOrderAndCases(legacy_order_no) {

    var self = this;
    console.log("loading order data ", legacy_order_no);

    var Params = {
        lookupType: "legacy_order_no",
        lookupValue: legacy_order_no,
        callingSystem: 'bmt'
    }

    GET("/os/ossui/v1/in/widget/order", Params,
    function(resp) {
      console.log(resp);

      if (resp.status == 'N') {

        alert(resp.message);

      } else {
        self.setState({
          orderData: resp.data,
          status:    resp.status,
          order_no:  resp.data.order_no
        })
        console.log(resp.data);

      }
    });
  }

  componentDidMount() {

    console.log("Cases3WModal loadOrderAndCases ...", this.props);

    if (this.props.order_no != "") {
      this.loadOrderAndCases(this.props.order_no)
    }
  }

  render() {

      return (
        <form className="form-horizontal" role="form" id="casesModalForm" method="post" action="">
          <div className="modal" id="casesModal" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style={{"display":"block"}}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.handleCloseCaseModal}>x</button>
                  <h3 className="modal-title" id="casesModalHeading">
                  Available Cases found for {this.state.order_no}
                  </h3>
                </div>
                <div className="modal-body">
                  <div className="form-group">
                    <div className="col-sm-12">
                    { (this.state.status == 'S')
                      ? <Cases
                          order={this.state.orderData}
                         />
                      : <BasicAlert type={this.state.status} />
                    }
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" onClick={this.handleCloseCaseModal} className="btn btn-info">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </form>
       )
  }
}

export class PinOrder extends React.Component {

  constructor(props) {
    super(props);
  }

  handlePinned( e) {
    console.log('handlePinned', e.target);
    var elem = e.currentTarget;
    var pinnedStatus = "off"
    if (elem.className.baseVal == "icon_off") pinnedStatus = "on";
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            elem.className.baseVal = 'icon_'+pinnedStatus
        }
    };
    xhttp.open("POST", "/os/ws/osvHelper.tcl?type=ajax&pinned="+pinnedStatus+"&os_no="+this.props.legacy_order_no, true)
    xhttp.send();   
  }

  render() {

    if (this.props.pinned) {
      return <span title='not pinned'>
               <svg onClick={this.handlePinned.bind(this)}
                    className='icon_on' style={{ marginBottom: "2px", color: "#c1401c"}}><use xlinkHref='#pin'/></svg>
             </span>
    } else {
      return <span title='pinned for you'>
               <svg onClick={this.handlePinned.bind(this)}
                    className='icon_off' style={{ marginBottom: "2px"}}><use xlinkHref='#pin'/></svg>
             </span>
    }
  }

}
export class RefreshOrder extends React.Component {

  constructor(props) {
    super(props);
    this.getBaseUrl = this.getBaseUrl.bind(this);
    this.handleUrl = this.handleUrl.bind(this);
    this.handleOrderRefresh = this.handleOrderRefresh.bind(this);
  }

  getBaseUrl() {
    return typeof GlobalUserSettings != 'undefined'
      ? GlobalUserSettings.config.links.LegacyIntURL.replace(/\/os\/.+/,'')
      : ''
  }

  handleUrl(url) {
    fetch(url).then(function(response) {
      if (response.ok)
        toast.success('Successfully added order to refresh queue');
      else
        toast.error('Error occurred while refreshing order');
    });
  }

  handleOrderRefresh() {
    toast.info('Initiating order refresh ...');
    var legacyOrderNo = this.props.order.legacy_order_no;
    var orderNo = this.props.order.order_no;
    var url = this.getBaseUrl() + "/os/ws/osvHelper.tcl?old=1&refresh=QTCUID:" + legacyOrderNo;
    this.handleUrl(url);
    document.getElementById("refreshOrder").disabled=true;
  }

  render(){
    return (
      <button type="button" id="refreshOrder" className="btn btn-primary btn-smallest" data-toggle="tooltip" data-html="true" onClick={this.handleOrderRefresh}>
        <i className="glyphicon glyphicon-refresh"/>&nbsp;
        {T('Refresh Order')}
      </button>
    )
  }

}

export class OpenIn extends React.Component {

  constructor(props) {
    super(props);
    this.getBaseUrl = this.getBaseUrl.bind(this);
    this.handleUrl = this.handleUrl.bind(this);
    this.handleOpenSandy = this.handleOpenSandy.bind(this);
    this.handleOpenExtWidget = this.handleOpenExtWidget.bind(this);
    this.handleOpenIntWidget = this.handleOpenIntWidget.bind(this);
    this.handleOpenE2ETracking = this.handleOpenE2ETracking.bind(this);
    this.handleOpenDocuments = this.handleOpenDocuments.bind(this);
    this.handleOpenChgLog = this.handleOpenChgLog.bind(this);
    this.handleOpenHistory = this.handleOpenHistory.bind(this);
    this.handleOpenB2BLinkage = this.handleOpenB2BLinkage.bind(this);
    this.handleCreateClaims = this.handleCreateClaims.bind(this);
    this.handleOpenOSV = this.handleOpenOSV.bind(this);
    this.handleDefaultToOSV = this.handleDefaultToOSV.bind(this);
  }

  getBaseUrl() {
    return typeof GlobalUserSettings != 'undefined'
      ? GlobalUserSettings.config.links.LegacyIntURL.replace(/\/os\/.+/,'')
      : ''
  }

  handleUrl(url) {
    return window.open(url, "_blank");
  }

  handleOpenSandy() {
    var legacyOrderNo = this.props.order.legacy_order_no;
    var orderNo = this.props.order.order_no;
    var url = this.getBaseUrl() + "/os/SalesAdminView.tcl?o=" + legacyOrderNo + "&os_no=" + orderNo;
    this.handleUrl(url);
  }

  handleOpenIntWidget() {
    var legacyOrderNo = this.props.order.legacy_order_no;
    var url = this.getBaseUrl() + "/static/dist/osWidgetWrapperInt.html?lookupType=legacy_order_no&lookupValue=" + legacyOrderNo;
    this.handleUrl(url);
  }

  // osWidgetWrapperInt.html?lookupType=legacy_order_no&lookupValue=201229Q16SG807

  handleOpenExtWidget() {
    var legacyOrderNo = this.props.order.legacy_order_no;
    var orderNo = this.props.order.order_no;
    var url = this.getBaseUrl() + "/os/osWidgetWrapper.html?lookupType=legacy_order_no&lookupValue="
              + legacyOrderNo + "&os_no=" + orderNo + "&session=" + sessionId;
    this.handleUrl(url);
  }

  handleOpenE2ETracking() {
    var legacyOrderNo = this.props.order.legacy_order_no;
    var orderNo = this.props.order.order_no;
    var url = this.getBaseUrl() + "/os/E2eTracking.tcl?legacy_order_no=" + legacyOrderNo + "&os=" + orderNo
              + "&search_id_type=ois_id&search_input_id=&e2e_tracking_id=&sales_order_no=&customer_po_no="
              + "&invoice_no=&shipment_no=&hp_customer_no=&date_from=&msgTimeStart=&setup_id=&msg_id="
              + "&date_to=&msgTimeEnd=&route_to_market=&hpsb_tracking_id=&region=&dosearch=Search";
    this.handleUrl(url);
  }

  handleOpenDocuments() {
    var msgViewerNo = this.props.order.sales_org + this.props.order.so_no + ":" + this.props.order.legacy_order_no;
    var corId = this.props.order.correlation_id;
    var webNo = this.props.order.web_order_no ? this.props.order.web_order_no : this.props.order.quote_no;
    var url = this.getBaseUrl() + "/os/MessageViewer.tcl?os=" + msgViewerNo + "&cor_id=" + corId + "&web_no=" + webNo;
    this.handleUrl(url);
  }

  handleOpenChgLog() {
    var msgViewerNo = this.props.order.legacy_order_no;
    var url = this.getBaseUrl() + "/os/support/LogViewer.tcl?os=" + msgViewerNo;
    this.handleUrl(url);
  }

  handleOpenHistory() {
    var legacyOrderNo = this.props.order.legacy_order_no;
    var url = this.getBaseUrl() + "/static/dist/OrderStatusViewer.html?render=sapHistory&lookupType=legacy_order_no&lookupValue=" + legacyOrderNo;
    this.handleUrl(url);
  }

  handleOpenB2BLinkage() {
    var soNo = this.props.order.so_no;
    var system = this.props.order.om_system;
    var tenant = this.props.order.tenant;
    var url = this.getBaseUrl() + "/os/B2BSAPLinkage.tcl?system=" + system + "&so_no=" + soNo + "&hdr_tenant=" + tenant;
    this.handleUrl(url);
  }

  handleCreateClaims() {
    if (typeof GlobalUserSettings != 'undefined') {
        UserSettings.config = GlobalUserSettings.config;
    }
    var ECSLink = UserSettings.config.links.ECSLink;
    var orderNo = this.props.order.order_no;
    var url = ECSLink + "/ww/eclaims/claimadmin/app?ORDER=" + orderNo;
    this.handleUrl(url);
  }

  handleOpenOSV() {
    var legacyOrderNo = this.props.order.legacy_order_no;
    var url = this.getBaseUrl() + "/static/dist/OrderStatusViewer.html?lookupType=legacy_order_no&lookupValue="
              + legacyOrderNo;
    this.handleUrl(url);
  }


  handleDefaultToOSV() {
    if (typeof GlobalUserSettings != 'undefined') {
        // directly set when person is on Landing Page
        GlobalUserSettings.val.global.preferredViewer = 'osv';
        try {
            UserSettings.val.global.preferredViewer = 'osv';
        } catch (err) {
            console.log(err);
        }
        window.CurrentPref = 'osv';
    }
    UserSettings.update('global.preferredViewer','osv', function() {
    });
    this.handleOpenOSV();
  }

  render() {
    var OpenHistory = (
          <li>
            <a onClick={this.handleOpenHistory} style={{"cursor":"pointer"}}>{T('User Status History')}</a>
          </li>
    );
    var OpenB2BLinkage = (
          <li>
            <a onClick={this.handleOpenB2BLinkage} style={{"cursor":"pointer"}}>{T('Back2Back Linkage')}</a>
          </li>
    );
    var CreateClaims = (
          <li>
            <a onClick={this.handleCreateClaims} style={{"cursor":"pointer"}}>{T('Create Claims')}</a>
          </li>
    );
    var E2ETracking = (
          <li>
            <a onClick={this.handleOpenE2ETracking} style={{"cursor":"pointer"}}>{T('E2E Tracking')}</a>
          </li>
    );
    var Documents = (
          <li>
            <a onClick={this.handleOpenDocuments} style={{"cursor":"pointer"}}>{T('Order Capture Documents')}</a>
          </li>
    );
    var ChgLog = (
          <li>
            <a onClick={this.handleOpenChgLog} style={{"cursor":"pointer"}}>{T('Order Change Log')}</a>
          </li>
    );
    var SANDY = (
            <li>
              <a onClick={this.handleOpenSandy} style={{"cursor":"pointer", color: "#bbbbbb"}}>{T('SANDY')} {T('(retiring)')}</a>
            </li>
    );
    //console.log("memberOf SMEUser/GlobalUser:", UserSettings.memberOf('SMEUser'), UserSettings.memberOf('GlobalUser'))
    if ((!UserSettings.memberOf('SMEUser') && !UserSettings.memberOf('GlobalUser')) && !UserSettings.isValidAcv(this.props.order.acv, '400')) {
      //Hide E2eTracking and Documents for General Users
      E2ETracking = "";
      ChgLog = "";
      if (!UserSettings.memberOf('MessageViewerReadOnly')) {
        Documents = "";
      }
    }
    //console.log("memberOf SANDYObsolesence:", UserSettings.memberOf('SANDYObsolesence'))
    if (!UserSettings.memberOf('SANDYObsolesence')) {
      //Hide SANDY link for most Users
      SANDY = "";
    }
    if (! isHpUser(UserSettings.user_id)) {
      //Hide Open In ... links for external Users
      OpenHistory    = "";
      OpenB2BLinkage = "";
      CreateClaims   = "";
    }

    var preferredViewer = UserSettings.get('global.preferredViewer');
    if (typeof GlobalUserSettings != 'undefined') {
        console.log('GlobalUserSettings:', GlobalUserSettings);
        if (GlobalUserSettings.val && GlobalUserSettings.val.global) { 
            preferredViewer = GlobalUserSettings.val.global.preferredViewer;
        }  
    }
    if (preferredViewer == null || preferredViewer == "" || preferredViewer == "sandy") {
        preferredViewer = "widget";
    }

    if (this.props.caller == 'oswi') {
      return (
        <div className="btn-group" style={{"verticalAlign": "top", "textAlign": "left"}}>
          <button type="button" className={`btn btn-primary btn-sm dropdown-toggle ${this.props?.class}`} data-toggle="dropdown" title={T('Open In ...')}>            
            <i className="glyphicon glyphicon-new-window"/>
            &nbsp;&nbsp;{T('Open In ...')}
            &nbsp;&nbsp;
            <span className="caret"></span>
          </button>
          <ul className="dropdown-menu" role="menu">
            <li>
              <a onClick={this.handleOpenOSV} style={{"cursor":"pointer"}}>{T('Order Status Viewer')}</a>
            </li>
            { preferredViewer != 'osv' 
              ? <li>
                 <a onClick={this.handleDefaultToOSV} style={{"cursor":"pointer"}}>{T('Default to Order Status Viewer')}</a>
                </li>
              : null
             }
            <li>
              <a onClick={this.handleOpenExtWidget} style={{"cursor":"pointer"}}>{T('External Widget')}</a>
            </li>

          </ul>
       </div>
      )
    } else if (this.props.caller == 'osv') {
      return (
        <div className="btn-group">
          <button type="button" className="btn btn-primary btn-smallest dropdown-toggle" data-toggle="dropdown" title={T('Open In ...')}>
            <i className="glyphicon glyphicon-new-window"/>&nbsp;&nbsp;{T('Open In ...')}
          </button>
          <ul className="dropdown-menu" role="menu">
            <li>
              <a onClick={this.handleOpenExtWidget} style={{"cursor":"pointer"}}>{T('Order Status Widget (external)')}</a>
            </li>
            <li>
              <a onClick={this.handleOpenIntWidget} style={{"cursor":"pointer"}}>{T('Order Status Widget (internal)')}</a>
            </li>
            {E2ETracking}
            {OpenHistory}
            {Documents}
            {ChgLog}
            {OpenB2BLinkage}
            {CreateClaims}
            {SANDY}
          </ul>
       </div>
      )
    }

  }
}

export class Feedback extends React.Component {

  constructor(props) {
    super(props);
    this.getBaseUrl = this.getBaseUrl.bind(this);
    this.handleUrl = this.handleUrl.bind(this);
    this.handleOpenFeedback = this.handleOpenFeedback.bind(this);
  }

  getBaseUrl() {
    return typeof GlobalUserSettings != 'undefined'
      ? GlobalUserSettings.config.links.LegacyIntURL.replace(/\/os\/.+/,'')
      : ''
  }

  handleUrl(url) {
    return window.open(url, "_blank");
  }

  handleOpenFeedback() {
    var legacyOrderNo = this.props.order.legacy_order_no;
    var url = this.getBaseUrl() + "/static/dist/OrderStatusViewer.html?render=feedback&lookupType=legacy_order_no&lookupValue=" + legacyOrderNo;
    this.handleUrl(url);
  }

  render(){
    return (
      <button type="button" className="btn btn-smallest btn-success" onClick={this.handleOpenFeedback}>
        <i className="glyphicon glyphicon-bullhorn" />&nbsp;&nbsp;{T('Feedback')}
      </button>
    )
  }
}

//----------------------------------------------------------------------
//  LaunchInSAP   --  link button, if SAP WEBUI url is available
//
//----------------------------------------------------------------------
export class LaunchInSAP extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    var cl = "btn btn-primary btn-sm dropdown-toggle";
    if (this.props.size && this.props.size == "smallest") {
        cl = "btn btn-primary btn-smallest dropdown-toggle";
    } 

    if ( this.props.order.tenant == 'HPICS' ) {

      if (   this.props.order.sapuiLink          == null 
          && this.props.order.sapuiLinkDisplay   == null
          && this.props.order.sapuiLinkChangeSN  == null
          && this.props.order.sapuiLinkDisplaySN == null
      ) {
        return ( <noscript/>)
      }

      var launchServiceNoti = "";
      if (this.props.order.sn_no != "") {
        launchServiceNoti =
        <ul className="dropdown-menu" role="menu">
          <li>                                    
            <a href={this.props.order.sapuiLinkDisplay} 
              target={"ossSAPUIDisplay_"+this.props.order.so_no} 
              style={{ "cursor": "pointer" }}>Display Sales Order</a>
          </li>                                                                                                                                         
          <li>                                    
            <a href={this.props.order.sapuiLink} 
              target={"ossSAPUIChange_"+this.props.order.so_no}
              style={{ "cursor": "pointer" }}>Change Sales Order</a>
          </li>                                                                                                                                         
          <li>                                    
            <a href={this.props.order.sapuiLinkDisplaySN} 
              target={"ossSAPUIDisplaySN_"+this.props.order.sn_no}
              style={{ "cursor": "pointer" }}>Display Service Notification</a>
          </li>                                                                                                                                         
          <li>                                    
            <a href={this.props.order.sapuiLinkChangeSN} 
              target={"ossSAPUIChangeSN_"+this.props.order.sn_no}
              style={{ "cursor": "pointer" }}>Change Service Notification</a>
          </li>                                                                                                                                         
          <li>                                    
            <a href={this.props.order.sapuiLinkDisplayStock} 
              target={"ossSAPUIDisplayStock"}
              style={{ "cursor": "pointer" }}>Display Stock Overview</a>
          </li>                                                                                                                                         
        </ul>  
      } else if (this.props.order.so_no.match(/^PR_/)) {
        var pr_no = this.props.order.so_no.substring(3);
        launchServiceNoti =
          <ul className="dropdown-menu" role="menu">
            <li>                                    
              <a href={this.props.order.sapuiLinkDisplayPR} 
                target={"ossSAPUIDisplay_"+ pr_no } 
                style={{ "cursor": "pointer" }}>Display Purchase Requisition</a>
            </li>                                                                                                                      
          </ul>  
      } else {
        launchServiceNoti =
        <ul className="dropdown-menu" role="menu">
          <li>                                    
            <a href={this.props.order.sapuiLinkDisplay} 
              target={"ossSAPUIDisplay_"+this.props.order.so_no} 
              style={{ "cursor": "pointer" }}>Display Sales Order</a>
          </li>                                                                                                                                         
          <li>                                    
            <a href={this.props.order.sapuiLink} 
              target={"ossSAPUIChange_"+this.props.order.so_no}
              style={{ "cursor": "pointer" }}>Change Sales Order</a>
          </li>                                                                                                                                         
          <li>                                    
            <a href={this.props.order.sapuiLinkDisplayStock} 
              target={"ossSAPUIDisplayStock"}
              style={{ "cursor": "pointer" }}>Display Stock Overview</a>
          </li>                                                                                                                                         
        </ul>  
      }

      return (
      <div className="btn-group">
          <button type="button" className={cl} data-toggle="dropdown" title="open in SAP">
            <i className="glyphicon glyphicon-edit"/>&nbsp; SAP &nbsp;
            <span className="caret"></span>
          </button>
          {launchServiceNoti}          
        </div> 

      )

    } else {

      if (   this.props.order.sapuiLink        == null 
          && this.props.order.sapuiLinkDisplay == null
      ) {
        return ( <noscript/>)
      }

      if (this.props.order.so_no.match(/^PR_/)) {

          var pr_no = this.props.order.so_no.substring(3);

          return (
            <div className="btn-group">
               <button type="button" className={cl} data-toggle="dropdown" title="open in SAP">
                 <i className="glyphicon glyphicon-new-window"/>&nbsp; SAP &nbsp;
                 <span className="caret"></span>
               </button>
               <ul className="dropdown-menu" role="menu">
                 <li>                                    
                    <a href={this.props.order.sapuiLinkDisplayPR} 
                      target={"ossSAPUIDisplay_"+ pr_no } 
                      style={{ "cursor": "pointer" }}>Display Purchase Requisition</a>
                  </li>                                                                                                                      
               </ul>  
            </div>
          ) 
      }

      if (this.props.order.so_no.match(/^SOM_/)) {
          var crm_no = this.props.order.so_no.substring(4);
          if (this.props.order.order_type_descr.match(/Solution/)) {
              // solution quotations ...
              return (
                <div className="btn-group">
                   <button type="button" className={cl} data-toggle="dropdown" title="open in SAP">
                     <i className="glyphicon glyphicon-new-window"/>&nbsp; SAP &nbsp;
                     <span className="caret"></span>
                   </button>
                   <ul className="dropdown-menu" role="menu">
                     <li>                                    
                        <a href={this.props.order.sapuiLinkDisplaySolutionQuotation} 
                          target={"ossSAPUIDisplay_"+ crm_no } 
                          style={{ "cursor": "pointer" }}>Display Solution Quotation</a>
                      </li>                                                                                                                      
                   </ul>  
                </div>
              ) 
          } else {
              // subscription contracts ...
              return (
                <div className="btn-group">
                   <button type="button" className={cl} data-toggle="dropdown" title="open in SAP">
                     <i className="glyphicon glyphicon-new-window"/>&nbsp; SAP &nbsp;
                     <span className="caret"></span>
                   </button>
                   <ul className="dropdown-menu" role="menu">
                     <li>                                    
                        <a href={this.props.order.sapuiLinkDisplaySubscriptionContract} 
                          target={"ossSAPUIDisplay_"+ crm_no } 
                          style={{ "cursor": "pointer" }}>Display Subscription Contract</a>
                      </li>                                                                                                                      
                   </ul>  
                </div>
              ) 
          }
      }

      return (
      <div className="btn-group">
          <button type="button" className={cl} data-toggle="dropdown" title="open in SAP">
            <i className="glyphicon glyphicon-new-window"/>&nbsp; SAP &nbsp;
            <span className="caret"></span>
          </button>
          <ul className="dropdown-menu" role="menu">
            <li>                                    
              <a href={this.props.order.sapuiLinkDisplay} 
                target={"ossSAPUIDisplay_"+this.props.order.so_no} 
                style={{ "cursor": "pointer" }}>Display Sales Order</a>
            </li>                                                                                                                                         
            <li>                                    
              <a href={this.props.order.sapuiLink} 
                target={"ossSAPUIChange_"+this.props.order.so_no}
                style={{ "cursor": "pointer" }}>Change Sales Order</a>
            </li>                                                                                                                                         
          </ul>  
        </div> 
      )
    }
  }
};

export class SandyExternalLink extends React.Component {

  constructor(props) {
    super(props);
    this.handleOpenSandyLink = this.handleOpenSandyLink.bind(this);
  }  

  handleOpenSandyLink() {
    var LegacyIntURL = "/os/osWidgetWrapper.html";
    var order = this.props.order;
    var legacyno = order.legacy_order_no;
    var orderno = order.order_no;
    var sandyUrl = LegacyIntURL+"?lookupType=legacy_order_no&lookupValue="+legacyno+"&os_no="+orderno
                    +"&session="+sessionId;
    window.open(sandyUrl, "_blank", "toolbar=no, scrollbars=no, resizable=no, top=10, left=10, width=1200, height=850");
  }

  render() {
    var order = this.props.order;
    return (
      <button type="button" className="btn btn-primary btn-sm" onClick={this.handleOpenSandyLink}>
        <i className="glyphicon glyphicon-new-window"/>&nbsp;
        {T('Open External Widget')}
      </button>
    )
  }
};

export class InitSFDCWorkflow extends React.Component {

  render() {
    //var legacyno = order.legacy_order_no;
    var locale            = this.props.locale;
    var order             = this.props.order;
    var showSfdcButton    = order.showSfdcButton;
    //var serviceURL      = "https://test1-hpvertica.cs18.force.com/CustomerSalesOp";
    var serviceURL        = order.serviceURL;
    var om_region         = order.om_region;
    var orderno           = order.order_no;
    var customer_no       = order.customer_no;
    var customer_name     = order.customer_name;
    var purchase_order_no = order.purchase_order_no;
    var caseOrigin        = "OSS";
    var recordType        = "Order Management";
    var quote_no          = order.quote_no;
    var userEmail         = order.userEmail;
    var userName          = order.userName;
    var business_type     = order.business_type;
    var rtm               = order.rtm;
    const isExternalWidget = this.props.isExternalWidget;
    const isValidDwGroupUser = this.props.isValidDwGroupUser;

    if(this.props.overwrite) {
        var overwrite       = this.props.overwrite;;
        serviceURL          = overwrite.serviceURL ;
        om_region           = overwrite.om_region ;
        quote_no            = overwrite.quote_no ;
        customer_no         = overwrite.customer_no ;
        purchase_order_no   = overwrite.purchase_order_no ;
        customer_name       = overwrite.customer_name ;
        orderno             = overwrite.order_no ;
        business_type       = overwrite.business_type ;
        rtm                 = overwrite.rtm ;
    }
    if ( business_type == "O") {
        business_type = "Volume Order Management"
    } else if ( business_type == "A" ) {
        business_type = "Value Order Management"
    }

    if ( rtm == "I") {
        rtm = "Indirect";
    } else if ( rtm == "D" ) {
        rtm = "Direct";
    }

    switch(locale) {
      case 'jp':
        var sfdc_locale = "ja";
        break;
      case 'kr':
        var sfdc_locale = "ko";
        break;
      case 'zh':
        var sfdc_locale = "zh_CN";
        break;
      case 'en':
        var sfdc_locale = "en_US";
        break;
      default:
        var sfdc_locale = locale;
    }

    var sfdcBtn = ( <noscript/> );
    var tenant = (typeof UserSettings != 'undefined' && UserSettings.tenant)
        ? UserSettings.tenant
        : 'HPI';

    if ( (isExternalWidget && showSfdcButton)
      || (isValidDwGroupUser)
      || (!(isExternalWidget) && tenant != "HPIFEDLLC") ) {

      var locale_map = {};
      locale_map.en = 'en-US';
      locale_map.de = 'de-DE';
      locale_map.es = 'es-ES';
      locale_map.zh = 'zh-CN';
      locale_map.fr = 'fr-FR';
      locale_map.it = 'it-IT';
      locale_map.pt = 'pt-PT';
      locale_map.ru = 'en-US';
      locale_map.sv = 'en-US';
      locale_map.zh = 'zh-CN';
      locale_map.kr = 'ko-KR';
      locale_map.ko = 'ko-KR';
      locale_map.nl = 'en-US';

      var mapped_locale = "en-US";
      if ( locale_map[locale] && locale_map[locale] != "" ) {
        mapped_locale = locale_map[locale];
      }

      serviceURL = serviceURL.replace("_LANGCODE_", mapped_locale);

      if (order.crp && order.crp.baseURL && order.crp.createCaseEP && order.legacy_order_no) {
        var crpItemList = ""
        if (Array.isArray(this.props.crpItems) && this.props.crpItems.length > 0)
          crpItemList = this.props.crpItems.join("%2C")

        serviceURL = order.crp.baseURL.replace("_LANGCODE_", getLangCode()) + order.crp.createCaseEP + order.legacy_order_no + (crpItemList ? ("%26item_no%3D" + crpItemList) : "");
      }

      if (!(isExternalWidget) && (typeof UserSettings != 'undefined') && (window.location.host.includes('oss'))) {
        var sccpItemList = ""
        if (Array.isArray(this.props.sccpItems) && this.props.sccpItems.length > 0)
          sccpItemList = this.props.sccpItems.join(",")

        serviceURL = UserSettings.config.links.SelfServicePortal3W.replace(/\/case/, '/create?orderid=') + order.order_no + (sccpItemList ? ("&item_no=" + sccpItemList) : "");
      }

      sfdcBtn = (
        <div style={{"display": "inline-block", "paddingRight": "5px"}}>
          <a id="RaiseAQuestion" className={`btn btn-primary ${this.props.class || 'btn-sm'}`} href={serviceURL} target="_blank"
            title={T('Raise a question')}
           ><span className="glyphicon glyphicon-flag"/>&nbsp;{T('Raise a question')}
          </a>
          <form style={{position: 'absolute', left: 0, bottom: 0}} name="sfdc" target="_blank" method="post" action={serviceURL}>
            <input type="hidden" name="Region__c"               value={om_region}/>
            <input type="hidden" name="Case_Requestor_Email__c" value={userEmail}/>
            <input type="hidden" name="Requestor_Name__c"       value={userName}/>
            <input type="hidden" name="Quote_Number__c"         value={quote_no}/>
            <input type="hidden" name="CBN__c"                  value={customer_no}/>
            <input type="hidden" name="PO_Number__c"            value={purchase_order_no}/>
            <input type="hidden" name="Sold_to_Party__c"        value={customer_name}/>
            <input type="hidden" name="HP_Order_Number__c"      value={orderno}/>
            <input type="hidden" name="Business_Type__c"        value={business_type}/>
            <input type="hidden" name="Route_to_Market__c"      value={rtm}/>
            <input type="hidden" name="Record Type"             value={recordType}/>
            <input type="hidden" name="Case Origin"             value={caseOrigin}/>
            <input type="hidden" name="lang"                    value={sfdc_locale}/>
          </form>
        </div>
      );
    }
    return sfdcBtn;
  }
};

export class WikiLink extends React.Component {
  render() {
    var linkText = "";
    if (this.props.text && this.props.text != '') {
      linkText = " " + this.props.text;
    }

    return <a href={_wikiUrl+this.props.page} target="_blank"><i className="glyphicon glyphicon-question-sign">
            </i>{linkText}</a>;
  }
};

class IEHint extends React.Component {

  render() {

      // use this.props.tenant for later branding the info message via tenantized css file

      var infoText = "You Are Using Internet Explorer. If you are facing display issues please disable the IE compatibility mode.";
      var tipText  = "OSS is best viewed with Firefox or Chrome.";

      var tenant      = this.props.tenant
      var tenantLower = this.props.tenant.toLowerCase();

      ieHint = (
                  <div id="ieHint" className="alert alert-info" role="alert">
                  <i className="glyphicon glyphicon-info-sign"></i> <L>{infoText}</L> <a href="#" data-toggle="modal" data-target="#ieHintModal"><L>Disable compatibility mode</L> </a> <br/>

                  <div className="modal fade" id="ieHintModal" role="dialog">
                    <div className="modal-dialog" style={{"width":"850px"}}>
                      <div className="modal-content">
                        <div className="modal-header">
                          <button type="button" className="close" data-dismiss="modal">&times;</button>
                          <h4 className="modal-title"><L>Disable compatibility mode</L></h4>
                        </div>
                        <div className="modal-body">
                          <img className="img-responsive" src={"./images/slides/"+tenantLower+"/OSSBestViewed_"+tenant+".png"} alt={"slide "+i}/>
                        </div>
                        <div className="modal-footer">
                          <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

      );

    return ieHint;
  }
};

    export class ReadOnlyTextAreaBox extends React.Component {

      render() {
        var value;

        if (this.props.afilter.type == "enum" || this.props.afilter.type == "bool" ) {
          if (this.props.afilter.values.length == 0) {
            value = "nothing selected";
          } else {
            value = this.props.afilter.values.join(', ');
          }
          
        } else if (this.props.afilter.type == "string" || this.props.afilter.type == "int" || this.props.afilter.type == "double" || this.props.afilter.type == "date" ) {
          if (this.props.afilter.values == "" || this.props.afilter.values.search("undefined") > 0 ) {
            value = "nothing selected";
          } else {
            // ##str:starts with:wwww -> "starts with: wwww"
            value = this.props.afilter.values.split(':')
            let firstElemOfVal = value.shift();
            value = value.join(' - ');
          }
        }

        return (
          <div key={this.props.afilter.name} className="sliceValue" >
            <div className="lbjs" style={{'backgroundColor': '#eee'}}>
              {value}                        
            </div>
          </div>
        )
      }

    };
    //------------------------------------------------------------------------
    //  SearchableMultiSelectBox
    //
    //------------------------------------------------------------------------
    export class SearchableMultiSelectBox extends React.Component {

       constructor(props) {
         super(props);
         this.state = {
           query : '',
           _turnOn: null,
           _start : null,
           force : null
         };
         this.filterInput = React.createRef();
         this.list        = React.createRef();
         this.clear       = React.createRef();
         this.status      = React.createRef();

         this.start = 0;
         this.turnOn = null;

         this.doOver   = this.doOver.bind(this);
         this.doFilter = this.doFilter.bind(this);
         this.doSelect = this.doSelect.bind(this);
         this.doClear  = this.doClear.bind(this);
       };

       doOver( event) {


           var index = parseInt(event.target.getAttribute('nindex'));
           var elem = this.props.values[index];

           if (this.props.single) {
             return;
           }
           if (event.buttons == 0) {
             //this.state.turnOn = null;
             return;
           }
           if (!elem.disabled) {
             if (this.turnOn == false) {
                 elem.selected = false;
                 event.target.removeAttribute("selected");

                 if (this.props.onChange) {
                     this.props.onChange(this, elem);
                 }
             } else
             if (this.turnOn == true) {
                 elem.selected = true;
                 event.target.setAttribute("selected", true);
                 if (this.props.onChange) {
                     this.props.onChange(this, elem);
                 }
             }
           }          
           this.repaintStatus();   
       }

       doFilter() {
         this.repaint();
       }
     
       doSelect(ev) {

           var i = parseInt(ev.target.getAttribute('nindex'));
           var e = this.props.values[i];

           var doRepaint = false;

           //console.log(e, this.start, this.state);
           //console.log(ev); 
           //console.log(ev.buttons, ev.shiftKey, ev.ctrlKey);
           
           if (this.props.single) {
                var savedSelected = e.selected;
                this.props.values.forEach(function(e,i) {
                   e.selected = false;                  
                });
                if (savedSelected) {
                   e.selected = true;
                }
           }
           if (!this.props.single && ev.shiftKey && this.start != null) {
               if (this.start < i) {
                   for (var j=this.start+1;  j < i; j++) {
//console.log("this.start < i", j, i, "start=", this.start, this.turnOn);
                       if (!this.props.values[j].disabled
                           &&
                           this.props.values[j].name.toLowerCase().indexOf(this.state.query) >= 0
                       ) {
                           this.props.values[j].selected = this.turnOn;
                       }
                   }
//console.log("repaint??");
                   this.repaint(); 
               }
               if (this.start > i) {
                   for (var j=this.start-1;  j > i; j--) {
//console.log("this.start > i", j, i, this.start, this.turnOn);
                       if (!this.props.values[j].disabled
                           &&
                           this.props.values[j].name.toLowerCase().indexOf(this.state.query) >= 0
                       ) {
                           this.props.values[j].selected = this.turnOn;
                       }
                   }
                   //console.log("repaint??");
                   this.repaint(); 
               }
           } else
           if (!ev.ctrlKey) {
               var savedSelected = e.selected;
               this.props.values.forEach(function(f,i) {
                   f.selected = false;
               });
               e.selected = savedSelected;
               if (this.props.single && savedSelected) {
                  e.selected = true;
               }
               doRepaint = true;
           }
           this.start = i; 


           //console.log(e.selected, e, ev);

           if (e.selected) { 
               e.selected = false;
               this.turnOn = false;
               ev.target.removeAttribute('selected');
               if (this.props.onChange) {
                   this.props.onChange(this, e);
               }
           } else {

               e.selected = true;
               this.turnOn = true;
               ev.target.setAttribute('selected', true);
               if (this.props.onChange) {
                   this.props.onChange(this, e);
               }
           }
           if (doRepaint) {
               this.repaint();
           } else {
               this.repaintStatus();   
           }
       }

       doClear(ev) {
           this.props.values.forEach(function(e,i) {
             e.selected = false;                  
           });
           if (this.props.onChange) {
               this.props.onChange(this, ev);
           }
           this.repaint();
       }

       repaintStatus() {
           var nrTotal    = 0;
           var nrSel      = 0;
           var nrFiltered = 0;
           var query =  this.filterInput.current.value.toLowerCase();
           for (var i = 0; i < this.props.values.length; i++) {
               var e = this.props.values[i];                
               if ( !e.hasOwnProperty("hide") || e.hide == false) {
                   nrTotal++; 
                   if (e.selected) {
                       nrSel++;
                   }
               }  
               if (e.name.toLowerCase().indexOf(query) >= 0 
                   && (!e.hasOwnProperty("hide") || e.hide == false)
               ) { 
                   nrFiltered++;    
               } 
           }
           if (query.length > 0) {
               nrTotal =  nrTotal + " ("+nrFiltered+")" 
           }

           this.status.current.innerHTML = nrSel + " / " + nrTotal; 
           if (nrSel > 0 ) {
               this.clear.current.className = "lbjs-info-clear";
           } else {
               this.clear.current.className = "lbjs-info-clear-disabled";
           }
       }

       repaint() {

           var self = this;
  
           var query =  this.filterInput.current.value.toLowerCase();
 
           var frag = document.createDocumentFragment();
//console.log("repainting ...");

           for (var i = 0; i < this.props.values.length; i++) {

               var e = this.props.values[i];

               var node = document.createElement('div') 
               node.className = "lbjs-item";
               node.setAttribute('nindex', i);
               node.title = e.name;
               node.onmouseover = self.doOver;
               node.onmousedown = self.doSelect;
               if (e.selected) {
                 node.setAttribute('selected', true);
               }
               if (e.disabled) {
                 node.setAttribute('disabled', true);
               }
                 
               if (e.name.toLowerCase().indexOf(query) >= 0 
                   && (!e.hasOwnProperty("hide") || e.hide == false)
               ) { 
                 node.style.display = 'block'
               } else {
                 node.style.display = 'none'
               }
//               console.log("repaint", i, e, node.selected , node.disabled, node.title);
               var textNode = document.createTextNode(e.name);
               node.appendChild(textNode);
               frag.appendChild(node);
           }

           /* remove (old?) content */
           //console.log("removing:",  this.list.current.firstChild );
           while( this.list.current.firstChild) {
               this.list.current.removeChild( this.list.current.firstChild );
               //console.log("removing continued:",  this.list.current.firstChild );
           }
           this.list.current.appendChild( frag );

           //var n = this.list.current.firstChild;
           //while(n) {
           //     console.log("new entries:", n);
           //     n = n.nextSibling;
           //}
           this.repaintStatus();
       }

       render() {
           //console.log("this.props.repaint=", this.props.repaint);
           var self = this;

           var nrTotal    = 0;
           var nrSel      = 0;
           var nrFiltered = 0;

           var clearAll = null;
           if (nrSel > 0) {
               clearAll = <span className="lbjs-info-clear" onClick={this.doClear} style={{"height" : "120px", "cursor": "pointer"}}>clear filter</span>;
           } else {
               clearAll = <span className="lbjs-info-clear-disabled">clear filter</span>;
           }
           if (self.state.query.length > 0) {
               nrTotal =  nrTotal + " ("+nrFiltered+")" 

           }
           setTimeout(function(){self.repaint()},200);
           return (
             <div className="lbjs">
               <div className="lbjs-searchbar-wrapper">
                  <input className="lbjs-searchbar" ref={this.filterInput} placeholder="search..."  onChange={this.doFilter} />
                </div>
               <div className="lbjs-button ui-selectable"></div>
               <div className="lbjs-list" ref={this.list} title={this.state.trigger} style={{"height" : "120px"}}>
               </div>
               <div className="lbjs-info">
               <span className="lbjs-info-clear" ref={this.clear} onClick={this.doClear} style={{"height" : "120px", "cursor": "pointer"}}>clear filter</span>
               <span ref={this.status} style={{'float':'right'}}> 1/ 7</span>
               </div>
             </div>              
           )
       }
    };  

export class BasicAlert extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.type == 'L')
      return (
        <div className="basic-alert">
          <span className="hp-gif-spinner" style={{'width':'24px', 'height':'24px', 'backgroundSize':'24px 24px'}}></span>
          <span className="basic-alert-msg">
            {this.props.msg ? this.props.msg : T('Loading ...')}
          </span>
        </div>
      )

    else if (this.props.type == 'N')
      return (
        <div className="basic-alert">
          <span className="basic-alert-icon-nodata" style={{'width':'24px', 'height':'24px', 'backgroundSize':'24px 24px'}}></span>
          <span className="basic-alert-msg">
            {this.props.msg ? this.props.msg : T('Sorry, no data available.')}
          </span>
        </div>
      )

    else if (this.props.type == 'E')
      return (
        <div className="basic-alert">
          <span className="basic-alert-icon-error" style={{'width':'24px', 'height':'24px', 'backgroundSize':'24px 24px'}}></span>
          <span className="basic-alert-msg">
            {this.props.msg ? this.props.msg : T('Sorry, error occurred. Please try again later.')}
          </span>
        </div>
      )

    else if (this.props.type == 'T')
      return (
        <div className="basic-alert">
          <span className="basic-alert-icon-timeout" style={{'width':'24px', 'height':'24px', 'backgroundSize':'24px 24px'}}></span>
          <span className="basic-alert-msg">
            {this.props.msg ? this.props.msg : T('Sorry, timeout occurred. Please try again later.')}
          </span>
        </div>
      )

    else if (this.props.type == 'I')
      return (
        <div className="basic-alert">
          <span className="basic-alert-icon-info" style={{'width':'24px', 'height':'24px', 'backgroundSize':'24px 24px'}}></span>
          <span className="basic-alert-msg">
            {this.props.msg ? this.props.msg : ''}
          </span>
        </div>
      )

    else
      return ''
  }
};



/*------------------------------------------------------------------
|   MouseOverPopUp
|     
|
|   properties:
|
|      popupContent   fragment which will be used popup content
|                     enables completely of the layout 
|
|      tableContent   fragment which is just put inside a tbody 
|                     and therefore the default table styling
|                     is used.
|                     can be used for all multi column
|                     layouts
|      
|      keys / values  renders in two column mode: 
|                         left side keys
|                         right side values
|
|
\-----------------------------------------------------------------*/
export class MouseOverPopUp extends React.Component {

  constructor(props) {
    super(props);
    this.popupRef = React.createRef();
  }

  onMouseOver (ev) {

    var p  = ReactDOM.findDOMNode(this.refs.popupRef);
    var pt = ReactDOM.findDOMNode(this.refs.popupRefTable);
    var pi = ReactDOM.findDOMNode(this.refs.popupRefImage);
    var pm = ReactDOM.findDOMNode(this.refs.popupRefMarker);
    var pr = ReactDOM.findDOMNode(this.refs.popupRefRMarker);

    ['mouseover-popup-marker','mouseover-popup-rmarker',
     'mouseover-popup-content','mouseover-popup-table',
     'mouseover-popup-image'
    ].forEach(function(cls) {
        var elems = document.getElementsByClassName(cls);
        for (var i=0; i < elems.length; i++) {
          elems[i].style.visibility = 'collapse';
          elems[i].style.opacity = '0';
          elems[i].style.transition = 'opacity 0.1s 0.7s';
        }
    });

    p.style.visibility  = 'visible';
    pt.style.visibility = 'visible';
    p.style.opacity  = '1';
    pt.style.opacity = '1';

    if (pi) {
        pi.style.visibility = 'visible';
        pi.style.opacity = '1';
    }

    var brect = ev.target.getBoundingClientRect();
    //console.log(brect.left, brect.width);
    var left = brect.left  + Math.floor(brect.width);
    var top  = brect.top;

    var s = window.getComputedStyle(p);

    var onRightSide = true;
    if ( (top + parseInt(s.height)) > window.innerHeight) {
        top = window.innerHeight - parseInt(s.height) - 3;
        if (top < 5) top = 5;
    }
    if ( (left + parseInt(s.width)) > window.innerWidth) {
        left = brect.left - parseInt(s.width) - 13;  
        onRightSide = false;
       
    }

    p.style.top = (top-1) + 'px';
    p.style.left = (left-8+14) + 'px';

    if (onRightSide) {
        pm.style.visibility = 'visible';
        pm.style.opacity = '1';
        pm.style.top = (brect.top-1) + 'px';
        pm.style.left = (left-8)+ 'px';
    } else {
        pr.style.visibility = 'visible';
        pr.style.opacity = '1';
        pr.style.top = (brect.top+0) + 'px';
        pr.style.left = (brect.left-7)+ 'px';
    }     
  }


  onMouseOut (ev) {

    var p  = ReactDOM.findDOMNode(this.refs.popupRef);
    var pt = ReactDOM.findDOMNode(this.refs.popupRefTable);
    var pm = ReactDOM.findDOMNode(this.refs.popupRefMarker);
    var pr = ReactDOM.findDOMNode(this.refs.popupRefRMarker);

    var s = window.getComputedStyle(p);
    var ptop    = parseInt(s.top);
    var pleft   = parseInt(s.left);
    var pwidth  = parseInt(s.width);
    var pheight = parseInt(s.height);

    if (pm.style.visibility == 'visible') { 
        //-- pop out to the right, use marker left to the popup 
        var s = window.getComputedStyle(pm);
    } else {
        //-- pop out to the left, use marker right to the popup 
        var s = window.getComputedStyle(pr);
    }
    var pmtop    = parseInt(s.top);
    var pmleft   = parseInt(s.left)+5;
    var pmwidth  = parseInt(s.width)-5;
    var pmheight = parseInt(s.height);

    if (
        (    ev.pageX > pleft && ev.pageX < (pleft + pwidth + 5)
          && ev.pageY > ptop  && ev.pageY < (ptop  + pheight) 
        )
        ||
        (    ev.pageX > pmleft && ev.pageX < (pmleft + pmwidth)
          && ev.pageY > pmtop  && ev.pageY < (pmtop  + pmheight) 
        )

    ) {
        // console.log('still inside popup window:  keep it open!');
    } else {

        ['mouseover-popup-marker','mouseover-popup-rmarker',
         'mouseover-popup-content','mouseover-popup-table',
         'mouseover-popup-image'
        ].forEach(function(cls) {
            var elems = document.getElementsByClassName(cls);
            for (var i=0; i < elems.length; i++) {
              elems[i].style.visibility = 'collapse';
              elems[i].style.opacity = '0';
              elems[i].style.transition = 'opacity 1s';
            }
        });
    }
  }


  render() {

    var field = this.props.field || "";

    var emptyPopup = true;

    if (this.props.materialNo && this.props.materialNo !== '') {
        var image = <ProductImage materialNo={this.props.materialNo} forPopup={true} />;
        emptyPopup = false;
    }

    var indicator= <span></span>
    if (this.props.indicatorFlag && this.props.indicatorFlag == 1) {
       indicator = <span style={{ color:"#0086c6", marginLeft:"2px"}}>&#8226;</span>
    }

    if (this.props.popupContent && this.props.popupContent != null ) {
 
       var content = this.props.popupContent
       emptyPopup  = false;       

    }
    if (this.props.tableContent && this.props.tableContent != null ) {
 
       var content = <table className="mouseover-popup-table" ref='popupRefTable'>
                       {this.props.tableContent}
                       {this.props.tableFooter}
                     </table>

       emptyPopup  = false;       

    } else {

        var keys = [];
        var values = [];
        var popupRows = [];

        if (this.props.keys !== undefined)
          keys = this.props.keys;

        if (this.props.values !== undefined)
          values = this.props.values;

        for (var i = 0; i < values.length; i++) {
          keys.length > 0
            ? popupRows.push( <tr key={this.props.field + i}>
                                <th>{keys[i]}</th>
                                <td>{values[i]}</td>
                              </tr>
                            )
            : popupRows.push( <tr key={this.props.field + i}>
                                <td>{values[i]}</td>
                              </tr>
                            )
        }
        var content = <table className="mouseover-popup-table" ref='popupRefTable'>
                         <tbody>
                            {popupRows}
                         </tbody> 
                      </table>

        if (values.length != 0) {
            emptyPopup = false; 
        }  

    }
    if (field == "") {   
        emptyPopup = true;
    } 
 
    return (
      emptyPopup
        ? ( <span>{field}</span> )
        : (  
            <span className="mouseover-popup">
              <span onMouseOver={this.onMouseOver.bind(this)}
                    onMouseOut={this.onMouseOut.bind(this)}
              >
                {field} {indicator}
              </span>
              <div  className="mouseover-popup-marker"  ref='popupRefMarker'></div>
              <div  className="mouseover-popup-rmarker" ref='popupRefRMarker'></div>
              <span className="mouseover-popup-content" ref='popupRef'
                    onMouseOut={this.onMouseOut.bind(this)}
              >                
                {content}
                <span className="mouseover-popup-image" ref='popupRefImage'>
                  {image}
                </span>
              </span>
            </span>
          )
    )
  }
}
export class SettingsModal extends React.Component {

  constructor(props) {
    super(props);

    this.handleSelectColumns     = this.handleSelectColumns.bind(this);
    this.handleRemoveColumns     = this.handleRemoveColumns.bind(this);
    this.handleShiftColumns      = this.handleShiftColumns.bind(this);
    this.handleSubmitToUserSettings    = this.handleSubmitToUserSettings.bind(this);
    this.handleCloseCustomizationModal = this.handleCloseCustomizationModal.bind(this);
  }

  handleCloseCustomizationModal(e) {
    this.props.onClose && this.props.onClose(e);
  };

  handleSubmitToUserSettings(e) {
    //check comment on handleSelectColumns
  }

  handleSelectColumns (field, available, selected) {
    this.props.selectColumns(field, available, selected);
    //TODO maybe dont pass directly and create an interim object until "save" is clicked
  }

  handleRemoveColumns (field, available, selected) {
    this.props.removeColumns(field, available, selected);
    //TODO maybe dont pass directly and create an interim object until "save" is clicked
  }

  handleShiftColumns (field, selected, direction) {
    this.props.shiftColumns(field, selected, direction);
    //TODO maybe dont pass directly and create an interim object until "save" is clicked
  }

  render() {

    if (!this.props.showCustomizeModal) {
      return null;
    }

    return (

      <form className="form-horizontal" role="form" id="customizationModalForm" action="">
        <div className="modal" id="customizationModal" tabIndex="-1" style={{display: "inline"}}  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-lg" style={{ width: "110ex" }}>
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.handleCloseCustomizationModal}>x</button>
                <h3 className="modal-title" id="customizationModalHeading">{T('Customization')}</h3>
              </div>
              <div className="modal-body" style={{ height:"51ex" }} >
                <div className="form-group" style={{ margin: "0 -10px 0 -10px"}} >
                  <div className="col-sm-12">

                    <CustomizeColumns   selectedColumns={this.props.selectedColumns} 
                                        availColumns={this.props.availableColumns}
                                        selectColumns={this.handleSelectColumns}
                                        removeColumns={this.handleRemoveColumns} 
                                        shiftColumns={this.handleShiftColumns}
                                        showValues={this.props.showValues}
                                        translationPrefix={this.props.translationPrefix}/>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {/*<button type="button" onClick={this.handleSubmitToUserSettings} className="btn btn-danger">Save</button>*/}
                <button type="button" onClick={this.handleCloseCustomizationModal} className="btn btn-info">{T('Close')}</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    )
  }
}

class CustomizeColumns extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      shiftMode: false,
      columnToShift: null
    };

    this.handleSelectColumn  = this.handleSelectColumn.bind(this);
    this.handleRemoveColumn  = this.handleRemoveColumn.bind(this);
    this.handleShiftColumns  = this.handleShiftColumns.bind(this);
    this.handleShiftMode     = this.handleShiftMode.bind(this);
  }

  handleShiftColumns(e) {
    if (this.state.shiftMode) {

      var shiftDirection
      if (e.currentTarget.name == "up") {
        shiftDirection = -1
      } else if (e.currentTarget.name == "down") {
        shiftDirection = 1
      } else {
        console.log("error: handleShiftColumns ",e)
      }

      this.props.shiftColumns(this.state.columnToShift, this.props.selectedColumns, shiftDirection)
    }
    e.preventDefault();    
  }

  handleShiftMode(e) {
    this.setState({shiftMode: !this.state.shiftMode})
    e.preventDefault();
  }

  handleRemoveColumn(e) {
    if (!this.state.shiftMode) {
      this.props.removeColumns(e.target.value, this.props.availColumns, this.props.selectedColumns)
    } else {
      this.setState({
        columnToShift: e.target.value,
      })      
    }
    e.preventDefault();
  }

  handleSelectColumn(e) {
    if (!this.state.shiftMode) {
      this.props.selectColumns(e.target.value, this.props.availColumns, this.props.selectedColumns)
    } else {
      this.setState({
        columnToShift: e.target.value,
      })      
    }
    e.preventDefault();
  }

  render() {

    var showValues = this.props.showValues;
    var translationPrefix = this.props.translationPrefix;
    var selectedColumns = this.props.selectedColumns.map(function(col) {
        var isDisabled = false;
        var ddLabel = DD(col.internalName);
        var colValue = ddLabel.dd_label;

        if (col.frozen) {
          isDisabled = "true";
        }
        if (showValues) {
          colValue = colValue + " -- " + col.value;
        }
        var uniqueKey = 'sel_' + col.internalName;
        return <option disabled={isDisabled ? "disabled" : false} key={uniqueKey} value={col.internalName}>{colValue}</option>;
    });

    var availableColumns = this.props.availColumns.map(function(col) {
      var uniqueKey = 'avail_' + col.internalName;
      var ddLabel = DD(col.internalName);
      var colValue = ddLabel.dd_label;

      if (showValues) {
        colValue = colValue + " -- "  + col.value;
      }
      return <option key={uniqueKey} value={col.internalName}>{colValue}</option>;
  });

    if (this.state.shiftMode) {
      var style = null;
    } else {
      var style = {"borderColor": "#c8c8c8", "backgroundColor": "#c8c8c8"};
    }

    return (
      <div className="widget-customization"> 
        <table style={{width: "100%", "margin":"0"}}>
          <tbody>
          <tr> 
            <td className="col-selection">
              <div>
                <header className="header-col-selection">Selected Columns</header>
                <select className="selection-list" defaultValue="dummy" onClick={this.handleRemoveColumn} size="14" ref="selectedColumnList">
                  <option disabled value="dummy" > -- click to remove -- </option>
                  {selectedColumns}
                </select>
              </div> 
            </td>  
            <td align="center" className="col-actions">
              <button className="btn btn-primary" onClick={this.handleShiftMode}><i  className="glyphicon glyphicon-edit"/></button>
              <br/>
              <br/>
              <button className="btn btn-primary" style={style} name="up" onClick={this.handleShiftColumns} disabled={this.state.shiftMode ? null : true} ><i className="glyphicon glyphicon-arrow-up"/> </button>
              <br/>
              <br/>
              <button className="btn btn-primary" style={style} name="down" onClick={this.handleShiftColumns} disabled={this.state.shiftMode ? null : true} ><i className="glyphicon glyphicon-arrow-down"/></button>
            </td>      
            <td className="col-selection">
              <div>
                <header className="header-col-selection secondary">Available Columns</header>  
                <select className="selection-list AvailableColumnSelectBox" defaultValue="dummy" onClick={this.handleSelectColumn} size="14" ref="availableColumnList">
                  <option disabled value="dummy" > -- click to add -- </option>
                  {availableColumns}                                                                                        
                </select>
              </div>
          </td>                                                                                                                       
          </tr>
          </tbody>
          </table>
        </div>
    );
  }

}

//------------------------------------------------------------------------
//  FieldsCustomizer
//
//------------------------------------------------------------------------
export class FieldsCustomizer extends React.PureComponent {

  constructor(props) {
      super(props);   
      this.state = {
          selectedCols: this.props.selectedColumns
      }
      this.handleSave      = this.handleSave.bind(this);
      this.handleCancel    = this.handleCancel.bind(this);
      this.colSelectorStd  = this.colSelectorStd.bind(this);
      this.colSelectorUp   = this.colSelectorUp.bind(this);
      this.colSelectorDown = this.colSelectorDown.bind(this);
      this.colSelectorAdd  = this.colSelectorAdd.bind(this);
      this.colSelectorRem  = this.colSelectorRem.bind(this);
  }

  handleSave() {
      console.log('handleSave', this.state.selectedCols);
      if (this.props.onChange) {
          this.props.onChange([... this.state.selectedCols]);
      }
  }

  handleCancel() {
      console.log('handleCancel');
      // restore to initial given set of fields
      this.setState({
          selectedCols: [... this.props.selectedColumns ]
      });
      if (this.props.onCancel) {
          this.props.onCancel();
      }
  }

  colSelectorStd() {
      console.log('colSelectorStd')
      this.setState({
          selectedCols: [... this.props.standardColumns ]
      });
  }

  colSelectorUp() {
      console.log('colSelectorUp')
      var selCols = ReactDOM.findDOMNode(this.refs.selectedColumnList);  
      var options = selCols && selCols.options;  
      var selected = [];
      var lockedRowsIdx;

      //In BMT we have
      if (this.props.caller == "BMT" && UserSettings.tenant == "HPICS"){
        lockedRowsIdx = 3;
      } else {
        lockedRowsIdx = 2;
      }

      if (this.props.lockedRows) {
        lockedRowsIdx = parseInt(this.props.lockedRows);
        lockedRowsIdx++
      }

      for (var i = lockedRowsIdx, iLen = options.length; i < iLen; i++) {
          if (options[i].selected) {
              selected.push(i);
          }
      }
      console.log('colSelectorUp selected=', selected);


      var newSelCols = [ ...  this.state.selectedCols];
      
      for (i = 0, iLen = selected.length; i < iLen; i++) {
          var index = selected[i];                  

          if (index < 1) {
                break;
          }

          var temp = newSelCols[index-1];
          newSelCols[index-1] = newSelCols[index];
          newSelCols[index] = temp;

          newSelCols[index-1].selected = true;
          newSelCols[index  ].selected = false;
      }
      console.log('colSelectorUp new=', newSelCols);
      this.setState({
          selectedCols: newSelCols
      });
  }

  colSelectorDown() {
      console.log('colSelectorDown')

      var selCols = ReactDOM.findDOMNode(this.refs.selectedColumnList);  
      var options = selCols && selCols.options;  
      var selected = [];
      var lockedRowsIdx;

      if (this.props.caller == "BMT" && UserSettings.tenant == "HPICS"){
        lockedRowsIdx = 2;
      } else {
        lockedRowsIdx = 1;
      }

      if (this.props.lockedRows) {
        lockedRowsIdx = parseInt(this.props.lockedRows);
      }

      for (var i = lockedRowsIdx, iLen = options.length; i < iLen; i++) {
          if (options[i].selected) {
              selected.push(i);
          }
      }
      console.log('colSelectorDown selected=', selected);


      var newSelCols = [ ...  this.state.selectedCols];

      for (i = selected.length - 1, iLen = 0; i >= iLen; i--) {
          var index = selected[i];                  

          if (index == (options.length - 1) ) {
                break;
          }

          var temp = newSelCols[index];
          newSelCols[index] = newSelCols[index+1];
          newSelCols[index+1] = temp;

          newSelCols[index+1].selected = true;
          newSelCols[index  ].selected = false;
      }
      console.log('colSelectorDown new=', newSelCols);
      this.setState({
          selectedCols: newSelCols
      });
  }
  
  colSelectorAdd() {
      console.log('colSelectorAdd');
      var name = "name";
      var fieldIdent = "value";
      if (this.props.caller == "OSV") {
        name = "internalName"
        fieldIdent = "internalName";
      }

      var sel = ReactDOM.findDOMNode(this.refs.availableColumnList);

      var newSelCols  = [];
      var cutOff      = false;
      if (this.props.caller == "BMT" && this.state.selectedCols.length > 49) {
        newSelCols = this.state.selectedCols.slice(0, 48);
        cutOff = true;
      } else {
        newSelCols = [ ...  this.state.selectedCols];
      }

      var self = this;
      for(var i=0; i < sel.length; i++) {
          var opt = sel[i];
          if (opt.selected) {
              opt.selected = false;
              var found = false;   
              for (var j=0; j < newSelCols.length; j++) {
                  if (newSelCols[j][fieldIdent] == self.props.availableColumns[i][fieldIdent]) {
                      found = true;                     
                  }                    
              }
              // prevent re-adding multiple times
              if (!found) {            
                  newSelCols.push({
                      [name]: self.props.availableColumns[i][name],
                      value : self.props.availableColumns[i].value,
                      selected: false
                  });          
              }    
          }
      }
      console.log('colSelectorAdd new=', newSelCols);
      if (this.props.caller == "BMT" && newSelCols.length > 49) {
        toast.error('limit of 50 columns reached!');
        console.log('colSelectorAdd limit reached=', newSelCols);
      } else {
        if (cutOff) {
          toast.info('Warning: some columns have been deleted, because they exceed the maximum allowed limit (50).');
        }
        this.setState({
          selectedCols: newSelCols
        });
      }
  }

  colSelectorRem() {
      console.log('colSelectorRem')
      var selCols = ReactDOM.findDOMNode(this.refs.selectedColumnList);  
      var options = selCols && selCols.options;  

      var newSelCols = [ ...  this.state.selectedCols];

      var lockedRowsIdx;

      if (this.props.caller == "BMT" && UserSettings.tenant == "HPICS"){
        lockedRowsIdx = 2;
      } else {
        lockedRowsIdx = 1;
      }

      if (this.props.lockedRows) {
        lockedRowsIdx = parseInt(this.props.lockedRows);
      }

      for(var i = selCols.length-1; i >= lockedRowsIdx; i--) {
          var opt = selCols[i];
          if (opt.selected) {
              newSelCols.splice(i, 1);  
          }
      }
      console.log('colSelectorRem new=', newSelCols);
      this.setState({
          selectedCols: newSelCols
      });
  }

  render() {
      var showValues = this.props.showValues;
      var fieldIdentifier = "value";
      var name            = "name";
      if (this.props.caller == "OSV") {
        fieldIdentifier = "internalName"
        name = "internalName"
      }

      var standardColumns = this.props.standardColumns.map(function(col) {
        var ddLabel = DD(col[name]);
        var colValue = ddLabel.dd_label;

        if (showValues) {
          colValue = colValue + " -- " + col.value;
        }

        var uniqueKey = 'std_' + col[fieldIdentifier];
        return <option key={uniqueKey} value={col[fieldIdentifier]}>{colValue}</option>;
      });
      var selectedColumns = this.state.selectedCols.map(function(col) {
        var isDisabled = false;
        var ddLabel = DD(col[name]);
        var colValue = ddLabel.dd_label;

        if (col.frozen) {
          isDisabled = "true";
        }
        if (showValues) {
          colValue = colValue + " -- " + col.value;
        }

        var uniqueKey = 'std_' + col[fieldIdentifier];

        return <option disabled={isDisabled ? "disabled" : false} key={uniqueKey} value={col[fieldIdentifier]}>{colValue}</option>;
      });
      var self = this;
      var availableColumns = this.props.availableColumns.sort(function(colA, colB) {
        var colALabel = DD(colA[name]), colBLabel = DD(colB[name]);
        if (colALabel.dd_label.toLowerCase() < colBLabel.dd_label.toLowerCase()) return -1;
        if (colALabel.dd_label.toLowerCase() > colBLabel.dd_label.toLowerCase()) return 1;
        return 0;
      }).map(function(col) {
        var ddLabel = DD(col[name]);
        var colValue = ddLabel.dd_label;

        if (showValues) {
          colValue = colValue + " -- " + col.value;
        }
        var found = false;
        for (var i=0; i< self.state.selectedCols.length; i++) {
            if (self.state.selectedCols[i][fieldIdentifier] == col[fieldIdentifier]) {
                found = true;
            }
        }                
        var uniqueKey = 'std_' + col[fieldIdentifier];
        if (found) {
            return <option key={uniqueKey} value={col[fieldIdentifier]} disabled>{colValue}</option>;
        } else {
            return <option key={uniqueKey} value={col[fieldIdentifier]}>{colValue}</option>;
        }
      });

      var standardColumnsLabel    = "";
      var standardColumnsButtons  = "";
      var standardColumnsSpacing  = "";
      var labelStyle = {
        backgroundColor : "#0096d6", 
        color           : "white",
        padding         : "2px 8px 2px 8px", 
        width           : "50%", 
        whiteSpace      : "nowrap"
      }

      if (standardColumns.length == 0) {
        standardColumns = "";
      } else {
        labelStyle.width = "29%";
        standardColumnsSpacing = <td></td>
        standardColumnsLabel = <td style={labelStyle}>Standard Columns</td>
        standardColumns = <td>
                            <select multiple="1" size="14" ref="standardColumnList" style={{"width": "100%"}}>
                              {standardColumns}
                            </select>          
                          </td>

        standardColumnsButtons = <td align="center" style={{"padding":"3px 3px 3px 6px", "maxWidth": "50px", "width":"50px"}}>
                                  <button className="btn btn-primary" onClick={this.colSelectorStd}  ><i  className="glyphicon glyphicon-forward"/></button>
                                 </td>        
      }

      return (
      <div className="modal" style={{ "display": "block"}}>
        <div className="modal-dialog modal-lg" style={{ "width": "900px" }} >
            <div className="modal-content">
                <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal"  onClick={this.handleCancel} aria-hidden="true">x</button>
                    <h3 className="modal-title">Customize Columns for '{this.props.templateName}'</h3>
                </div>                                                                                                    
                <div className="modal-body" style={{ "height":"370px", "overflow":"auto", "maxHeight": "370px"}}>  
                  <br/>                                                                                          
                  <table style={{"width": "100%", "margin":"0px"}}>
                  <tbody>
                  <tr>  
                      {standardColumnsLabel}
                      {standardColumnsSpacing}
                      <td style={labelStyle}>Selected Columns</td>
                      <td></td>
                      <td style={labelStyle}>Available Columns</td>
                  </tr>
                  <tr> 
                    {standardColumns}
                    {standardColumnsButtons}
                    <td>  
                      <select multiple="1" size="14" ref="selectedColumnList" style={{"width": "100%", "boxShadow": "4px 6px 20px #999"}}>
                        {selectedColumns}
                      </select>
                    </td>  
                    <td align="center" style={{"padding":"3px 4px 3px 6px", "maxWidth": "50px", "width":"50px"}}>
                      <button className="btn btn-primary" onClick={this.colSelectorUp}><i  className="glyphicon glyphicon-arrow-up"/></button>
                      <br/>
                      <br/>
                      <button className="btn btn-primary" onClick={this.colSelectorDown}><i  className="glyphicon glyphicon-arrow-down"/></button>
                      <br/>                                                                                                                       
                      <br/>
                      <br/>
                      <br/>
                      <button className="btn btn-primary" onClick={this.colSelectorAdd}><i  className="glyphicon glyphicon-arrow-left"/></button> 
                      <br/>
                      <br/>
                      <button className="btn btn-primary" onClick={this.colSelectorRem}><i  className="glyphicon glyphicon-arrow-right"/></button>
                    </td>                                                                                                                             
                    <td>  
                      <select multiple="1" size="14" ref="availableColumnList" className="AvailableColumnSelectBox" style={{"width": "100%"}}>
                        {availableColumns}                                                                                        
                      </select>
                    </td>
                  </tr>
                  </tbody>
                  </table> 
                </div>
                <div className="modal-footer">
                    <button type="button" onClick={this.handleSave}   className="btn btn-primary">Save</button>
                    <button type="button" onClick={this.handleCancel} className="btn btn-info">Cancel</button>
                </div>
            </div>
        </div>
      </div>
      )
  }
}

export class SimpleDataTable extends React.Component {

  constructor(props) {
    super(props);
    this.generateChildRow = this.generateChildRow.bind(this);
    this.rowToggleHandler = this.rowToggleHandler.bind(this);
  };

  componentDidMount() {

  }

  // arrayCompare(array1, array2) {
  //   return ((Array.isArray(array1) && Array.isArray(array2)) && (array1.length === array2.length) && (array1.every((val, index) => val === array2[index])));
  // }

  rowToggleHandler(e) {
    //console.log(e);
    const currentEl = e.currentTarget;
    const currentTr = currentEl.parentElement;
    const nextRow = currentTr.nextSibling;
    if (nextRow.className.indexOf('row-collapsed') < 0) {
      nextRow.classList.add('row-collapsed');
      currentTr.classList.add('state-collapsed');
    } else {
      nextRow.classList.remove('row-collapsed');
      currentTr.classList.remove('state-collapsed');
    }
  }

  generateChildRow(row, tbody) {
    const rowArr = (row instanceof Array) ? row : [row]
    const rowData = [];
    const nestedHeaderStyle = {
      backgroundColor: "#bfbfbf",
      fontWeight: "normal",
      color: "white"
    };
    rowArr.forEach(row => {
    row.parentRowData.map((rowItem, i) => {
      if (i === 0) {
        // if first cell then add 'chevron' icon 
        rowData.push(<td className="toggle-anchor"
          onClick={this.rowToggleHandler}
        >
          <i style={{ "color": "#0096d6", "fontSize": "10px" }} className="glyphicon glyphicon-chevron-down" /> &nbsp; {rowItem}
        </td>)
      } else {
        //keep below code, maybe in future we need to handle raw "strings"
        //rowData.push(<td>{rowItem}</td>)
        rowData.push(rowItem)
      }
      return rowItem;
    })
    // push data of parent row 
    tbody.push(<tr className={"state-collapsed toggle-header-row " + ("ncols-" + row.parentRowData.length)}>{rowData}</tr>);

    const tbodyInner = [];
    // frame header of inner tbody
    if (row.header) {
      const innerHeaderRowData = [];
      var dataHeaderCountOffset = row.header.length - 3;
      row.header.map((rowItem, i) => {
        if (i >= dataHeaderCountOffset) {
          innerHeaderRowData.push(<th style={nestedHeaderStyle} className="inner-th" ><DDLabel field={rowItem} forceAlign="right" /></th>)
        } else {
          innerHeaderRowData.push(<th style={nestedHeaderStyle} className="inner-th" ><DDLabel field={rowItem} /></th>)
        }
        return rowItem;
      })
      tbodyInner.push(<tr className={("ncols-" + innerHeaderRowData.length)}>{innerHeaderRowData}</tr>)
    }
    if (row.data) {
      row.data.map((innerRow, i) => {
        if (innerRow instanceof Array) {
          tbodyInner.push(<tr className={"level-" + i}>{SimpleDataGrid_formatRow(false, false, 0, 0, [], innerRow, "", [], "")}</tr>);
        } else if (innerRow.parentRowData !== undefined) {
          this.generateChildRow(innerRow, tbodyInner);
        }
      })
    }

    tbody.push(<tr className="row-collapsed">
      <td colSpan={row.parentRowData.length} style={{"paddingLeft":"10px"}}>
        <div className="inner-table-wrraper" style={{"backgroundColor":"#e3e3e3"}}><table className="table-inner"><tbody className="tbody-inner">{tbodyInner}</tbody></table></div>
      </td>
    </tr>)

  })
    return tbody;
  }

  data2table(data) {
    let headerRowHtml = [];
    let bodyHtml = [];

    const tableBodyStyle = {
      backgroundColor: "#eee"
    }

    const groupHeaderStyle = {
      backgroundColor: "#0095d6",
      color: "#fff"
    };

    const nestedHeaderStyle = {
      backgroundColor: "#9d9d9d",
      fontWeight: "normal"
    };

    const nestedBodyStyle = {
      borderBottom: "4px solid #aaa",
      width: "100%",
      backgroundColor: "#fff"
    };

    const diffStyle = {
      backgroundColor: "#9dc668"
    };

    var dataHeaderCountOffset = data.header.length - 3;

    data.header.forEach((entry, index) => {
      if (typeof data.noformat !== 'undefined' && data.noformat.includes(entry))
        headerRowHtml.push(<th>{entry}</th>);
      else if (index >= dataHeaderCountOffset) {
        headerRowHtml.push(<th><DDLabel field={entry} forceAlign="right" /></th>);
      } else {
        headerRowHtml.push(<th><DDLabel field={entry} /></th>);
      }
    });

    data.body.forEach((group, iGroup) => {

      if (group.group !== "")
        bodyHtml.push(<tr style={groupHeaderStyle}><td colSpan="99">{group.group}</td></tr>); //group label

      group.body.forEach((groupRow, iGroupRow) => {
        let groupRowHtml = [];
        let isTable = false;
        let nestedHeaderMap = [];

        if (groupRow.hasOwnProperty("header")) {
          isTable = true;
          let nestedHeaderColHtml = [];
          var groupRowHeaderCountOffset = groupRow.header.length - 3;
          groupRow.header.forEach((nestedHeaderCol, index) => {
            if (typeof groupRow.noformat !== 'undefined' && groupRow.noformat.includes(nestedHeaderCol))
              nestedHeaderColHtml.push(<th>{nestedHeaderCol}</th>);
              else if (index >= groupRowHeaderCountOffset) {
                nestedHeaderColHtml.push(<th><DDLabel field={nestedHeaderCol} forceAlign="right"/></th>);
              } else {
                nestedHeaderColHtml.push(<th><DDLabel field={nestedHeaderCol} /></th>);
              }
            nestedHeaderMap.push(nestedHeaderCol);
          });
          groupRowHtml.push(<thead style={nestedHeaderStyle}><tr>{nestedHeaderColHtml}</tr></thead>);
        };

        if (groupRow.hasOwnProperty("body")) {
          isTable = true;
          let nestedBodyHtml = [];
          const diffHighlight = groupRow.diff;

          if (diffHighlight == null || diffHighlight === "") {
            groupRow.body.forEach(nestedBodyRow => {
              let nestedBodyColHtml = [];
              nestedBodyRow.forEach(nestedBodyCol => {
                nestedBodyColHtml.push(<td>{nestedBodyCol}</td>);
              });
              nestedBodyHtml.push(<tr>{nestedBodyColHtml}</tr>);
            });
          } else {
            let prevRowData = [];
            const diffHighlightCustom = groupRow.diffCustom;

            //when we find commit history rows having the same timestamp, create a parent/child releation so that the children can be hidden in the commit view.
            var parentChildGroup = [];
            var childElements = [];
            for (var index = 0; index < groupRow.body.length; index++) {

              if ((groupRow.body[index+1] && groupRow.body[index+1][1]) && groupRow.body[index][1] == groupRow.body[index+1][1]) {
                childElements.push({rowIndex: groupRow.body[index], cat: "child"})
                parentChildGroup.push({rowIndex: groupRow.body[index], cat: "child"})
              } else {
                parentChildGroup.push({rowIndex: groupRow.body[index], cat: "parent", childElements:childElements})
                childElements = [];
              }
              
            }
            groupRow.body.parentChildGroup = parentChildGroup;

            groupRow.body.forEach((eventRow, iEventRow) => {
              let nestedBodyColHtml = [];

              eventRow.forEach((eventCol, iEventCol) => {
                let cellStyle = {};
                let cellClass = "";
                const columnName = nestedHeaderMap[iEventCol];

                // different to previous row
                if (prevRowData[iEventCol] !== eventCol) {
                  if ((iEventRow > 0 && diffHighlight.includes(columnName)) || (diffHighlightCustom.includes(iEventRow + ":" + iEventCol))) {
                    cellClass = "commit_diff";
                    cellStyle = diffStyle;
                  }
                }

                nestedBodyColHtml.push(<td className={cellClass} style={cellStyle}>{eventCol}</td>);
              });

              var childRows = [];
              var parentRows = [];
              var skipFlag = false;
              for (var i = 0; i < groupRow.body.parentChildGroup.length; i++) {

                if (groupRow.body.parentChildGroup[i].rowIndex[0] == eventRow[0]) {

                  if (groupRow.body.parentChildGroup[i].cat == "child") {
                    skipFlag = true;
                    break
                  }

                  if (groupRow.body.parentChildGroup[i].childElements.length > 0) {
                    for (var x = 0; x < groupRow.body.parentChildGroup[i].childElements.length; x++) {
                      childRows.push(groupRow.body.parentChildGroup[i].childElements[x].rowIndex);
                    }
                  }
                  //instead of passing over raw TD values, we pass preformatted react style TD objects (because of diff rule)
                  //parentRows.push(groupRow.body.parentChildGroup[i].rowIndex)
                  parentRows.push(nestedBodyColHtml)
                
                } 
                 
              } 

              if (skipFlag) {
                return
              }
              
              if (parentRows.length > 0) {

                var nestedTableObj;
                var parentChildGroupObj = {
                  data : childRows,
                  parentRowData: parentRows[0],
                  header: groupRow.header
                }

                if (childRows.length == 0) {
                  nestedTableObj = <tr>{nestedBodyColHtml}</tr>
                } else {
                  nestedTableObj = this.generateChildRow(parentChildGroupObj, [])
                }
                nestedBodyHtml.push(nestedTableObj);
          
              } else {
                nestedBodyHtml.push(<tr>{nestedBodyColHtml}</tr>);
              }
              
              prevRowData = eventRow;
            });
          };

          groupRowHtml.push(<tbody style={nestedBodyStyle}>{nestedBodyHtml}</tbody>);
        };

        if (isTable) {
          bodyHtml.push(<tr><td colSpan="99"><table>{groupRowHtml}</table></td></tr>);
        } else {
          groupRow.forEach(groupRowCol => {
            groupRowHtml.push(<td>{groupRowCol}</td>);
          });
          bodyHtml.push(<tr>{groupRowHtml}</tr>);
        }
      });
    });

    return (<table className="grid-container-table table"><thead><tr>{headerRowHtml}</tr></thead><tbody style={tableBodyStyle}>{bodyHtml}</tbody></table>);
  }

  render() {
    return this.data2table(this.props.data);
  }
}

export class DDLabel extends React.Component {

  constructor(props) {
    super(props);

    this.getBaseUrl = this.getBaseUrl.bind(this);
    this.genPopupContent = this.genPopupContent.bind(this);
    this.ddLabelRef = React.createRef();
  }

  getBaseUrl() {
    return typeof GlobalUserSettings != 'undefined'
      ? GlobalUserSettings.config.links.LegacyIntURL.replace(/\/os\/.+/,'')
      : ''
  }

  genPopupContent(ddLabel) {
    const width = 75;
    var contentClass = ""
    var descClass = ""
    var desc = ddLabel.dd_desc.trim();
    var url = this.getBaseUrl() + "/static/dist/dataDictionary.html?field=" + ddLabel.dd_name;

    if (!desc) {
      desc = "No description available";
      descClass = "dd-label-missing";

    } else if (desc.length > width) {
      contentClass = "dd-label-content";
    }

    if (ddLabel.dd_area == 'ext_widget') {
      return (
        <span>
          <span className={contentClass} style={{paddingLeft: '3px'}}>
            <span className={descClass}>{desc}</span>
          </span>
          <br/>
          <span style={{paddingLeft: '3px'}}><strong>New Ext. Reporting: </strong>{ddLabel.dd_nrep != null ? ddLabel.dd_nrep : 'NA' }</span><br/>
          <span style={{paddingLeft: '3px'}}><strong>Old Ext. Reporting: </strong>{ddLabel.dd_orep != null ? ddLabel.dd_orep : 'NA' }</span>
        </span>
      );
    } else {
      return (
        <span>
          <span className={contentClass} style={{paddingLeft: '3px'}}>
            <span className={descClass}>{desc}</span>&nbsp;&nbsp;
            <a style={{textDecoration: 'none'}} href={url} target="_blank" title="Open in OSS Data Dictionary">
              <i className="glyphicon glyphicon-new-window dd-label-btn"></i>Dictionary&nbsp;
            </a>
          </span>
          <br/>
          <span style={{paddingLeft: '3px'}}><strong>Int. Reporting: </strong>{ddLabel.dd_irep != null ? ddLabel.dd_irep : 'NA' }</span><br/>
          <span style={{paddingLeft: '3px'}}><strong>BMT: </strong>{ddLabel.dd_bmt != null ? ddLabel.dd_bmt : 'NA' }</span>
        </span>
      );
    }
  }

  componentDidMount() {
    if (this.ddLabelRef.current !== undefined && this.ddLabelRef.current) {
      var ddContSize = 100;
      var ddLabelRef = this.ddLabelRef.current;
      var bcr = ddLabelRef.getBoundingClientRect();

      if (this.props.field !== undefined && this.props.field) {
        if (this.props.field.dd_container !== undefined && Number.isInteger(this.props.field.dd_container))
          ddContSize = this.props.field.dd_container;
      }

      var onRightSide = true;
      if (bcr.left > ((window.innerWidth * (ddContSize / 100)) * 0.6)) {
        onRightSide = false;
      }

      if (onRightSide) {
        if (ddLabelRef.style.right === undefined || (ddLabelRef.style.right !== undefined && ddLabelRef.style.right === ''))
          ddLabelRef.style.left = '-7px';
      } else {
        if (ddLabelRef.style.left === undefined || (ddLabelRef.style.left !== undefined && ddLabelRef.style.left === ''))
          ddLabelRef.style.right = '-7px';
      }
    }
  }

  render() {
    if (this.props.field !== undefined && this.props.field) {
      var field = this.props.field;
      var ddLabel = (typeof field === 'string') ? Object.assign({}, DD(field)) : field;

      if (ddLabel.dd_name) {
        var ddPopupContent = this.genPopupContent(ddLabel);
        var ddPopupStyle = {}

        if (["int_widget", "ext_widget"].includes(ddLabel.dd_area)) {
          ddPopupStyle = (ddLabel.dd_align === "right" ? {right:'-7px'} : {left:'-7px'})
        }

        if (this.props.forceAlign == "right" || ddLabel.dd_align != "") {
          ddPopupStyle = {right:'-7px'};
        }

        return (
          <span className="dd-label">
            {ConvertBRs(ddLabel.dd_label)}
            <span className="dd-label-popup" ref={this.ddLabelRef} style={ddPopupStyle}>
              {ddPopupContent}
            </span>
          </span>
        )

      } else {
        return (<span className="dd-label-missing">{ConvertBRs(ddLabel.dd_label)}</span>);
      }
    }
  }
}

export class SpecialCodeDescModal extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      specialCodeDesc: {},
      status: 'L'
    }

    this.handleError = this.handleError.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.fetchSpecialCodeDesc = this.fetchSpecialCodeDesc.bind(this);
  }

  componentDidMount() {
    this.fetchSpecialCodeDesc(this.props.special_codes, this.props.om_system, this.props.tenant)
  }

  handleError(statusText) {
    if (statusText == "error") {
      this.setState({status: 'E'})

    } else if (statusText == "timeout") {
      this.setState({status: 'T'})
    }
  }

  handleModalClose(e) {
    this.props.onClose && this.props.onClose(e);
  }

  fetchSpecialCodeDesc(specialCodes, omSystem, tenant) {

    GET("/os/ws/specialCodeDesc.tcl?sap_system=" + omSystem + "&tenant=" + tenant + "&sc=" + specialCodes.replace(/,/g, ' '), {}, function(res) {
      var specialCodeDesc = {}

      if (res.status == 'S') {
        specialCodeDesc =  {
          header: [
            { name: T('Code') },
            { name: T('Description') }
          ],
          data: res.data.map(function(row) {
            return [
              row.code,
              row.desc
            ]
          })
        }

        this.setState({specialCodeDesc: specialCodeDesc})
      }

      this.setState({status: res.status})

    }.bind(this), this.handleError)
  }

  render() {

    return (
      <div className="modal" style={{"display": "block"}}>
        <div className="modal-dialog modal-lg" style={{"width": "900px"}} >
            <div className="modal-content">
                <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" onClick={this.handleModalClose} aria-hidden="true">x</button>
                    <h3 className="modal-title">{T('Special Code Description')}</h3>
                </div>
                <div className="modal-body" style={{"height":"280px", "overflow":"auto", "maxHeight": "280px"}}>
                  {
                    this.state.status == 'S'
                      ? <SimpleDataGrid header={this.state.specialCodeDesc.header} data={this.state.specialCodeDesc.data} />
                      : <BasicAlert type={this.state.status} />
                  }
                </div>
                <div className="modal-footer">
                    <button type="button" onClick={this.handleModalClose} className="btn btn-primary">Close</button>
                </div>
            </div>
        </div>
      </div>
    )
  }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  //module.exports.ModalTitle     = ModalTitle;
  //module.exports.ModalBody      = ModalBody;
  //module.exports.ModalFooter    = ModalFooter;
  //module.exports.Modal          = Modal;
  module.exports.ModalWithClose = ModalWithClose;
  //module.exports.Tab            = Tab;
  //module.exports.TabBar         = TabBar;
  //module.exports.LabelGrid      = LabelGrid;
  //module.exports.SearchableMultiSelectBox = SearchableMultiSelectBox;
  //module.exports.SimpleDataGrid = SimpleDataGrid;
  //module.exports.QTCPage        = QTCPage;
  //module.exports.OSSMenu        = OSSMenu;
  module.exports.ExternalOSSMenu = ExternalOSSMenu;
  //module.exports.SandyLink      = SandyLink;
  module.exports.HdrFlags       = HdrFlags;
  module.exports.ExportExcel    = ExportExcel;
  //module.exports.DateChooser    = DateChooser;
  //module.exports.exportExcelMaxLimit = exportExcelMaxLimit;
  //module.exports.showAllOrdersMaxLimit = showAllOrdersMaxLimit;

}

export class DropDownButton extends React.Component {

  constructor(props) {
    super(props);
    this.getBaseUrl = this.getBaseUrl.bind(this);
    this.handleUrl = this.handleUrl.bind(this);
  }

  getBaseUrl() {
    return typeof GlobalUserSettings != 'undefined'
      ? GlobalUserSettings.config.links.LegacyIntURL.replace(/\/os\/.+/,'')
      : ''
  }

  handleUrl(url) {
    return () => window.open(url, "menubar=1,resizable=1,width=450,height=450");
  }

  render() {
    const label = this.props.label || 'Download';
    const links = this.props.links || [];
    return (
      <div className="btn-group">
        <button type="button" className="btn btn-primary btn-smallest dropdown-toggle" data-toggle="dropdown" title={T(label)}>
          <i className="glyphicon glyphicon-circle-arrow-down"/>&nbsp;&nbsp;{T(label)}
        </button>
        <ul className="dropdown-menu" role="menu">
          {links.map( (item, i) => {
            return (
               <li key={i}>
                 {item.openInWindow
                 ? (<a onClick = {this.handleUrl(item.href)}>{T(item.label)}</a>)
                 : (item.openInNewTab ? <a href={item.href} target="_blank" download={item.download ? item.download : ''} >{T(item.label)}</a> : 
                 (item.onclick 
                  ? <a onClick={item.onclick}>{T(item.label)}</a> 
                  : (item.disabled ? <a href={item.href} style={{"pointer-events":"none", "opacity":"0.6"}}>{T(item.label)}</a> : <a href={item.href}>{T(item.label)}</a>)
                 ))
                 }
              </li>
            )
          })}
        </ul>
     </div>
    )
  }
}

//----------------------------------------------------------------------
//  Loading -- loading with params size : XS, S, M and L
//             default icon size : M
//----------------------------------------------------------------------
export const Loading = (params) => {
  
  let iconSize = params.size ? params.size : 22;
  if (params.size === 'XS') iconSize = 12;
  if (params.size === 'S') iconSize = 18;
  if (params.size === 'M') iconSize = 22;
  if (params.size === 'L') iconSize = 30;

  var ldStyle = { height: iconSize + 'px', width: iconSize + 'px' }
  var cAStyle = { height: ((iconSize * 2) - 2) + 'px', width: ((iconSize * 2) - 2) + 'px' }
  var fstBStyle = { height: (iconSize - 2) + 'px', width: (iconSize - 2) + 'px', left: '0px', top: '0px' }
  var secBStyle = { height: (iconSize - 2) + 'px', width: (iconSize - 2) + 'px', left: iconSize + 'px', top: '0px' }
  var thrBStyle = { height: (iconSize - 2) + 'px', width: (iconSize - 2) + 'px', left: '0px', top: iconSize + 'px' }
  var fthBStyle = { height: (iconSize - 2) + 'px', width: (iconSize - 2) + 'px', left: iconSize + 'px', top: iconSize + 'px' }

  return (
    <div className="loading" style={ldStyle}>
      <div className="cycle-animation" style={cAStyle}>
        <span id="first-load-block" style={fstBStyle}></span>
        <span id="second-load-block" style={secBStyle}></span>
        <span id="third-load-block" style={thrBStyle}></span>
        <span id="fourth-load-block" style={fthBStyle}></span>
      </div>
    </div>
  );
}

export class AdvancedHyperlink extends React.Component {
  constructor(props) {
    super(props);
    this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  copyToClipboard(url) {
    navigator.clipboard.writeText(url);
    toast.info('URL copied to clipboard');
  }

  render() {
    const url = this.props.url || '';
    const iconStyle = {color: '#0096d6', paddingLeft: '10px', cursor: 'pointer'};

    if (url) {
      return (
        <div>
          <MouseOverPopUp field={url.substring(0, 14) + "..."} keys={[]} values={[url]} />
          <a title="Copy to clipboard" onClick={() => {this.copyToClipboard(url)}}><i className="glyphicon glyphicon-log-in" style={iconStyle}/></a>
          <a title="Open in new tab/window" target="_blank" href={url}><i className="glyphicon glyphicon-new-window" style={iconStyle}/></a>
        </div>
      );
    } else {
      return (
        null
      );
    }
  }
}

export class MassDLInvoiceModal extends React.Component {

  handleCloseCaseModal = e => {
    this.props.onClose && this.props.onClose(e);
  };

  handleSubmitCase = e => {
    e.preventDefault();

    var reportName = e.target.massDLFilename.value = e.target.massDLFilename.value.split(/[\s,]+/).join('_')
    var massDLNos = e.target.massDLNos.value.split(',');
    var self = this;
    var side = "ex"

    if (self.props.caller == 'osv') {
      side = "in"
    }

    axios.post('/os/ossui/v1/' + side + '/massDL/createSerialReport', {
      id: "", 
      name: reportName, 
      description: "", 
      type: e.target.elements.massDLNos.name, 
      values: {
                file: "n/a",
                method: "paste",
                values: massDLNos
              }
    })
    .then(response => {
      var message = response.data.name + " submitted for processing";
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
      self.handleCloseCaseModal({ target : {
                                      name : null,
                                  },
                                });
    })
    .catch(error => {
      toast.error(error.response.statusText, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
  });

  };

  render() {

    if (!this.props.show) {
      return null;
    }

    var orders =  this.props.orders;
    var message = "";
    var massDLNos = "";
    var massDLLimit;
    var massDLLimitWarn;
    var massDLTypeText;
    var massDLField; 

    if (this.props.type == "invoice-pdf") {
      massDLTypeText  = "invoice"
      massDLLimitWarn = 100;
      massDLLimit     = 500; 
      massDLField     = "invoice_no";
    } else if (this.props.type == "pod-docs") {
      massDLTypeText  = "shipment"
      massDLLimitWarn = 50;
      massDLLimit     = 100; 
      massDLField     = "shipment_no";
    } else if (this.props.type == "packing-list") {
      massDLTypeText  = "shipment"
      massDLLimitWarn = 100;
      massDLLimit     = 500; 
      massDLField     = "shipment_no";  
    }

    var uniqueMassDLNos = []

    if (this.props.caller == "osv") {
      massDLField = "shipmentno"
    }

    for (var i = 0; i < orders.length; i++) {
      if (orders[i][massDLField] && orders[i][massDLField] != "") {
        if(uniqueMassDLNos.indexOf(orders[i][massDLField]) === -1) {
          uniqueMassDLNos.push(orders[i][massDLField]);
        }
      }
    } 
    massDLNos = uniqueMassDLNos.join()

    var dontSubmit = false;
    if (uniqueMassDLNos.length > massDLLimitWarn && uniqueMassDLNos.length <= massDLLimit) {
      message = "You selected, " + uniqueMassDLNos.length + " " + massDLTypeText + " numbers. This will take a lot of time!"
    } else if (uniqueMassDLNos.length > massDLLimit) {
      message = "Sorry, only " + massDLLimit + " " + massDLTypeText + " numbers allowed!"
      dontSubmit = true;
    } else if (uniqueMassDLNos.length == 0) {
      message = "Sorry, no valid " + massDLTypeText + " numbers in search result!"
      dontSubmit = true;
    }

    if (message) {
      toast.warn(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
    }

    if (dontSubmit) {
      return null
    }

    return (

      <form className="form-horizontal" onSubmit={this.handleSubmitCase} role="form" id="massDLModalForm" method="post" action="">
        <div className="modal" id="massDLModal" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style={{"display":"block"}}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.handleCloseCaseModal}>x</button>
                <h3 className="modal-title" id="massDLModalHeading">Mass download {massDLTypeText} docs for all found orders</h3>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <div className="col-sm-12">
                    <label>Extract Name:</label>
                    <input className="form-control" id="massDLFilename" name="massDLFilename"></input>
                    <input className="form-control" type="hidden" id="massDLNos" name={this.props.type} value={massDLNos}></input>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-danger">Start Extract</button>
                <button type="button" onClick={this.handleCloseCaseModal} className="btn btn-info">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    )
  }
}

/*------------------------------------------------------------------
|
|   AdvancedFieldCustomizer
|
|      title: (string)       - title for the modal
|      standardList: (array) - standard list of columns
|      selectedList: (array) - user selected list of columns
|      availableList (array) - available list of columns
|      listMapping: (object) - to customize the mapping in the list,
|                              default values are shown below
|                              {
|                                 label: 'label',
|                                 name: 'internalName',
|                                 value: 'value'
|                              }
|      lockedRows: (integer) - no. of starting columns in the
|                              selected list to be frozen
|      maxRows: (integer)    - max no. of columns allowed in the
|                              selected list
|      onChange: (ref)       - reference to parent class function
|                              to save the list
|      onCancel: (ref)       - reference to parent class function
|                              to ignore the changes in the list
|
\-----------------------------------------------------------------*/
export class AdvancedFieldCustomizer extends React.Component {

  constructor(props) {
    super(props);

    this.draggingItem = React.createRef();
    this.dragOverItem = React.createRef();

    this.state = {
      title: this.props.title || "",
      standardList: [],
      selectedList: [],
      availableList: [],
      availableListBkp: [],
      listMapping: this.props.listMapping || {
        label: 'label',
        name: 'internalName',
        value: 'value'
      },
      lockedRows: this.props.lockedRows || 0,
      maxRows: this.props.maxRows || 0,
      showStdList: false,
      hasValue: false
    }

    this.initAFC = this.initAFC.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleDragStart = this.handleDragStart.bind(this);
    this.handleDragEnter = this.handleDragEnter.bind(this);
    this.handleAddRemove = this.handleAddRemove.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleFilterReset = this.handleFilterReset.bind(this);
    this.handleShowStdList = this.handleShowStdList.bind(this);
    this.formatElement = this.formatElement.bind(this);
  }

  componentDidMount() {
    this.initAFC();
  }

  initAFC() {
    var name = this.state.listMapping.name;

    if (this.props.standardList) {
      var standardListCopy = [...this.props.standardList];
      for (var k = 0; k < standardListCopy.length; k++) {
        if (!standardListCopy[k].label) {
          ddElm = DD(standardListCopy[k][name]);
          standardListCopy[k].label = ddElm.dd_label || '';
        }
      }
      this.setState({standardList: standardListCopy});
    }

    if (this.props.selectedList && this.props.availableList) {
      var ddElm = {};
      var selectedListCopy = [...this.props.selectedList];
      var availableListCopy = [...this.props.availableList];

      for (var i = 0; i < availableListCopy.length; i++) {
        availableListCopy[i].free = true;

        if (!availableListCopy[i].label) {
          ddElm = DD(availableListCopy[i][name]);
          availableListCopy[i].label = ddElm.dd_label || '';
        }

        if (availableListCopy[i][this.state.listMapping.value])
          this.setState({hasValue: true});

        for (var j = 0; j < selectedListCopy.length; j++) {
          if (!selectedListCopy[j].label) {
            ddElm = DD(selectedListCopy[j][name]);
            selectedListCopy[j].label = ddElm.dd_label || '';
          }

          if (availableListCopy[i][name] == selectedListCopy[j][name])
            availableListCopy[i].free = false;
        }
      }

      for (i = 0; i < availableListCopy.length; i++) {
        availableListCopy[i].locked = false;
        for (j = 0; j < this.state.lockedRows; j++) {
          if (availableListCopy[i][name] == selectedListCopy[j][name]) {
            availableListCopy[i].locked = true;
          }
        }
      }

      availableListCopy.sort((a,b) => (a[name] > b[name]) ? 1 : ((b[name] > a[name]) ? -1 : 0));
      this.setState({selectedList: selectedListCopy});
      this.setState({availableList: availableListCopy});
      this.setState({availableListBkp: availableListCopy});
    }
  }

  handleReset() {
    var name = this.state.listMapping.name;
    var standardList = [...this.state.standardList];
    var availableListCopy = [...this.state.availableList];
    var availableListBkpCopy = [...this.state.availableListBkp];

    for (var j = 0; j < availableListCopy.length; j++) {
      availableListCopy[j].free = true;
      for (var i = 0; i < standardList.length; i++) {
        if (availableListCopy[j][name] == standardList[i][name]) {
          availableListCopy[j].free = false;
        }
      }
    }

    for (var k = 0; k < availableListBkpCopy.length; k++) {
      availableListBkpCopy[k].free = true;
      for (var i = 0; i < standardList.length; i++) {
        if (availableListBkpCopy[k][name] == standardList[i][name]) {
          availableListBkpCopy[k].free = false;
        }
      }
    }

    this.setState({selectedList: standardList});
    availableListCopy.sort((a,b) => (a[name] > b[name]) ? 1 : ((b[name] > a[name]) ? -1 : 0))
    this.setState({availableList: availableListCopy});
    availableListBkpCopy.sort((a,b) => (a[name] > b[name]) ? 1 : ((b[name] > a[name]) ? -1 : 0))
    this.setState({availableListBkp: availableListBkpCopy});
  }

  handleSave() {
    if (this.props.onChange)
      this.props.onChange([...this.state.selectedList]);
  }

  handleCancel() {
    if (this.props.onCancel)
      this.props.onCancel();
  }

  handleDragStart(e, position) {
    this.draggingItem.current = position;
  }

  handleDragEnter(e, position) {
    this.dragOverItem.current = position;
    var selectedListCopy = [...this.state.selectedList];
    var draggingItemContent = selectedListCopy[this.draggingItem.current];

    selectedListCopy.splice(this.draggingItem.current, 1);
    selectedListCopy.splice(this.dragOverItem.current, 0, draggingItemContent);

    this.draggingItem.current = this.dragOverItem.current;
    this.dragOverItem.current = null;

    this.setState({selectedList: selectedListCopy});
  };

  handleAddRemove(e, item) {
    var name = this.state.listMapping.name;
    var maxRows = this.state.maxRows;
    var selectedListCopy = [...this.state.selectedList];
    var availableListCopy = [...this.state.availableList];
    var availableListBkpCopy = [...this.state.availableListBkp];

    if (item.free) {
      if (maxRows && maxRows > 0 && maxRows == this.state.selectedList.length) {
        toast.error("Limit of " + maxRows + " columns reached.");
        return;
      }

      for (var i = 0; i < availableListCopy.length; i++)
        if (availableListCopy[i][name] == item[name])
          availableListCopy[i].free = false;

      for (var i = 0; i < availableListBkpCopy.length; i++)
        if (availableListBkpCopy[i][name] == item[name])
          availableListBkpCopy[i].free = false;

      selectedListCopy.push(item);

    } else {

      for (var i = 0; i < availableListCopy.length; i++)
        if (availableListCopy[i][name] == item[name])
          availableListCopy[i].free = true;

      for (var i = 0; i < availableListBkpCopy.length; i++)
        if (availableListBkpCopy[i][name] == item[name])
          availableListBkpCopy[i].free = true;

      for (var i = 0; i < selectedListCopy.length; i++)
        if (selectedListCopy[i][name] == item[name])
          selectedListCopy.splice(i, 1);
    }

    this.setState({selectedList: selectedListCopy});
    availableListCopy.sort((a,b) => (a[name] > b[name]) ? 1 : ((b[name] > a[name]) ? -1 : 0))
    this.setState({availableList: availableListCopy});
    availableListBkpCopy.sort((a,b) => (a[name] > b[name]) ? 1 : ((b[name] > a[name]) ? -1 : 0))
    this.setState({availableListBkp: availableListBkpCopy});
  }

  handleFilter() {
    var label = this.state.listMapping.label;
    var name = this.state.listMapping.name;
    var value = this.state.listMapping.value;

    var availableListBkpCopy = this.state.availableListBkp.filter((d) => {
      if (d[value])
        return d[label].toLowerCase().indexOf(this.filter.value.toLowerCase()) !== -1 ||
               d[name].toLowerCase().indexOf(this.filter.value.toLowerCase()) !== -1 ||
               d[value].toLowerCase().indexOf(this.filter.value.toLowerCase()) !== -1
      else
        return d[label].toLowerCase().indexOf(this.filter.value.toLowerCase()) !== -1 ||
               d[name].toLowerCase().indexOf(this.filter.value.toLowerCase()) !== -1
    });

    availableListBkpCopy.sort((a,b) => (a[name] > b[name]) ? 1 : ((b[name] > a[name]) ? -1 : 0))
    this.setState({availableList: availableListBkpCopy});
  }

  handleFilterReset() {
    this.filter.value = "";
    this.handleFilter();
  }

  handleShowStdList() {
    if (this.state.showStdList)
      this.setState({showStdList: false});
    else
      this.setState({showStdList: true});
  }

  formatElement(item) {
    var label = this.state.listMapping.label;
    var name = this.state.listMapping.name;
    var value = this.state.listMapping.value;
    var valMaxL = 55;

    if (item[value] && typeof(item[value]) === 'string' && item[value].length > valMaxL)
      item[value] = item[value].substring(0, valMaxL-1) + "...";


    if (item[value]) {
        return (
          <span>
            <span className="afc-label">{item[label] ? item[label] : ""}</span>
            <span className="afc-name"  title='internal field name'>{item[name]}</span>
            <span className="afc-value" title='actual value'       >{item[value] ? item[value] : ""}</span>
          </span>
        );
    } else {
        return (
          <span>
            <span className="afc-label">{item[label] ? item[label] : ""}</span>
            <span className="afc-name" title='internal field name'>{item[name]}</span>
          </span>
        );
    }

  }

  render() {
    return (
      <div className="modal" style={{ "display": "block"}}>
        <div className="modal-dialog modal-lg" style={{ "width": "900px" }} >
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal"  onClick={this.handleCancel} aria-hidden="true">x</button>
              <h3 className="modal-title">Customize Columns{this.state.title ? ": " + this.state.title : ""}</h3>
            </div>
            <div className="modal-body afc-body">
              <div className="afc-row">
                {
                  this.state.showStdList ?
                    <div className="afc-column">
                      <div className="afc-column-hdr">
                        Standard Columns
                      </div>
                      {
                        this.state.standardList && this.state.standardList.map((item, index) => (
                          <div className={(index < this.state.lockedRows) ? "afc-frozen" : "afc-standard"} key={"d" + index}>
                            {this.formatElement(item)}
                            <div className="afc-badge">
                              {(index+1)}
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  :
                    null
                }
                <div className="afc-column">
                  <div className="afc-column-hdr">
                    Selected Columns
                    <div className="afc-column-sub-hdr">
                      Drag and drop to re-arrange
                    </div>
                  </div>
                  {
                    this.state.selectedList && this.state.selectedList.length <= 0 ?
                      <div className="afc-info-text">
                        To start, add column(s) from the right.
                      </div>
                    :
                      null
                  }{
                    this.state.selectedList && this.state.selectedList.map((item, index) => (
                      (index < this.state.lockedRows) ?
                        <div className="afc-frozen" key={"s" + index}>
                          {this.formatElement(item)}
                          <div className="afc-badge">
                            {(index+1)}
                          </div>
                        </div>
                      :
                        <div className="afc-selected"
                             onDragStart={(e) => this.handleDragStart(e, index)}
                             onDragOver={(e) => e.preventDefault()}
                             onDragEnter={(e) => this.handleDragEnter(e, index)}
                             key={"s" + index}
                             draggable>
                          {this.formatElement(item)}
                          <div className="afc-badge">
                            {(index+1)}
                          </div>
                          <div className="afc-overlay-btn" onClick={(e) => this.handleAddRemove(e, item)}>
                            x
                          </div>
                        </div>
                    ))
                  }{
                    this.state.maxRows && this.state.maxRows > 0 ?
                      <span className="afc-max-rows">
                        Max: {this.state.maxRows}, Left: {this.state.maxRows - this.state.selectedList.length}
                      </span>
                    :
                      null
                  }
                </div>
                <div className="afc-column">
                  <div className="afc-column-hdr">
                    Available Columns
                    <div className="afc-column-sub-hdr">
                      Click to add
                    </div>
                  </div>
                  <div className="afc-reset-btn-wrap">
                    <input type="text" className="form-control afc-filter" id="filter"
                           placeholder={this.state.hasValue ? "Search in names and values..." : "Search..."}
                           ref={(input)=> this.filter = input} onChange={this.handleFilter} />
                    <span onClick={this.handleFilterReset} className="afc-reset-btn">X</span>
                  </div>
                  {
                    this.state.availableList && this.state.availableList.map((item, index) => (
                      (item.locked) ?
                        <div className="afc-frozen afc-hide" key={"a" + index} style={{paddingLeft: '5px'}}>
                          {this.formatElement(item)}
                        </div>
                      :
                        <div className={item.free ? "afc-available" : "afc-not-available afc-hide"}
                             key={"a" + index}
                             onClick={(e) => this.handleAddRemove(e, item)}>
                          {this.formatElement(item)}
                          <div className="afc-overlay-btn">+</div>
                        </div>
                    ))
                  }
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <span style={{'float': 'left'}}>
                <button type="button" onClick={this.handleReset}  className="btn btn-primary">
                  <i className="glyphicon glyphicon-repeat" style={{paddingRight: '5px'}}></i> Reset to Default
                </button>
                {
                  this.state.standardList.length > 0 ?
                    this.state.showStdList ?
                      <button type="button" onClick={this.handleShowStdList}  className="btn btn-primary">
                        <i className="glyphicon glyphicon-eye-close" style={{paddingRight: '5px'}}></i> Hide Standard Columns
                      </button>
                    :
                      <button type="button" onClick={this.handleShowStdList}  className="btn btn-primary">
                        <i className="glyphicon glyphicon-eye-open" style={{paddingRight: '5px'}}></i> Show Standard Columns
                      </button>
                  :
                    null
                }
              </span>
              <button type="button" onClick={this.handleSave}   className="btn btn-primary">Save</button>
              <button type="button" onClick={this.handleCancel} className="btn btn-default">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/*------------------------------------------------------------------
|
|   RefreshOrderInTStore
|
|      lon: (string) - Legacy Order No.
|
\-----------------------------------------------------------------*/
export class RefreshOrderInTStore extends React.Component {

  constructor(props) {
    super(props);
    this.getBaseUrl = this.getBaseUrl.bind(this);
    this.handleUrl = this.handleUrl.bind(this);
    this.handleOrderRefresh = this.handleOrderRefresh.bind(this);
  }

  getBaseUrl() {
    return typeof GlobalUserSettings != 'undefined'
      ? GlobalUserSettings.config.links.LegacyIntURL.replace(/\/os\/.+/,'')
      : ''
  }

  handleUrl(url) {
    fetch(url).then(function(response) {
      if (response.ok)
        toast.success('Successfully added order to refresh queue');
      else
        toast.error('Error occurred while refreshing order in tstore');
    });
  }

  handleOrderRefresh() {
    toast.info('Initiating tstore order refresh ...');
    var url = this.getBaseUrl() + "/os/support/RefreshOrdersInTStore.tcl?main=1&order_numbers=" + this.props.lon;
    this.handleUrl(url);
  }

  render(){
    return (
      <button type="button" className="btn btn-primary btn-smallest" data-toggle="tooltip" data-html="true" onClick={this.handleOrderRefresh}>
        <i className="glyphicon glyphicon-refresh"/>&nbsp;
        {T('Refresh Order in TStore')}
      </button>
    )
  }
}

//----------------------------------------------------------------------
//   Checkbox -- toggle between 0 and 1
//
//----------------------------------------------------------------------
export class Checkbox extends React.Component {
  render() {
    const { checked, onChange } = this.props;

    return (
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
    );
  }
}

//----------------------------------------------------------------------
//   FlexiFilterSearch - Field agnostic, grid search
//                     - Box expands to specified size on hover/focus
//
//----------------------------------------------------------------------
export class FlexiFilterSearch extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isHovered: false,
      isFocused: false,
    }

    this.targetRef = React.createRef();
    this.handleClickReset = this.handleClickReset.bind(this);
  }

  handleClickReset() {
    if (this.targetRef.current) {
      this.targetRef.current.value = "";
    }
    this.setState({ isFocused: false, isHovered: false }, this.props.handleReset);
  }

  render() {

    const { isHovered, isFocused } = this.state;
    const { searchText, handleChange, handleSearch, handleReset } = this.props;
    const showSearchInput = isHovered || isFocused;

    return (
      <div 
        id="FlexiFilterSearch" 
        className={`flexi-search-container ${showSearchInput ? 'flexi-search-container-expanded': ''}`}
        onMouseEnter={() => this.setState({ isHovered: true})}
        onMouseLeave={() => this.setState({ isHovered: false})}
        onFocus={() => this.setState({ isFocused: true})}
      >
        <button className="flexi-search-reset"
          onClick={this.handleClickReset}
          style={showSearchInput ? {'display': 'block'} : {'display': 'none'}}>X</button>
        <input
          ref={this.targetRef}
          type="search"
          className="flexi-search-input"
          style={showSearchInput ? {'display': 'block'} : {'display': 'none'}}
          placeholder="Search across pages..."
          value={searchText}
          onChange={(e) => handleChange(e)}
          onKeyPress={(e) => handleSearch(e)}
        />
        <button className={`flexi-search-btn ${showSearchInput ? 'flexi-search-btn-right': ''}`}
          onClick={(e) => handleSearch(e)}
        >
          <span className="glyphicon glyphicon-search"></span>
        </button>
      </div>
    );
  } 

}

/*------------------------------------------------------------------
|
|   LightWeightDataGrid
|
|   header - Column Labels (array)
|   data - Row(s)/Data (array of array)
|
|   optional:
|   title - Title (string)
|   download - Show download option (true/false)
|   options - Code/Text to embed on the right side of top-bar (string)
|   height - Height of the grid
|   maxHeight - Max height of the grid
|   stretchTo - Stretch to the height of the parent container
|   searchFilter - Show search filter (true/false)
|
|   Note: Pass 'id' as props to avoid unexpected behaviour
|
\-----------------------------------------------------------------*/
export class LightWeightDataGrid extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      currPage: 1,
      rowsPerPage: this.props.pageSize || 100,
      gridData: props.data,
      displayedData: [],
      pageSizeOpt: this.props.pageSizeOpt || [100, 250, 500],
      gridHeight: '55vh',
      searchFilterText: ''
    }

    this.gridRef = React.createRef();
    this.handleDownload = this.handleDownload.bind(this);
    this.paginateData = this.paginateData.bind(this);
    this.goToPage = this.goToPage.bind(this);
    this.handlePageSize = this.handlePageSize.bind(this);
    this.resizeGridHt = this.resizeGridHt.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchFilter = this.handleSearchFilter.bind(this);
    this.handleSearchReset = this.handleSearchReset.bind(this);
    this.highlight = this.highlight.bind(this);
    this.unhighlight = this.unhighlight.bind(this);
    this.highlightMatchedText = this.highlightMatchedText.bind(this);
  }

  componentDidMount() {
    if (!this.props.height && this.props.stretchTo) {
      window.addEventListener('resize', function(event) {
        this.resizeGridHt();
      }.bind(this), true);

      this.resizeGridHt();
    }

    if (this.props.data) {
      this.setState({ gridData: this.props.data }, this.paginateData);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Change in initial data props
    if ( prevProps.data !== this.props.data ) {
      this.setState({ gridData: this.props.data });
    }
    // Change in filtered grid results, reset to page 1
    if ( prevState.gridData !== this.state.gridData ) {
      this.setState({ currPage: 1 }, this.paginateData);
    }
    // Change in Page Settings
    if (
      prevState.currPage    !== this.state.currPage ||
      prevState.rowsPerPage !== this.state.rowsPerPage
    ) {
      this.paginateData();
    }
  }

  handleDownload() {
    let c = this.gridRef.current;
    let tableRef = c.querySelectorAll('.lwdg-table')[0];

    DownloadTableAsShownXLSX(tableRef, this.props.title?.replace(/ /g, '_'));
  }

  paginateData() {
    const { currPage, rowsPerPage } = this.state

    const startIdx = (currPage - 1) * rowsPerPage;
    const endIdx   = startIdx + rowsPerPage;
    const displayedData = this.state.gridData.slice(startIdx, endIdx);

    this.setState({ displayedData }, () => {
      let selector = this.props.id ? `#${this.props.id}` : '#lwdgTableWrapper';
      const tw = document.querySelector(selector);
      tw.scrollLeft = 0;
      tw.scrollTop = 0;
      if (this.props.searchFilter) {
        this.highlightMatchedText();
      }
    });
  }

  goToPage(page) {
    this.setState({ currPage: page });
  }

  handlePageSize(e) {
    let pageSize = e.target.value
    this.setState({currPage: 1, rowsPerPage: parseInt(pageSize, 10)});
  }

  resizeGridHt() {
    if (this.gridRef.current) {
      var c = this.gridRef.current;
      var gridRect = c.getBoundingClientRect();
      var sTo = document.querySelectorAll(this.props.stretchTo)[0];
      var sToRect = sTo.getBoundingClientRect();
      var gridHeight = (sToRect.top - gridRect.top - 1)  + 'px';
      c.style.height = gridHeight;
      this.setState({ gridHeight });
    }
  }

  handleSearchChange(e) {
    this.setState({ searchFilterText: e.target.value });
  }

  handleSearchFilter(e) {
    if (e.type === 'keypress' && e.key !== 'Enter') 
      return;

    let searchText = this.state.searchFilterText.trim();

    if (searchText.length == 0) {
      this.handleSearchReset();
      return;
    }
    let filteredData = this.props.data.filter(row => {
      return row.some(field => {
        if (field && field !== null)
          return field.toString().toLowerCase().search(searchText.toLowerCase()) !== -1;
        return false;
      });
    });

    this.setState({ gridData: filteredData });
  }

  handleSearchReset() {
    this.setState({ gridData: this.props.data, searchFilterText: '' });
  }

  highlight(selector, str, className) {
    const regex = new RegExp(`(${str})`, "gi");
    document.querySelectorAll(selector).forEach((element) => {
      Array.from(element.childNodes).forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && regex.test(node.nodeValue)) {
          const newNodes = node.nodeValue.split(regex).map((part) => {
            if (part.toLowerCase() === str.toLowerCase())  {
              const span = document.createElement('span');
              span.className = className;
              span.textContent = part;
              return span;
            } else {
              return document.createTextNode(part);
            }
          });
          node.replaceWith(...newNodes);
        }
      });
    });
  }
  
  unhighlight(selector, className) {
    Array.from(document.querySelectorAll(`${selector} span.${className}`)).forEach((span) => {
      const parent = span.parentNode;
      if (parent) {
        const text = document.createTextNode(parent.textContent);
        parent.replaceChildren(text);
      }
    });
  }

  highlightMatchedText() {
    let search = this.state.searchFilterText.trim();

    let selector = this.props.id ? `#${this.props.id} td` : '#lwdgTableWrapper td';

    this.unhighlight(selector, 'highlighted-cell');

    if (search !== '') {
      this.highlight(selector, search, 'highlighted-cell');
    }
  }

  render() {
    let id = this.props.id || 'lwdg';
    const { currPage, rowsPerPage, displayedData, gridData } = this.state

    if (!this.props.header || (this.props.header && this.props.header.length <= 0)) {
      return (
        <BasicAlert type='E' msg='Missing header data for grid' />
      )

    } else if (!this.props.data || (this.props.data && this.props.data.length <= 0)) {
      return (
        <BasicAlert type='N' />
      )

    } else if (this.props.data && this.props.data[0] && this.props.data[0].length != this.props.header.length) {
      return (
        <BasicAlert type='E' msg='Mismatch in header and row data' />
      )

    } else {

      let pageOffset = rowsPerPage * (currPage - 1);
      let lastPage = Math.ceil(gridData.length / rowsPerPage);

      if (displayedData.length == 0) {
        lastPage = 1
      }

      const { searchFilterText } = this.state;

      return (
        <div id={id} className="lwdg">
          <div className="lwdg-table-topbar">
            <div>
              { this.props.download ?
                  <span className="lwdg-table-topbar-btn-dwnld">
                    <i title="Download" onClick={this.handleDownload} className='glyphicon glyphicon-circle-arrow-down'></i>
                    &nbsp;&nbsp;
                  </span>
                : null
              }
              { this.props.title ?
                  <span className="lwdg-table-topbar-title">
                    {this.props.title}&nbsp;-&nbsp;
                  </span>
                : null
              }
              &nbsp;
              Page: {currPage}/{lastPage} - Showing {displayedData.length ? pageOffset + 1 : pageOffset} to {pageOffset + displayedData.length} row(s) out of {gridData.length} &nbsp;
              {
                currPage >= 2 ?
                  <span>
                    &nbsp;
                    <button className="lwdg-table-topbar-btn lwdg-table-topbar-btn-prev"
                            onClick={() => {this.goToPage(currPage - 1)}}>
                      &lt;&nbsp;Prev
                    </button>
                    &nbsp;
                  </span>
                : null
              }
              {
                currPage < lastPage ?
                  <span>
                    &nbsp;
                    <button className="lwdg-table-topbar-btn lwdg-table-topbar-btn-next"
                            onClick={() => {this.goToPage(currPage + 1)}}>
                      Next&nbsp;&gt;&nbsp;
                    </button>
                  </span>
                : null
              }
              {
                this.props.searchFilter ?
                  <FlexiFilterSearch searchText={searchFilterText} handleChange={this.handleSearchChange} handleSearch={this.handleSearchFilter} handleReset={this.handleSearchReset} />
                : null
              }
            </div>
            <div>
              { this.props.options ? this.props.options : null }
              <select className="form-control lwdg-table-topbar-select" name="pageSizeOpt" id="pageSizeOpt"
                      onChange={(e)=>{this.handlePageSize(e)}} value={rowsPerPage} >
                {
                  this.state.pageSizeOpt.map(function(size) {
                    return <option key={size} value={size}>{size}</option>
                  })
                }
              </select>
            </div>
          </div>
          <div id="lwdgTableWrapper" ref={this.gridRef} className="lwdg-table-wrapper"
               style={{height: this.props.height ? this.props.height : this.state.gridHeight,
                      maxHeight: this.props.maxHeight ? this.props.maxHeight : this.state.gridHeight}}>
            <table className="table table-striped lwdg-table">
              <thead>
                <tr key="lwdg-table-th">
                  {
                    this.props.header.map((col, idx) => {
                      return <th key={"lwdg-table-th-" + idx}>{col}</th>;
                    })
                  }
                </tr>
              </thead>
              <tbody>
              {
                displayedData.map((row, idx) => {
                  return (
                    <tr key={"lwdg-table-td-" + idx}>
                      {
                        row.map((field, sidx) => {
                          return <td key={idx + '-' + sidx}>{field}</td>;
                        })
                      }
                    </tr>
                  );
                })
              }
              </tbody>
            </table>
          </div>
        </div>
      )
    }
  }
}

/*------------------------------------------------------------------------------
|
|   AdvancedListCustomizer
|
|      title:    (string)    - title for the modal
|      subtitle: (string)    - subtitle for the modal
|      list:     (array)     - array of row objects
|                              eg. [
|                                     {id: "1", name: "abc", color: 2},
|                                     {id: "2", name: "def"}
|                              ]
|                              - color: 0 / null / undefined - black on white
|                              - color: 1 - white on blue
|                              - color: 2 - black on grey
|
|      map:      (object)    - to customize the mapping in the list,
|                              default values are shown below
|                              {id: "<id>", name: "<name>", color: "<color>"}
|      onSave:   (ref)       - reference to parent class function
|                              to save the list
|      onCancel: (ref)       - reference to parent class function
|                              to ignore the changes in the list
|
\-----------------------------------------------------------------------------*/
export class AdvancedListCustomizer extends React.Component {

  constructor(props) {
    super(props);

    this.draggingItem = React.createRef();
    this.dragOverItem = React.createRef();

    this.state = {
      list: [],
      title: this.props.title || "Customize List",
      subtitle: this.props.subtitle || "",
      map: this.props.map || {id: "id", name: "name", color: "color"},
    }

    this.handleReset = this.handleReset.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleDragStart = this.handleDragStart.bind(this);
    this.handleDragEnter = this.handleDragEnter.bind(this);
    this.handleShowHide = this.handleShowHide.bind(this);
    this.setItemColor = this.setItemColor.bind(this);
  }

  componentDidMount() {
    this.setState({list: [...this.props.selectedList]});
  }

  componentDidUpdate(prevProps, prevState) {
    if (!(_.isEqual(prevProps.selectedList, this.props.selectedList))) {
      this.setState({list: [...this.props.selectedList]});
    }
  }

  handleReset() {
    var list = [];

    for (var i = 0; i < this.props.standardList.length; i++) {
      list.push({
        id: this.props.standardList[i][this.state.map.id],
        name: this.props.standardList[i][this.state.map.name],
        color: this.props.standardList[i][this.state.map.color] ? this.props.standardList[i][this.state.map.color] : null,
        hide: false
      })
    }

    this.setState({list: list});
  }

  handleSave() {
    if (this.props.onSave)
      this.props.onSave([...this.state.list]);
  }

  handleCancel() {
    if (this.props.onCancel)
      this.props.onCancel();
  }

  handleDragStart(e, position) {
    this.draggingItem.current = position;
  }

  handleDragEnter(e, position) {
    this.dragOverItem.current = position;
    var listCopy = [...this.state.list];
    var draggingItemContent = listCopy[this.draggingItem.current];

    listCopy.splice(this.draggingItem.current, 1);
    listCopy.splice(this.dragOverItem.current, 0, draggingItemContent);

    this.draggingItem.current = this.dragOverItem.current;
    this.dragOverItem.current = null;

    this.setState({list: listCopy});
  }

  handleShowHide(e, i) {
    var listCopy = [...this.state.list]

    if (listCopy[i])
      listCopy[i].hide = listCopy[i].hide ? false : true;

    this.setState({list: listCopy});
  }

  setItemColor(item) {
    // black on white
    var color = {textColor: "#000000", bgColor: "#FFFFFF"}

    if (item.color && item.color == 1) {
      // white on blue
      color = {textColor: "#FFFFFF", bgColor: "#0096D6"}

    } else if (item.color && item.color == 2) {
      // black on grey
      color = {textColor: "#000000", bgColor: "#DDDDDD"}
    }

    if (item.hide) {
      // grey on white
      color = {textColor: "#CCCCCC", bgColor: "#FFFFFF"}
    }

    return color;
  }

  render() {
    return (
      <div className="modal" style={{"display": "block"}}>
        <div className="modal-dialog modal-lg" style={{"width": "650px"}} >
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal"  onClick={this.handleCancel} aria-hidden="true">x</button>
              <h3 className="modal-title" style={{maxWidth: "600px"}}>
                {this.state.title}
                <span style={{fontSize: "11px", fontWeight: "400", paddingLeft: "5px"}}>
                  {this.state.subtitle}
                </span>
              </h3>
            </div>
            <div className="modal-body afc-body">
              <div className="afc-row">
                <div className="afc-column">
                  {
                    this.state.list && this.state.list.map((item, index) => {
                      var color = this.setItemColor(item);
                      return(
                        <div className="afc-selected"
                             style={{backgroundColor: color.bgColor}}
                             onDragStart={(e) => this.handleDragStart(e, index)}
                             onDragOver={(e) => e.preventDefault()}
                             onDragEnter={(e) => this.handleDragEnter(e, index)}
                             key={"s" + index}
                             draggable>
                          <span className="afc-label" style={{color: color.textColor}}>
                            {item.name ? item.name : ""}
                          </span>
                          <div className="afc-badge">
                            {(index+1)}
                          </div>
                          <div className="afc-overlay-btn" onClick={(e) => this.handleShowHide(e, index)}>
                            <i style={{fontSize: "12px"}} className={item.hide ? "glyphicon glyphicon-eye-close" : "glyphicon glyphicon-eye-open"}></i>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <span style={{'float': 'left'}}>
                <button type="button" onClick={this.handleReset} className="btn btn-primary">
                  <i className="glyphicon glyphicon-repeat" style={{paddingRight: '5px'}}></i> Reset to Default
                </button>
              </span>
              <button type="button" onClick={this.handleSave} className="btn btn-primary">Save</button>
              <button type="button" onClick={this.handleCancel} className="btn btn-default">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/*------------------------------------------------------------------
|
|   Chatbot
|
\-----------------------------------------------------------------*/
export class Chatbot extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      user: "",
      tenant: "",
      page: "",
      session: "",
      userInput: "",
      chatHistory: [],
      feedbackBtn: {},
      genAICfg: {},
      agenticAICfg: {},
      chatPointer: 0,
      isAdmin: false,
      hasAccess: true,
      isProcessing: false,
      isProcessingRating: 0,
      showFeedbackForm: 0,
      processingMsg: "",
      processingMsgColor: "#f2f2f2",
      isNewUser: false,
      isOpened: false,
      showCSV: false,
      showToolCall: false,
      useMeta: true,
      mode: this.props.mode || "user",
      hide: true,
      status: "L",
      gStatus: false,
      cStatus: false,
      lStatus: false,
      uStatus: false,
      isAgentic: false,
      agentSteps: []
    }

    this.handleTool = this.handleTool.bind(this);
    this.handleFeatureToggle = this.handleFeatureToggle.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handlePrompt = this.handlePrompt.bind(this);
    this.handleCSVClose = this.handleCSVClose.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSend = this.handleSend.bind(this);
    this.handleStop = this.handleStop.bind(this);
    this.handleUser = this.handleUser.bind(this);
    this.handleRating = this.handleRating.bind(this);
    this.handleSubmitFeedback = this.handleSubmitFeedback.bind(this);
    this.handleHelp = this.handleHelp.bind(this);
    this.handleError = this.handleError.bind(this);
    this.waitForUserSettings = this.waitForUserSettings.bind(this);
    this.waitForSession = this.waitForSession.bind(this);
    this.initUserData = this.initUserData.bind(this);
    this.getPageTitle = this.getPageTitle.bind(this);
    this.getAICfg = this.getAICfg.bind(this);
    this.createSession = this.createSession.bind(this);
    this.loadSession = this.loadSession.bind(this);
    this.checkIfReturningUser = this.checkIfReturningUser.bind(this);
    this.checkIfSessionExists = this.checkIfSessionExists.bind(this);
    this.renderCitations = this.renderCitations.bind(this);
    this.renderSuggQuest = this.renderSuggQuest.bind(this);
    this.generateProcessingMsg = this.generateProcessingMsg.bind(this);
    this.jsonToTable = this.jsonToTable.bind(this);

    this.myChatbot = React.createRef();
    this.myChatbox = React.createRef();

    this.showdownConv = new showdown.Converter() || null;
    if (this.showdownConv)
      this.showdownConv.setOption('tables', true);

    if (!window.toggleChatbot)
      window.toggleChatbot = this.handleToggle;

    if (!window.promptChatbot)
      window.promptChatbot = this.handlePrompt;
  }

  componentDidMount() {
    if (this.props.open)
      this.handleToggle();
  }

  handleTool(e) {
    e.preventDefault();

    var key = e.target?.chatbotToolKey?.value ? e.target.chatbotToolKey.value : "";
    var value = e.target?.chatbotToolValue?.value ? e.target.chatbotToolValue.value.trim() : "";

    if (!value) {
      e.target.chatbotToolValue?.classList?.add("chat-input-error");

    } else {
      e.target.chatbotToolValue?.classList?.remove("chat-input-error");
      this.setState({showToolCall: false});
      this.setState({userInput: "[tool_call]{\"key\":\"" + key + "\",\"value\":\"" + value + "\"}"}, () => {this.handleSend()});
    }
  }

  handleFeatureToggle = (stateKey) => {
    this.setState(
      (prevState) => ({
        [stateKey]: !prevState[stateKey],
      }),
      () => {
        this.createSession();
      }
    );
  };

  handleToggle() {
    this.waitForUserSettings((userSettings) => {
      if (!this.state.gStatus)
        this.getAICfg(userSettings);

      const chatbot = this.myChatbot.current;
      chatbot.classList.toggle("show-chatbot");

      if (this.state.hasAccess) {
        if (!this.state.isOpened)
          this.initUserData(userSettings);

      } else {
        this.setState({user: "N/A"});
        this.setState({status: "N"})
      }

      this.state.hide ? this.setState({hide: false}) : this.setState({hide: true});
    });
  }

  handlePrompt(prompt) {
    this.waitForUserSettings((userSettings) => {
      if (!this.state.gStatus)
        this.getAICfg(userSettings);

      const chatbot = this.myChatbot.current;
      if (!chatbot.classList.contains("show-chatbot")) {
        chatbot.classList.add("show-chatbot");
        this.setState({hide: false})
      }

      if (this.state.hasAccess) {
        if (!this.state.isOpened)
          this.initUserData(userSettings);

        this.setState({userInput: prompt});

        this.waitForSession((session) => {setTimeout(() => {this.handleSend()}, 500)});

      } else {
        this.setState({user: "N/A"});
        this.setState({status: "N"})
      }
    });
  }

  handleCSVClose() {
    this.setState({showCSV: false});
  }

  handleKeyDown(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      this.handleSend();

    } else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();

      var chatHist = [];
      this.state.chatHistory.map((chat) => {
        if (chat.role && chat.role == "user")
          chatHist.push(chat.content);
      })

      var cp = this.state.chatPointer;
      if (e.key === 'ArrowUp')
        cp = (cp > 0 ? cp - 1 : cp);
      else
        cp = (cp < chatHist.length ? cp + 1 : cp);

      this.setState({userInput: (chatHist[cp] ? chatHist[cp]: "")});
      this.setState({chatPointer: cp});
    }
  }

  handleChange(e) {
    this.setState({userInput: e.target.value});
  }

  handleSend() {
    var userInput = this.state.userInput.trim();

    if (!userInput)
      return;

    // Sanitize input
    userInput.replace(/[&<>]/g, " ");

    var cp = 1;
    this.state.chatHistory.map((chat) => {
      if (chat.role && chat.role == "user")
        cp++;
    });

    var pmc = {msgs:[], colors:[]};
    this.generateProcessingMsg(pmc);
    var handleProcessMsg = setInterval(() => {this.generateProcessingMsg(pmc)}, 5000);

    this.setState({isProcessing: true});
    this.setState({chatPointer: cp});

    setTimeout(() => {
      this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
    }, 100)

    this.abortController = new AbortController();
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: {
          role: "user",
          content: userInput
        },
        session: this.state.session,
        page: this.state.useMeta ? this.state.page : null
      }),
      signal: this.abortController.signal
    };

    if (userInput.substr(0, 11) == "[tool_call]") {
      var tcJSON = JSON.parse(userInput.match(/{([^}]+)}/g))
      userInput = tcJSON.key.replace(/_/g, " ").replace(/^./, c => c.toUpperCase()) + ": " + tcJSON.value;
    }

    this.setState({chatHistory: [...this.state.chatHistory, {role: "user", content: userInput, ts: new Date().toLocaleString()}]});
    this.setState({userInput: ""});

    if (this.state.isAgentic) {
      this.setState({agentSteps: []});

      fetch("/os/ossui/v1/in/chatbot/chat/agentic", requestOptions).then(async function (response) {
        if (!response.ok) {
          throw new Error(
            `Server returned ${response.status}`
          );
        }

        if (!response.body) {
          throw new Error("Streaming is not supported by this browser");
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        let buffer = "";

        // Function updateStep
        const updateStep = (stepData) => {
          this.setState((prevState) => {
            const steps = [...prevState.agentSteps];

            const existingIndex = steps.findIndex(
              (step) => step.step === stepData.step
            );

            if (existingIndex >= 0) {
              steps[existingIndex] = stepData;
            } else {
              steps.push(stepData);
            }

            return {
              agentSteps: steps
            };
          });
        };

        // Function processServerMessage
        const processServerMessage = (message) => {
          if (!message || !message.trim()) {
            return;
          }

          let eventType = "message";
          let eventData = "";

          const lines = message.split("\n");

          for (const line of lines) {
            if (line.startsWith("event:")) {
              eventType = line
                .substring("event:".length)
                .trim();
            }

            if (line.startsWith("data:")) {
              eventData += line
                .substring("data:".length)
                .trim();
            }
          }

          if (!eventData)
            return;

          const data = JSON.parse(eventData);
          if (eventType === "progress" || eventType === "failed") {
            updateStep(data);
            setTimeout(() => {
              this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
            }, 100);

          } else if (eventType === "complete") {
            var msgId = data?.id ?? "";
            var content = data?.response ?? "";
            var suggestedQuestions = [];

            // Handle links
            var links = content.match(/\[.*?\)/g);
            if (links != null && links.length > 0) {
              for (var link of links) {
                var linkTxt = link.match(/\[(.*?)\]/)[1];
                var linkUrl = link.match(/\((.*?)\)/)[1];
                content = content.replace(link, '<a href="'+linkUrl+'" target="_blank">'+linkTxt+'</a>');
              }
            }

            // Handle suggested questions
            const sqRegex = /\[suggested_questions\](\[[^\]]*\])/;
            const sqMatch = content.match(sqRegex);

            if (sqMatch) {
              try {
                suggestedQuestions = JSON.parse(sqMatch[1]);
                content = content.replace(sqRegex, '').trim();
              } catch (err) {
                console.log("Failed to parse suggested questions:", err);
              }
            }

            if (this.showdownConv && this.showdownConv.makeHtml) {
              content = this.showdownConv.makeHtml(content.replace(/<h./g,'<label').replace(/<\/h.>/g,'</label>'));
              content = content.replace(/<table>/g, '<table class="table table-striped">');
            }

            this.setState({chatHistory: [...this.state.chatHistory, {id: msgId, role: "assistant", content: content, citations: [], ts: new Date().toLocaleString(), rating: 0, sq: suggestedQuestions}]});
            this.setState({isProcessing: false});
            setTimeout(() => {
              this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
            }, 100);
            clearInterval(handleProcessMsg);

          } else if (eventType === "error") {
            throw Error(data.message);

          } else if (eventType === "restart") {
            this.setState({agentSteps: []});
            setTimeout(() => {
              this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
            }, 100);
          }
        };

        while (true) {
          const { value, done } = await reader.read();

          if (done)
            break;

          // Convert incoming bytes to text
          buffer += decoder.decode(value, {
            stream: true
          });

          // SSE messages are separated by \n\n
          const messages = buffer.split("\n\n");

          // Keep the incomplete message for the next chunk
          buffer = messages.pop() || "";

          for (const message of messages) {
            processServerMessage(message);
          }
        }

        // Process anything remaining in the buffer
        if (buffer.trim()) {
          processServerMessage(buffer);
        }

      }.bind(this)).catch(function (error) {
        this.setState({chatHistory: [...this.state.chatHistory, {role: "assistant", content: this.handleError(error)}]});
        this.setState({isProcessing: false});
        setTimeout(() => {
          this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
        }, 100);
        clearInterval(handleProcessMsg);
      }.bind(this));

    } else {

    fetch("/os/ossui/v1/in/chatbot/chat/" + this.state.mode, requestOptions)
      .then(async function (response) {
        const resJSON = await response.json();

        if (!response.ok)
          throw new Error(resJSON.message || response.statusText);

        return resJSON;
      }).then(function (resJSON) {
        if (resJSON.status && resJSON.status == "S" && resJSON.data) {
          var msgID = resJSON.data.id ? resJSON.data.id : ""
          var suggestedQuestions = [];

          if (resJSON.message && resJSON.message == "json") {
            var content = resJSON.data.content ? this.jsonToTable(JSON.parse(resJSON.data.content)) : (this.state.genAICfg.empty_response_msg ? this.state.genAICfg.empty_response_msg : "Sorry, I don't know... I am still learning.");
            var citations = [];

          } else {
            var content = resJSON.data.content ? resJSON.data.content : (this.state.genAICfg.empty_response_msg ? this.state.genAICfg.empty_response_msg : "Sorry, I don't know... I am still learning.");
            //content = content.replace(/(\b(https?|ftp|file):\/\/[\-A-Z0-9+&@#\/%?=~_|!:,.;]*[\-A-Z0-9+&@#\/%=~_|])/img, '<a target="_blank" href="$1">$1</a>');
            //content = content.replace(/(?:\r\n|\r|\n)/g, '<br>');
            //content = content.replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi, '<a href="mailto:$1">$1</a>');

            // Handle links
            var links = content.match(/\[.*?\)/g);
            if (links != null && links.length > 0) {
              for (var link of links) {
                var linkTxt = link.match(/\[(.*?)\]/)[1];
                var linkUrl = link.match(/\((.*?)\)/)[1];
                content = content.replace(link, '<a href="'+linkUrl+'" target="_blank">'+linkTxt+'</a>');
              }
            }

            // Handle suggested questions
            const sqRegex = /\[suggested_questions\](\[[^\]]*\])/;
            const sqMatch = content.match(sqRegex);

            if (sqMatch) {
              try {
                suggestedQuestions = JSON.parse(sqMatch[1]);
                content = content.replace(sqRegex, '').trim();
              } catch (err) {
                console.log("Failed to parse suggested questions:", err);
              }
            }

            if (this.showdownConv && this.showdownConv.makeHtml) {
              content = this.showdownConv.makeHtml(content.replace(/<h./g,'<label').replace(/<\/h.>/g,'</label>'));
              content = content.replace(/<table>/g, '<table class="table table-striped">');
            }

            var citations = [];
            if (resJSON.data.citations && resJSON.data.citations.length > 0)
              for (var i=0; i<resJSON.data.citations.length; i++)
                if (resJSON.data.citations[i].title && !citations.includes(resJSON.data.citations[i].title))
                  citations.push(resJSON.data.citations[i].title)
          }

          this.setState({chatHistory: [...this.state.chatHistory, {id: msgID, role: "assistant", content: content, citations: citations, ts: new Date().toLocaleString(), rating: 0, sq: suggestedQuestions}]});
          this.setState({isProcessing: false});
          this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
          clearInterval(handleProcessMsg);

        } else {
          throw Error(resJSON.message);
        }

      }.bind(this)).catch(function (error) {
        this.setState({chatHistory: [...this.state.chatHistory, {role: "assistant", content: this.handleError(error)}]});
        this.setState({isProcessing: false});
        this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
        clearInterval(handleProcessMsg);

      }.bind(this));
    }
  }

  handleStop() {
    if (this.abortController) {
      console.log("Stopping request... request aborted by user.");
      this.abortController.abort();
    }
  }

  handleUser(e) {
    e.preventDefault();
    var value = e.target.form?.chatbotEmail?.value ? e.target.form.chatbotEmail.value : "";

    if (!value || (value && !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)))) {
      e.target.form.chatbotEmail?.classList?.add("chat-input-error");

    } else {
      this.setState({user: value}, () => {
        this.getPageTitle();
        this.checkIfReturningUser();
        this.checkIfSessionExists();
      });
    }
  }

  handleRating(message, rating) {
    this.setState({isProcessingRating: message});
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session: this.state.session,
        message: message,
        rating: rating
      })
    };

    fetch("/os/ossui/v1/in/chatbot/rate/", requestOptions)
      .then(function (response) {
        if (response.ok)
          return response.json();
        else
          throw Error(response.statusText);

      }).then(function (resJSON) {
        if (resJSON.status && resJSON.status == "S" && resJSON.data) {
          var chatHistory = [...this.state.chatHistory]

          for (var i = 0; i < chatHistory.length; i++)
            if (chatHistory[i].id && chatHistory[i].id == message)
              chatHistory[i].rating = rating

          this.setState({chatHistory: chatHistory});
          this.setState({isProcessingRating: 0});

          if (rating) {
            this.setState({showFeedbackForm: message});

            var lastIdx = chatHistory.length - 1
            if (chatHistory[lastIdx].id && chatHistory[lastIdx].id == message)
              setTimeout(() => {
                this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
              }, 100)
          }

        } else {
          throw Error(resJSON.message);
        }

      }.bind(this)).catch(function (error) {
        console.log(error);
        this.setState({isProcessingRating: 0});

      }.bind(this));
  }

  handleSubmitFeedback(e, message) {
    e.preventDefault();

    var value = e.target.form?.chatbotFeedback?.value ? e.target.form.chatbotFeedback.value : "";
    if (!value) {
      e.target.form.chatbotFeedback?.classList?.add("chat-input-error");
      return;
    }

    e.target.form.feedbackSubBtn.innerText = "Submitting...";
    e.target.form.feedbackSubBtn.disabled = true;
    e.target.form.chatbotFeedback?.classList?.remove("chat-input-error");

    var now = new Date().toISOString();
    var feedback = {
      area: 'cb',
      priority: 'l',
      text: value.replace(/</g, "&lt;").replace(/>/g, "&gt;"),
      subtext: "Chatbot called from " + this.state.page + " (" + this.state.session + ':' + message + ")",
      created_by: this.state.user,
      creation_date: now,
      last_update: now,
      status: 'n',
      reviewed_by: '',
      review_date: '',
      likes: []
    }

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({feedback: feedback})
    };

    fetch("/os/ossui/v1/in/feedback", requestOptions)
      .then(function (response) {
        if (response.ok) {
          this.setState({showFeedbackForm: 0});
          e.target.form.feedbackSubBtn.innerText = "Submit";
          e.target.form.feedbackSubBtn.disabled = false;

        } else {
          throw Error(response.statusText);
        }
      }.bind(this)).catch(function (error) {
        console.log(error);
        e.target.form.feedbackSubBtn.innerText = "Try Again";
        e.target.form.feedbackSubBtn.disabled = false;

      }.bind(this));
  }

  handleHelp() {
    var helpContent = this.state.isAgentic
      ? (this.state.agenticAICfg.help_msg ?? "")
      : (this.state.genAICfg.help_msg ?? "")

    if (helpContent) {
      this.setState({chatHistory: [...this.state.chatHistory, {role: "assistant", content: helpContent, ts: new Date().toLocaleString()}]});
      setTimeout(() => {
        this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
      }, 100)
    }
  }

  handleError(error) {
    if (error?.name === "AbortError")
      return this.state.genAICfg.abort_msg ? this.state.genAICfg.abort_msg : "You aborted the request.";
    else if (error?.message?.startsWith("STSU:"))
      return error.message.slice(5);
    else
      return this.state.genAICfg.error_msg ? this.state.genAICfg.error_msg : "Sorry, error occurred. Please try again later.";
  }

  waitForUserSettings(callback) {
    if (!this.state.uStatus) {
      const interval = setInterval(() => {
        var userSettings = typeof window.GlobalUserSettings != 'undefined' && window.GlobalUserSettings.user_id
          ? window.GlobalUserSettings
          : typeof window.UserSettings != 'undefined' && window.UserSettings.user_id
            ? window.UserSettings
            : undefined
        if (userSettings !== undefined) {
          clearInterval(interval);
          this.setState({uStatus: true});
          callback(userSettings);
        }
      }, 500);
    } else {
      callback(typeof window.GlobalUserSettings != 'undefined' && window.GlobalUserSettings.user_id
        ? window.GlobalUserSettings
        : typeof window.UserSettings != 'undefined' && window.UserSettings.user_id
          ? window.UserSettings
          : undefined);
    }
  }

  waitForSession(callback) {
    const interval = setInterval(() => {
      if (this.state.session) {
        clearInterval(interval);
        callback(this.state.session);
      }
    }, 250);
  }

  initUserData(userSettings) {
    var user = "";
    var tenant = "";
    var isAdmin = false;

    if (typeof userSettings != 'undefined' && userSettings.user_id) {
      user = userSettings.user_id;
      tenant = userSettings.tenant;

      if (userSettings.groups?.indexOf('SandyAdmin') >= 0)
        isAdmin = true;
    }

    this.setState({tenant: (tenant ? tenant : "HPI")});
    this.setState({isAdmin: isAdmin});

    if (user) {
      this.setState({user: user}, () => {
        this.getPageTitle();
        this.checkIfReturningUser();
        this.checkIfSessionExists();
      });

    } else {
      this.setState({user: user});
    }

    this.setState({isOpened: true});
  }

  getPageTitle() {
    var pageTitle = this.state.genAICfg.unknown_page ? this.state.genAICfg.unknown_page : "OSS";
    var pageTitleElm = document.getElementById("tmb-page-title");

    if (pageTitleElm && pageTitleElm.innerHTML)
      pageTitle = pageTitleElm.innerHTML;

    this.setState({page: pageTitle});
  }

  getAICfg(us) {
    this.setState({status: "L"});

    if (us && us.config?.GenAICfg) {
      if (us.config?.AgenticAICfg)
        this.setState({agenticAICfg: us.config.AgenticAICfg});

      this.setState({genAICfg: us.config.GenAICfg});
      this.setState({gStatus: true});

      if (this.state.cStatus || this.state.lStatus)
        this.setState({status: "S"});

      if (us.config.GenAICfg.restricted_to_grp && us.groups?.indexOf(us.config.GenAICfg.restricted_to_grp) < 0)
        this.setState({hasAccess: false});

    } else {
      console.log("Error while getting ai config");
      this.setState({status: "E"});
    }
  }

  createSession() {
    this.setState({status: "L"});
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    };

    var source = this.state.isAgentic ? "mate" : "sandy";

    fetch(`/os/ossui/v1/in/chatbot/session?source=${source}`, requestOptions)
      .then(function (response) {
        if (response.ok)
          return response.json();
        else
          throw Error(response.statusText);

      }).then(function (resJSON) {
        if (resJSON.status && resJSON.status == "S" && resJSON.data) {
          var date = new Date();
          date.setTime(date.getTime() + (this.state.genAICfg.session_duration_seconds ? (this.state.genAICfg.session_duration_seconds * 1000) : (2*60*60*1000))); // default 2 hours
          document.cookie = "HPOSS_CHATBOT_SESSION_ID="+resJSON.data+";expires="+date.toUTCString()+";path=/;";

          this.setState({chatHistory: [{role: "system", content: <>---------- New session started ----------<br/>[ ID: {resJSON.data} ]</>, ts: new Date().toLocaleString()}]});
          this.setState({session: resJSON.data});
          this.setState({cStatus: true});

          if (this.state.gStatus)
            this.setState({status: "S"});

          setTimeout(() => {
            this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
          }, 100)

        } else {
          throw Error(resJSON.message);
        }

      }.bind(this)).catch(function (error) {
        console.log("Error while getting session=", error);
        this.setState({status: "E"});

      }.bind(this));
  }

  loadSession(session) {
    this.setState({status: "L"});
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    };

    fetch(`/os/ossui/v1/in/chatbot/session/${session}`, requestOptions)
      .then(function (response) {
        if (response.ok)
          return response.json();
        else
          throw Error(response.statusText);

      }).then(function (resJSON) {
        if (resJSON.status && resJSON.status == "S" && resJSON.data) {
          var chatHistoryDB = []
          var chatHistoryResp = resJSON.data.chat ? resJSON.data.chat : []
          var source = resJSON.data.source ?? "";

          for (var i = 0; i < chatHistoryResp.length; i++) {
            if (["tool", "planner"].includes(chatHistoryResp[i].role) || chatHistoryResp[i].content.match(/^\s*\[([a-zA-Z]+)\]\s*(\{.*\})\s*$/))
              continue;

            var chRole = ""
            var chContent = chatHistoryResp[i].content;
            var chTs = Formatter.fmDateTime(chatHistoryResp[i].ts);
            var chId = chatHistoryResp[i].id ? chatHistoryResp[i].id : 0;
            var chRating = chatHistoryResp[i].rating ? chatHistoryResp[i].rating : 0;
            var chSuggQuest = [];

            if (chatHistoryResp[i].role != "user")
              chRole = 'assistant';
            else
              chRole = chatHistoryResp[i].role;

            if (chRole == 'assistant') {
              //chContent = chContent.replace(/(?:\r\n|\r|\n)/g, '<br>');
              //chContent = chContent.replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi, '<a href="mailto:$1">$1</a>');

              // Handle links
              var links = chContent.match(/\[.*?\)/g);
              if (links != null && links.length > 0) {
                for (var link of links) {
                  var linkTxt = link.match(/\[(.*?)\]/)[1];
                  var linkUrl = link.match(/\((.*?)\)/)[1];
                  chContent = chContent.replace(link, '<a href="'+linkUrl+'" target="_blank">'+linkTxt+'</a>');
                }
              }

              // Handle suggested questions
              const sqRegex = /\[suggested_questions\](\[[^\]]*\])/;
              const sqMatch = chContent.match(sqRegex);

              if (sqMatch) {
                try {
                  chSuggQuest = JSON.parse(sqMatch[1]);
                  chContent = chContent.replace(sqRegex, '').trim();
                } catch (err) {
                  console.log("Failed to parse suggested questions:", err);
                }
              }

              if (this.showdownConv && this.showdownConv.makeHtml) {
                chContent = this.showdownConv.makeHtml(chContent.replace(/<h./g,'<label').replace(/<\/h.>/g,'</label>'));
                chContent = chContent.replace(/<table>/g, '<table class="table table-striped">');
              }
            } else {
              if (chContent.substr(0, 11) == "[tool_call]") {
                var tcJSON = JSON.parse(chContent.match(/{([^}]+)}/g))
                chContent = tcJSON.key.replace(/_/g, " ").replace(/^./, c => c.toUpperCase()) + ": " + tcJSON.value;
              }
            }

            if (chRole)
              chatHistoryDB.push({id: chId, role: chRole, content: chContent, ts: chTs, rating: chRating, sq: chSuggQuest});
          }

          if (source && source === "mate")
            this.setState({isAgentic: true});

          this.setState({chatHistory: chatHistoryDB});
          this.setState({lStatus: true});

          if (this.state.gStatus)
            this.setState({status: "S"});

          setTimeout(() => {
            this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
          }, 100)

        } else {
          throw Error(resJSON.message);
        }

      }.bind(this)).catch(function (error) {
        console.log("Error while getting session history data=", error);
        this.setState({status: "E"});

      }.bind(this));
  }

  checkIfReturningUser() {
    if (document.cookie.match(/^(.*;)?\s*HPOSS_CHATBOT_RETURNED_USER\s*=\s*[^;]+(.*)?$/)) {
      this.setState({isNewUser: false});

    } else {
      var date = new Date();
      var seconds = Math.round(date.getTime() / 1000);
      date.setTime(date.getTime() + (400 * 86400 * 1000));
      document.cookie = "HPOSS_CHATBOT_RETURNED_USER="+seconds+"; expires="+date.toUTCString()+";path=/;";
      this.setState({isNewUser: true});
    }
  }

  checkIfSessionExists() {
    var session = document.cookie.match(/^(.*;)?\s*HPOSS_CHATBOT_SESSION_ID\s*=\s*[^;]+(.*)?$/);

    if (session) {
      var cookies = document.cookie.split(';');
      var cvalue = "";
      for (var i=0; i < cookies.length; ++i) {
        var pair = cookies[i].trim().split('=');
        if(pair[0] == "HPOSS_CHATBOT_SESSION_ID")
          cvalue = pair[1];
      }

      if (cvalue) {
        this.setState({session: cvalue});
        this.loadSession(cvalue);

      } else {
        this.createSession();
      }

    } else {
      this.createSession();
    }
  }

  renderCitations(citations, ts) {
    return (
      <div style={{marginTop: "5px"}}>
        {
          citations.map((value, index) => {
            var fRef = "file-" + (Math.random() + 1).toString(36).substring(2) + new Date(ts).getTime();
            var cLink = this.state.genAICfg.citation_links && this.state.genAICfg.citation_links[value] && this.state.genAICfg.citation_links[value][0]
              ? this.state.genAICfg.citation_links[value][0]
              : "";

            if (cLink)
              return (<div id={fRef} style={{fontSize: "12px"}}><a target="_blank" href={cLink}>{value}</a></div>)
            else
              return (<div id={fRef} style={{fontSize: "12px"}}>{value}</div>)
          })
        }
      </div>
    );
  }

  renderSuggQuest(sq) {
    return (
      <div style={{marginTop: "5px"}}>
        Do you want me to follow up further with one of the below options?
        <br/>
        {
          sq.map((value, index) => {
            if (value)
              return (
                <button type="button" className="btn btn-smallest btn-secondary" style={{marginRight: "5px", marginBottom: "5px"}}
                  onClick={(e) => {
                    this.setState({userInput: value}, () => {
                      setTimeout(() => {
                        this.handleSend();
                      }, 250);
                    });
                  }}
                >
                  <i className="fa-solid fa-oss-sandy fac-white"></i>&nbsp;&nbsp;{value}
                </button>
              )
          })
        }
      </div>
    );
  }

  generateProcessingMsg(pmc) {
    var msgs = this.state.genAICfg.processing_msgs ? this.state.genAICfg.processing_msgs : [
      "OSS captures new orders and order changes in near real time.",
      "OSS sources data from 50+ systems, like S4, Hawkeye, eClaims, 3W, etc.",
      "OSS is now the official reporting tool for claims (from eClaims) and cases (from 3W).",
      "OSS can process up to 350k order refreshes per hour.",
      "OSS has ~10k internal HPI unique monthly active users.",
      "OSS has ~70k external Customer / Partner unique monthly active users.",
      "OSS has a 6 years order archive.",
      "OSS order retention is 13 months after the orders are Closed (Fully Invoiced).",
      "OSS sends EDI order updates to Channel partners that need to get automated order updates.",
      "OSS has a capability that allows you to download up to 1 million invoices or PODs.",
      "OSS Sandy can be contacted by other AIs and will answer queries regarding order status.",
      "OSS has an external API (Application Programming Interface) that allows customers or partners to get order updates in their system in a self service mode.",
      "OSS legacy landing page and order viewer was called 'SANDY' and now we are re-using the name for our new chat AI assistant.",
      "OSS and Hawkey are the only applications that have data about the Shipment once it left the factory.",
      "OSS is sending order data summarized to both HP2B and Partner Portal so they can show it on the portal pages for customers and partners.",
      "OSS has mobile apps, one for internal users and one for customers and partners that need to use OSS while not on their desk.",
      "OSS has a BI database, called OSS Analytics Database, that allows to extract massive ammount of data.",
      "OSS enables users, with special rights, to trigger the removal of user statuses from OSV, Widget and BMT drilldown view.",
      "OSS enables users, with special rights, to cancel fallout documents in OIS from OSV and Widget.",
      "OSS sends proactive emails to Direct customers with major updates on their orders. Contact the COS team SME from your region to find out more."
    ];

    var colors = ["#cdc6fc", "#e5fea3", "#ffdd9d"];

    if (pmc.msgs.length === msgs.length)
      pmc.msgs = [];

    const unusedIndexesM = msgs.map((_, index) => index).filter(index => !pmc.msgs.includes(index));
    const randomIndexM = unusedIndexesM[Math.floor(Math.random() * unusedIndexesM.length)];

    pmc.msgs.push(randomIndexM);

    this.setState({processingMsg: msgs[randomIndexM]});

    if (pmc.colors.length === colors.length)
      pmc.colors = [];

    const unusedIndexesC = colors.map((_, index) => index).filter(index => !pmc.colors.includes(index));
    const randomIndexC = unusedIndexesC[Math.floor(Math.random() * unusedIndexesC.length)];

    pmc.colors.push(randomIndexC);

    this.setState({processingMsgColor: colors[randomIndexC]});
  }

  jsonToTable(json) {
    var table = "<table>";

    for (var key in json) {
      if (json.hasOwnProperty(key)) {
        var val = json[key];

        if (typeof val !== "string")
          continue; // TODO - handle nested objects

        if (val.startsWith('https'))
          val = val.replace(/(\b(https?):\/\/[\-A-Z0-9+&@#\/%?=~_|!:,.;]*[\-A-Z0-9+&@#\/%=~_|])/img, '<a target="_blank" href="$1"><i class="glyphicon glyphicon-new-window"></i>&nbsp;More details...</a>');

        table += "<tr><td style='background-color: #0096d6; color: #fff; border: 1px solid #bbb; padding: 5px;'>"
              + key
              + "</td><td style='background-color: #f5f5f5; border: 1px solid #bbb; padding: 5px;'>"
              + val
              + "</td></tr>";
      }
    }

    table += "</table>";

    if (table == "<table></table>")
      return "";

    return table;
  }

  render() {
    var name = this.state.isAgentic ? "Sandy (Agent)" : "Sandy (Chat)";
    var disclaimerMsg = this.state.isAgentic ? (this.state.agenticAICfg.disclaimer ?? "") : (this.state.genAICfg.disclaimer ?? "");
    var noAccessMsg = this.state.isAgentic ? (this.state.agenticAICfg.no_access_msg ?? "") : (this.state.genAICfg.no_access_msg ?? "");
    var welcomeMsg = this.state.isAgentic ? (this.state.agenticAICfg.returning_user_greeting ?? "") : (this.state.genAICfg.returning_user_greeting ?? "");
    if (this.state.isNewUser)
      welcomeMsg = this.state.isAgentic ? (this.state.agenticAICfg.new_user_greeting ?? "") : (this.state.genAICfg.new_user_greeting ?? "");

    var copyTableCSS = "<style> table, th, td { border: 1px solid black; padding: 5px } table { border-collapse: collapse; } thead { background-color: #767676; color: #fff; } </style> ";

    return (
      <div id="chatbot" ref={this.myChatbot}>
        {
          this.state.showCSV
          ? <ChatbotSessionViewer onClose={this.handleCSVClose} />
          : null
        }
        <div className="chatbot">
          <div className="chatheader" style={{background: this.state.isAgentic ? "#024ad8" : "#0096d6"}}>
            <h4>
              <ChatbotSandy width="24px" height="24px" style={{verticalAlign: "text-bottom"}} fill="#fff" stroke="#fff"/> Sandy
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {
                ((Array.isArray(this.state.agenticAICfg.authorized_users) && this.state.agenticAICfg.authorized_users.length > 0 && this.state.agenticAICfg.authorized_users.includes(this.state.user)) || !this.state.agenticAICfg.authorized_users || (Array.isArray(this.state.agenticAICfg.authorized_users) && this.state.agenticAICfg.authorized_users.length <= 0))
                ? this.state.isAgentic
                  ? <span className="chatbot-tabs">
                      <span className="chatbot-tab" onClick={() => this.handleFeatureToggle("isAgentic")}>Chat</span>
                      <span className="chatbot-tab active">Agent</span>
                    </span>
                  : <span className="chatbot-tabs">
                      <span className="chatbot-tab active">Chat</span>
                      <span className="chatbot-tab" onClick={() => this.handleFeatureToggle("isAgentic")}>Agent</span>
                    </span>
                : null
              }
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              { this.state.hasAccess
                ? <span style={{float: "right", marginTop: "4px"}}>
                  {
                    this.state.isAdmin
                    ? <>
                        <a title="View stored sessions" target="_blank" onClick={(e)=>{this.setState({showCSV: true})}}>
                          <i style={{color: "#fff", cursor: "pointer"}} className="glyphicon glyphicon-inbox" />
                        </a>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {
                          this.state.useMeta
                          ? <a title="User meta data enabled" target="_blank" onClick={() => this.handleFeatureToggle("useMeta")}>
                              <i style={{color: "#fff", cursor: "pointer"}} className="glyphicon glyphicon-ok-circle" />
                            </a>
                          : <a title="User meta data disabled" target="_blank" onClick={() => this.handleFeatureToggle("useMeta")}>
                              <i style={{color: "#fff", cursor: "pointer"}} className="glyphicon glyphicon-ban-circle" />
                            </a>
                        }
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <a title="AI Monitoring Dashboard" target="_blank" href={"/static/dist/aiMonDash.html"}>
                          <i style={{color: "#fff", cursor: "pointer"}} className="glyphicon glyphicon-stats" />
                        </a>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </>
                    : null
                  }
                    <a title="Reset chat session" target="_blank" onClick={this.createSession}>
                      <i style={{color: "#fff", cursor: "pointer"}} className="glyphicon glyphicon-repeat" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a title="Provide feedback" target="_blank" href={"/static/dist/feedback.html?caller=chatbot&subtext=Chatbot%20called%20from%20" + this.state.page + "%20(" + this.state.session + ")"}>
                      <i style={{color: "#fff", cursor: "pointer"}} className="glyphicon glyphicon-bullhorn" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a title="Help" onClick={this.handleHelp}>
                      <i style={{color: "#fff", cursor: "pointer"}} className="glyphicon glyphicon-info-sign" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a title="Close" onClick={this.handleToggle}>
                      <i style={{color: "#fff", cursor: "pointer"}} className="glyphicon glyphicon-remove" />
                    </a>
                  </span>
                : <span style={{float: "right"}}>
                    <a title="Provide feedback" href="mailto:Q2C_OSS_WW_OSS_BIZ_ITSME_USER@groups.hp.com?subject=Feedback:%20OSS%20AI%20Chatbot%20(Sandy)">
                      <i style={{color: "#fff", cursor: "pointer"}} className="glyphicon glyphicon-bullhorn" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a title="Close" onClick={this.handleToggle}>
                      <i style={{color: "#fff", cursor: "pointer"}} className="glyphicon glyphicon-remove" />
                    </a>
                  </span>
              }
            </h4>
          </div>
          {
            this.state.user
            ? this.state.hasAccess
              ? this.state.status == "S"
                ? <>
                    <div>
                      <ul className="chatbox" ref={this.myChatbox}>
                        <li key="cb-msg" className="chat assistant">
                          <span><ChatbotSandy width="16px" height="16px" style={{verticalAlign: "sub"}}/>{name}</span>
                          <p dangerouslySetInnerHTML={{__html: welcomeMsg}}></p>
                          <span className="chatbot-disclaimer" dangerouslySetInnerHTML={{__html: disclaimerMsg}}></span>
                        </li>
                        {
                          this.state.chatHistory.map((msg, idx) => {
                            var key = "cb-msg-" + idx
                            if (msg.role == "user")
                              return (
                                <li key={key} className="chat user">
                                  <span>{this.state.user}&nbsp;&nbsp;<i className="glyphicon glyphicon-user"/></span>
                                  <p>{msg.content}</p>
                                  <span>{msg.ts}</span>
                                </li>
                              )
                            else if (msg.role == "assistant")
                              return (
                                <li key={key} className="chat assistant">
                                  <span><ChatbotSandy width="16px" height="16px" style={{verticalAlign: "sub"}}/>{name}</span>
                                  <p id="chatbox-assistant-p" dangerouslySetInnerHTML={{__html: msg.content}}></p>
                                  <span>
                                    { msg.ts }
                                    { this.state.mode == "user" && msg.content
                                      ? <span title="Copy" style={{marginLeft: "10px"}}
                                          onClick={() => {
                                            navigator.clipboard.write([
                                              new ClipboardItem({
                                                'text/html': new Blob([copyTableCSS + msg.content], {type: 'text/html'}),
                                                'text/plain': new Blob([
                                                  (() => {
                                                    const div = document.createElement('div');
                                                    div.innerHTML = msg.content;
                                                    return div.innerText;
                                                  })()
                                                ], {type: 'text/plain'})
                                              })
                                            ])
                                          }}>
                                          <i className="fa-solid fa-copy" style={{color: "#777", fontSize: "14px", cursor: "pointer"}} />
                                        </span>
                                      : null
                                    }
                                    { this.state.mode == "user" && msg.id
                                      ? msg.rating && msg.rating === 1
                                        ? <>
                                            <i title="Like" onClick={() => this.handleRating(msg.id, 0)}  className="glyphicon glyphicon-thumbs-up" style={{cursor: "pointer", color: "#0096d6", fontSize: "14px", marginLeft: "5px"}}></i>
                                            <i title="Dislike" onClick={() => this.handleRating(msg.id, -1)} className="glyphicon glyphicon-thumbs-down" style={{cursor: "pointer", fontSize: "14px", marginLeft: "5px", transform: "scaleX(-1)"}}></i>
                                          </>
                                        : msg.rating && msg.rating === -1
                                          ? <>
                                              <i title="Like" onClick={() => this.handleRating(msg.id, 1)}  className="glyphicon glyphicon-thumbs-up" style={{cursor: "pointer", fontSize: "14px", marginLeft: "5px"}}></i>
                                              <i title="Dislike" onClick={() => this.handleRating(msg.id, 0)} className="glyphicon glyphicon-thumbs-down" style={{cursor: "pointer", color: "#d9534f", fontSize: "14px", marginLeft: "5px", transform: "scaleX(-1)"}}></i>
                                            </>
                                          : <>
                                              <i title="Like" onClick={() => this.handleRating(msg.id, 1)}  className="glyphicon glyphicon-thumbs-up" style={{cursor: "pointer", fontSize: "14px", marginLeft: "5px"}}></i>
                                              <i title="Dislike" onClick={() => this.handleRating(msg.id, -1)} className="glyphicon glyphicon-thumbs-down" style={{cursor: "pointer", fontSize: "14px", marginLeft: "5px", transform: "scaleX(-1)"}}></i>
                                            </>
                                      : null
                                    }
                                    {
                                      this.state.isProcessingRating && this.state.isProcessingRating == msg.id
                                      ? <i style={{color: "#999", fontSize: "11px", marginLeft: "10px"}}>sending...</i>
                                      : null
                                    }
                                    {
                                      (this.state.mode == "user" && msg.citations && Object.keys(msg.citations).length > 0)
                                      ? this.renderCitations(msg.citations, msg.ts)
                                      : null
                                    }
                                    {
                                      (this.state.mode == "user" && msg.sq && msg.sq.length > 0)
                                      ? this.renderSuggQuest(msg.sq)
                                      : null
                                    }
                                    {
                                      this.state.showFeedbackForm && this.state.showFeedbackForm == msg.id
                                      ? <form onSubmit={(e) => this.handleSubmitFeedback(e, msg.id)} style={{margin: "10px", textAlign: "center"}}>
                                          Why did you choose this rating? (optional)
                                          <br/>
                                          <textarea className="form-control"
                                                 id="chatbotFeedback" name="chatbotFeedback"
                                                 placeholder="Provide additional feedback" />
                                          <button type="button" style={{marginTop: "10px"}}
                                                  onClick={() => this.setState({showFeedbackForm: 0})}
                                                  className="btn btn-smallest btn-default">
                                            Close
                                          </button>
                                          &nbsp;&nbsp;
                                          <button type="submit" style={{marginTop: "10px"}}
                                                  id="feedbackSubBtn" name="feedbackSubBtn"
                                                  onClick={(e) => this.handleSubmitFeedback(e, msg.id)}
                                                  className="btn btn-smallest btn-primary">
                                            Submit
                                          </button>
                                        </form>
                                      : null
                                    }
                                  </span>
                                </li>
                              )
                            else
                              return (
                                <li key={key} className="chat system">
                                  <p>{msg.content}</p>
                                </li>
                              )
                          })
                        }
                        {
                          this.state.isProcessing
                            ? this.state.isAgentic
                                ? <li key="cb-msg-loading" className="chat assistant loading">
                                    <span>
                                      <span className="hp-gif-spinner" style={{width: '12px', height: '12px', backgroundSize: '12px 12px'}}></span>
                                      <span style={{marginLeft: '5px', color: '#0096d6', fontSize: '12px'}}>
                                        {name} is processing your query...
                                      </span>
                                    </span>
                                    <p id="chatbox-assistant-p" style={{position: 'relative'}}>
                                      {
                                        this.state.agentSteps.map((step) => (
                                          <div key={step.step} style={{marginBottom: "8px"}}>
                                            {step.status === "completed" && (
                                              <span style={{ color: "green" }}>
                                                ✓
                                              </span>
                                            )}
                                            {step.status === "failed" && (
                                              <span style={{ color: "red" }}>
                                                ✗
                                              </span>
                                            )}
                                            {step.status === "started" && (
                                              <span style={{ color: "orange" }}>
                                                ⏳
                                              </span>
                                            )}
                                            {" "}
                                            <span>
                                              Step {step.step}: {step.message}
                                            </span>
                                          </div>
                                        ))
                                      }
                                    </p>
                                  </li>
                                : <li key="cb-msg-loading" className="chat assistant loading">
                                    <span>
                                      <span className="hp-gif-spinner" style={{width: '12px', height: '12px', backgroundSize: '12px 12px'}}></span>
                                      <span style={{marginLeft: '5px', color: '#0096d6', fontSize: '12px'}}>
                                        {name} is processing your query... until then, here are some interesting OSS facts
                                      </span>
                                    </span>
                                    <p id="chatbox-assistant-p" style={{position: 'relative', background: this.state.processingMsgColor}}>
                                      {this.state.processingMsg}
                                    </p>
                                  </li>
                            : null
                        }
                      </ul>
                    </div>
                    {
                      this.state.isProcessing
                      ? <div className="chat-input">
                          <textarea placeholder="Please wait..." readOnly="readOnly"/>
                          <span id="stop-btn" onClick={this.handleStop}>Stop&nbsp;&#9209;</span>
                        </div>
                      : this.state.showToolCall && this.state.mode == "user"
                        ? <div className="chat-input">
                            <span id="tool-call" onClick={() => {this.setState({showToolCall: false})}}
                                  style={{display: "inline-flex", alignItems: "center"}}>
                                <i style={{padding: "0px 5px 0px 0px"}} className="glyphicon glyphicon-chevron-left"/>
                            </span>
                            <form id="tool-call-form" onSubmit={this.handleTool}
                                  style={{display: "inline-flex", alignItems: "center", width: '100%'}}>
                              <select id="chatbotToolKey" name="chatbotToolKey"
                                      className="form-control"
                                      style={{width: '40%', display: 'inline'}}>
                                <option value="order_no">Order No</option>
                                <option value="purchase_order_no">Purchase Order No</option>
                                <option value="parent_trade_order">Parent Trade Order No</option>
                                <option value="account_name">Account Name</option>
                                <option value="customer_name">Customer Name</option>
                                <option value="shipment_no">Shipment No</option>
                                <option value="invoice_no">Invoice No</option>
                                <option value="serial_no">Serial No</option>
                                <option value="claim_no">eClaims No</option>
                                <option value="b2bis_id">OIS ID</option>
                              </select>
                              <input type="text" className="form-control"
                                     id="chatbotToolValue" name="chatbotToolValue"
                                     placeholder="Please enter a reference"
                                     style={{width: '60%', display: 'inline'}} />
                            </form>
                            <button className="chatbot-btn-send" id="send-btn" form="tool-call-form" type="submit">
                              Send&nbsp;&#11166;
                            </button>
                          </div>
                        : <div className="chat-input">
                            <span id="tool-call" onClick={() => {this.setState({showToolCall: true})}} title="Quick Search"
                                  style={{display: "inline-flex", alignItems: "center", padding: "0px 5px 5px 0px"}}>
                              <SearchIcon />
                            </span>
                            <textarea placeholder={this.state.isProcessing ? "Please wait..." : "Type here..."}
                                      readOnly={this.state.isProcessing ? "readOnly" : ""}
                                      value={this.state.userInput}
                                      onKeyDown={this.handleKeyDown}
                                      onChange={this.handleChange}
                                      autoFocus />
                            <span id="send-btn" onClick={this.handleSend}>Send&nbsp;&#11166;</span>
                          </div>
                    }
                  </>
                : this.state.status == "L"
                  ? <div className="chatbot-spinner-container">
                      <div className="chatbot-spinner" />
                    </div>
                  : <BasicAlert type={this.state.status} />
              : <BasicAlert type="I" msg={noAccessMsg} />
            : this.state.status == "L"
              ? <div className="chatbot-spinner-container">
                  <div className="chatbot-spinner" />
                </div>
              : <BasicAlert type={this.state.status} />
            }
        </div>
      </div>
    )
  }
}

/*------------------------------------------------------------------
|
|   Chatbot Session Viewer
|
\-----------------------------------------------------------------*/
export class ChatbotSessionViewer extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      searchData: {
        searchValue: "",
        dateType: "created_at",
        dateFrom: "",
        dateTo: "",
        countType: "msg_count",
        countOp: "eq",
        countValue: ""
      },
      searchResults: [],
      chatData: {},
      sStatus: "",
      cStatus: ""
    }

    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChatData = this.handleChatData.bind(this);
    this.handlePlan = this.handlePlan.bind(this);
  }

  componentDidMount() {
    if (this.props.session) {
      this.handleChatData(null, this.props.session);

    } else {
      var today = new Date();
      var yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);

      this.setState({
        searchData: {
          searchValue: "",
          dateType: "created_at",
          dateFrom: yesterday.toISOString().split('T')[0],
          dateTo: today.toISOString().split('T')[0],
          countType: "msg_count",
          countOp: "eq",
          countValue: ""
        }
      }, this.handleSearch);
    }
  }

  handleClose() {
    if (this.props.onClose)
      this.props.onClose();
  }

  handleChange(e) {
    var searchData = this.state.searchData;
    var {name, value} = e.target;
    searchData[name] = value.trim();
    this.setState({searchData: searchData});
  }

  handleReset() {
    this.setState({searchData: {
        searchValue: "",
        dateType: "created_at",
        dateFrom: "",
        dateTo: "",
        countType: "msg_count",
        countOp: "eq",
        countValue: ""
      }
    });
  }

  handleSearch(e) {
    if (e) e.preventDefault();

    this.setState({sStatus: "L"});

    const requestOptions = {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(this.state.searchData)
    };

    fetch("/os/ossui/v1/in/chatbot/session/search", requestOptions)
      .then(function (response) {
        if (response.ok)
          return response.json();
        else
          throw Error(response.statusText);

      }).then(function (resJSON) {
        if (resJSON.status && resJSON.status == "S") {
          if (resJSON.data && resJSON.data.length > 0) {
            this.setState({searchResults: resJSON.data.map(function(row) {
              return [
                <a style={{cursor: 'pointer'}} onClick={(e)=>{this.handleChatData(e, row.session_id)}}>{row.session_id}</a>,
                row.prompt_tokens,
                row.completion_tokens,
                row.msg_count,
                row.overall_rating,
                row.db_lookup,
                row.source,
                row.user_id,
                row.tenant,
                Formatter.fmDateTime(row.created_at),
                Formatter.fmDateTime(row.updated_at)
              ];
            }.bind(this))});

            this.setState({sStatus: "S"});

          } else {
            this.setState({sStatus: "N"});
          }

        } else if (resJSON.status && resJSON.status == "N") {
          this.setState({sStatus: "N"});

        } else {
          throw Error(resJSON.message);
        }

      }.bind(this)).catch(function (error) {
        console.log("Error while searching session data, err =", error);
        this.setState({sStatus: "E"});

      }.bind(this));
  }

  handleChatData(e, id) {
    if (e) e.preventDefault();

    this.setState({cStatus: "L"});

    const requestOptions = {
      method: 'GET',
      headers: {'Content-Type': 'application/json'}
    };

    fetch("/os/ossui/v1/in/chatbot/session/" + id, requestOptions)
      .then(function (response) {
        if (response.ok)
          return response.json();
        else
          throw Error(response.statusText);

      }).then(function (resJSON) {
        if (resJSON.status && resJSON.status == "S") {
          if (resJSON.data?.chat && resJSON.data?.chat.length > 0) {
            this.setState({chatData: resJSON.data});
            this.setState({cStatus: "S"});

          } else {
            this.setState({cStatus: "N"});
          }

        } else if (resJSON.status && resJSON.status == "N") {
          if (resJSON.message == "access_denied")
            this.setState({cStatus: "AD"});
          else
            this.setState({cStatus: "N"});

        } else {
          throw Error(resJSON.message);
        }

      }.bind(this)).catch(function (error) {
        console.log("Error while searching session data, err =", error);
        this.setState({cStatus: "E"});

      }.bind(this));
  }

  handlePlan(session, id, plan) {
    var titleText = `Plan for msg id: ${id} of session: ${session}`;
    var newWindow = window.open("", "_blank");

    if (!newWindow)
      return;

    var favicon = newWindow.document.createElement("link");
    favicon.rel = "shortcut icon";
    favicon.sizes = "32x32";
    favicon.type = "image/png";
    favicon.href = "/oss.ico";
    newWindow.document.head.appendChild(favicon);

    newWindow.document.title = titleText;

    newWindow.document.head.insertAdjacentHTML(
      "beforeend",
      `
        <style>
          * {
            box-sizing: border-box;
          }

          html,
          body {
            margin: 0;
            padding: 0;
            min-height: 100%;
          }

          body {
            background: #f6f8fa;
            color: #24292f;
            font-family: "HPSimplified";
          }

          .json-container {
            max-width: 1920px;
            margin: 0 auto;
            padding: 10px;
          }

          .json-card {
            background: #ffffff;
            border: 1px solid #d0d7de;
            border-radius: 5px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
            overflow: hidden;
          }

          .json-toolbar {
            display: flex;
            align-items: center;
            gap: 6px;
            height: 40px;
            padding: 0 14px;
            background: #0096d6;
            color: white;
            border-bottom: 1px solid #d8dee4;
          }

          pre {
            margin: 0;
            padding: 10px;
            overflow-x: auto;
            font-size: 11px;
            white-space: pre-wrap;
            word-break: break-word;
            tab-size: 2;
          }
        </style>
      `
    );

    var container = newWindow.document.createElement("div");
    container.className = "json-container";

    var card = newWindow.document.createElement("div");
    card.className = "json-card";

    var toolbar = newWindow.document.createElement("div");
    toolbar.className = "json-toolbar";

    var toolbarText = newWindow.document.createElement("span");
    toolbarText.textContent = titleText;

    toolbar.appendChild(toolbarText);

    var pre = newWindow.document.createElement("pre");
    pre.textContent = JSON.stringify(plan, null, 2);

    card.appendChild(toolbar);
    card.appendChild(pre);

    container.appendChild(card);

    newWindow.document.body.appendChild(container);
  }

  render() {
    return (
      <div className="modal" style={{"display": "block"}}>
        <div className="modal-dialog modal-lg" style={{"width": "90%"}}>
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" onClick={this.handleClose} aria-hidden="true">x</button>
              <h3 className="modal-title" style={{maxWidth: "800px"}}>
                Session Storage Viewer
                <span style={{fontSize: "11px", fontWeight: "400", paddingLeft: "5px"}}>
                  Advanced
                </span>
              </h3>
            </div>
            <div className="modal-body" style={{display: 'flex', maxHeight: '80vh', height: '80vh', overflow: 'hidden'}}>
              <div id="csv-left-container" style={{width: this.state.cStatus ? '60%' : '100%', overflow: 'hidden'}}>
                <form onSubmit={(e)=>{this.handleSearch(e)}}>
                  <div style={{marginBottom: '10px'}}>
                    <select id="csv-date-type" name="dateType"
                            className="form-control"
                            onChange={this.handleChange}
                            style={{width: '20%', display: 'inline'}}>
                      <option value="created_at">Created On</option>
                      <option value="updated_at">Updated On</option>
                    </select>
                    <input type="text" className="form-control"
                           onChange={this.handleChange}
                           style={{width: '40%', display: 'inline'}}
                           value={this.state.searchData.dateFrom}
                           onFocus={(e) => {e.target.type = "date"}}
                           onBlur={(e) => {e.target.type = "text"}}
                           placeholder="From:"
                           id="csv-date-from" name="dateFrom" />
                    <input type="text" className="form-control"
                           onChange={this.handleChange}
                           style={{width: '40%', display: 'inline'}}
                           value={this.state.searchData.dateTo}
                           onFocus={(e) => {e.target.type = "date"}}
                           onBlur={(e) => {e.target.type = "text"}}
                           placeholder="To:"
                           id="csv-date-to" name="dateTo" />
                  </div>
                  <div style={{marginBottom: '10px'}}>
                    <input type="text" className="form-control"
                           id="csv-search-value" name="searchValue"
                           placeholder="Please enter 'Session ID' or 'User ID' to search..."
                           onChange={this.handleChange}
                           value={this.state.searchData.searchValue}
                           style={{width: '50%', display: 'inline', verticalAlign: 'middle'}} />
                    <select id="csv-count-type" name="countType"
                            className="form-control"
                            onChange={this.handleChange}
                            style={{width: '10.5%', marginLeft: '0.5%', display: 'inline', verticalAlign: 'middle'}}>
                      <option value="msg_count">User Msg Count</option>
                      <option value="overall_rating">Overall Rating</option>
                      <option value="db_lookup">DB Lookup</option>
                    </select>
                    <select id="csv-count-op" name="countOp"
                            className="form-control"
                            onChange={this.handleChange}
                            style={{width: '4%', display: 'inline', verticalAlign: 'middle'}}>
                      <option value="eq">{"="}</option>
                      <option value="ne">{"!="}</option>
                      <option value="lt">{"<"}</option>
                      <option value="lte">{"<="}</option>
                      <option value="gt">{">"}</option>
                      <option value="gte">{">="}</option>
                    </select>
                    <input type="number" className="form-control"
                           id="csv-count-value" name="countValue"
                           onChange={this.handleChange}
                           value={this.state.searchData.countValue}
                           style={{width: '5%', display: 'inline', verticalAlign: 'middle'}} />
                    <button type="submit" style={{width: '14.5%', marginLeft: '0.5%'}} onClick={this.handleSearch} className="btn btn-primary">Search</button>
                    <button type="button" style={{width: '14.5%', marginLeft: '0.5%'}} onClick={this.handleReset} className="btn btn-default">Reset</button>
                  </div>
                </form>
                {
                  this.state.sStatus
                  ? <div style={{height: '80%', overflowY: 'scroll', overflowX: 'hidden'}}>
                    {
                      this.state.sStatus == "S"
                      ? <LightWeightDataGrid title="Result"
                                 download="true"
                                 height="auto"
                                 maxHeight="auto"
                                 pageSize={500}
                                 pageSizeOpt={[500, 2500, 5000]}
                                 header={["Session ID", "Prompt Tokens", "Completion Tokens", "User Msg Count", "Overall Rating", "DB Lookup", "Source", "User ID", "Tenant", "Created At", "Updated At"]}
                                 data={this.state.searchResults} />
                      : <BasicAlert type={this.state.sStatus} />
                    }
                    </div>
                  : null
                }
              </div>
              {
                this.state.cStatus
                ? <div id="csv-right-container" style={{width: '40%', height: '100%', overflowY: 'scroll', padding: '0px 5px'}}>
                  {
                    this.state.cStatus == "S"
                    ? <div>
                        <span style={{marginLeft: '40px', color: '#777'}}>Session ID: <strong>{this.state.chatData.session_id}</strong></span>
                        <ul className="chatbox">
                          {
                            this.state.chatData.chat.map((msg, idx) => {
                              var key = "csv-cb-msg-" + idx
                              var bgColor = {}
                              msg.content = msg.content.replace(/(?:\r\n|\r|\n)/g, '<br>');
                              //msg.content = msg.content.replace(/(\b(https?|ftp|file):\/\/[\-A-Z0-9+&@#\/%?=~_|!:,.;]*[\-A-Z0-9+&@#\/%=~_|])/img, '<a target="_blank" href="$1">$1</a>');
                              //msg.content = msg.content.replace(/\n/g, '<br>');
                              //msg.content = msg.content.replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi, '<a href="mailto:$1">$1</a>');
                              msg.ts = Formatter.fmDateTime(msg.ts);

                              switch(msg.role) {
                                case "sandy": bgColor = {backgroundColor: '#0096d6', color: '#fff'}; break;
                                case "mate": bgColor = {backgroundColor: '#024ad8', color: '#fff'}; break;
                                case "tool": bgColor = {backgroundColor: '#202248', color: '#fff'}; break;
                                default: bgColor = {backgroundColor: '#cdc6fc'}; break;
                              }

                              if (msg.role == "user")
                                return (
                                  <li key={key} className="chat user">
                                    <span>{this.state.chatData.user_id}&nbsp;&nbsp;<i className="glyphicon glyphicon-user"/></span>
                                    <p>{msg.content}</p>
                                    <span>{msg.ts}</span>
                                  </li>
                                )
                              else
                                return (
                                  <li key={key} className="chat assistant">
                                    <span><ChatbotSandy width="16px" height="16px" style={{verticalAlign: "sub"}}/>{msg.role[0].toUpperCase() + msg.role.substring(1)}</span>
                                    <p style={bgColor} dangerouslySetInnerHTML={{__html: msg.content}}></p>
                                    <span>
                                      { msg.id
                                        ? <strong>MSG ID: {msg.id}&nbsp;&nbsp;&nbsp;</strong>
                                        : null
                                      }
                                      { msg.ts }
                                      { msg.id && msg.plan
                                        ? <span onClick={() => this.handlePlan(this.state.chatData.session_id, msg.id, msg.plan)} className="texticon texticon-primary" style={{color: "#fff", cursor: "pointer", marginLeft: "5px", fontSize: "9px"}}>&nbsp;P&nbsp;L&nbsp;A&nbsp;N&nbsp;</span>
                                        : null
                                      }
                                      { msg.rating && msg.rating === 1
                                        ? <i title="Liked" className="glyphicon glyphicon-thumbs-up" style={{color: "#0096d6", fontSize: "14px", marginLeft: "10px"}}></i>
                                        : msg.rating && msg.rating === -1
                                          ? <i title="Disliked" className="glyphicon glyphicon-thumbs-down" style={{color: "#d9534f", fontSize: "14px", marginLeft: "10px", transform: "scaleX(-1)"}}></i>
                                          : null
                                      }
                                    </span>
                                  </li>
                                )
                            })
                          }
                        </ul>
                      </div>
                    : this.state.cStatus == "AD"
                      ? <BasicAlert type="E" msg="Sorry, you do not have access to this data." />
                      : <BasicAlert type={this.state.cStatus} />
                  }
                  </div>
                : null
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/*------------------------------------------------------------------
|
|   Popup Menu
|
\-----------------------------------------------------------------*/
export class PopupMenu extends React.Component {

  constructor(props) {
    super(props);

    this.menuListRef = React.createRef();
  }

  componentDidMount() {
    if (this.menuListRef.current !== undefined && this.menuListRef.current) {
      var menuListSize = 100;
      var menuListRef = this.menuListRef.current;
      var bcr = menuListRef.getBoundingClientRect();

      var onRightSide = true;
      if (bcr.left > ((window.innerWidth * (menuListSize / 100)) * 0.6)) {
        onRightSide = false;
      }

      if (onRightSide) {
        if (menuListRef.style.right === undefined || (menuListRef.style.right !== undefined && menuListRef.style.right === ''))
          menuListRef.style.left = '15px';
          menuListRef.style.top = '5px';
      } else {
        if (menuListRef.style.left === undefined || (menuListRef.style.left !== undefined && menuListRef.style.left === ''))
          menuListRef.style.right = '15px';
          menuListRef.style.top = '5px';
      }
    }
  }

  render() {
    if (   this.props.field !== undefined && this.props.field
        && this.props.list  !== undefined && Array.isArray(this.props.list) && this.props.list.length > 0
    ) {
      return (
        <span className="popup-menu-field">
          {this.props.field}
          <ul className="popup-menu-list" ref={this.menuListRef}>
            {
              this.props.list.map((item, idx) => (
                <li key={"popup-menu-list-" + idx}>{item}</li>
              ))
            }
          </ul>
        </span>
      )
    }
  }
}

//------------------------------------------------------------------------
//  SliderCheckBox :time being keeping here !! move to components so that every can use
//  <SliderCheckBox
//        label="label1"
//        name="newsletter"
//        bgColor='#0096d6'
//        switchWidth="50"
//        sliderFunc={this.dfg}
//        tooltip="Enable to Use New Filter"
//      />
//
//------------------------------------------------------------------------

export class SliderCheckBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isChecked: false };
        this.toggleChange   = this.toggleChange.bind(this);
    }

    toggleChange() {
        this.setState({ isChecked: !this.state.isChecked }, () => {
            if (this.props.sliderFunc) {
                this.props.sliderFunc(this.state.isChecked);
            }
        });
    }

    render() {
        var switchWidth  = this.props.switchWidth  || 40 ;
        var switchHeight = this.props.switchHeight || switchWidth * .56 ;
        var sliderHeight = this.props.sliderHeight || .75 * switchHeight ;
        var sliderWidth  = this.props.sliderWidth  || .43 * switchWidth ;
        var sliderBottom = this.props.sliderBottom || .15 * sliderHeight ;
        var sliderLeft   = this.props.sliderLeft   || .15 * sliderWidth ;
        var bgColor      = this.props.bgColor      || '#66bb6a' ;

        var sliderMove   = .7 * switchWidth
        sliderMove = switchWidth - sliderLeft- sliderWidth

        const toggleStyle = {
            width: `${switchWidth}px`,
            height: `${switchHeight}px`,
            background: this.state.isChecked ? bgColor : '#ccc',
        };
        const circleStyle = {
            bottom: `${sliderBottom}px`,
            left: this.state.isChecked ? `${sliderMove}px` : `${sliderLeft}px`,
            width: `${sliderWidth}px`,
            height: `${sliderHeight}px`,
        };

        return (
            <div>
                <div className="slider-checkbox-toggle" id={this.props.name} style={toggleStyle} title={this.props.tooltip} onClick={this.toggleChange}>
                    <div className="slider-checkbox-circle" style={circleStyle}></div>
                </div>
                <span>{this.props.label}</span>
            </div>
        );
    }
}


//------------------------------------------------------------------------
//  <RoundButton
//                radius={radius of the circle}
//                label={lable given below }
//                sliderFunc={this.toggleDeleteAllFunc} //parent function whch should be called while ON or OFF
//                svg = {<span class="glyphicon glyphicon-trash"></span>}  // how the svg button or button inside the circle
//                clicked='clicked'  // can be used to always ON , can be used '' for OFF
//                additionalStyles={ backgroundColor :'' } // can be used to add extra style
//  />
//
//------------------------------------------------------------------------

export class RoundButton extends React.Component {
    constructor(props) {
        super(props);
        if (!this.props.noAction) this.state = { isClicked: false };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.setState({ isClicked: !this.state.isClicked }, () => {
            if (this.props.sliderFunc) {
                this.props.sliderFunc(this.state.isClicked);
            }
        });
    }

    render() {
        const radius = this.props.radius;
        const label = this.props.label;


        const existingStyles = {
          width: radius * 2,
          height: radius * 2,
          color: 'white'
        };


        const styles = this.props.additionalStyles ? { ...existingStyles, ...this.props.additionalStyles } : { ...existingStyles } ;
        var lClicked = this.state.isClicked ? 'clicked' : '' ;
        lClicked = this.props.clicked ? this.props.clicked : lClicked ;

        return (
            <div className="button-container" id={this.props.id ? this.props.id +"_main" : ""}>
                <button id={this.props.id ? this.props.id :""}
                        className={`round-button ${lClicked}`}
                        onClick={this.handleClick} style={styles}>
                    {this.props.svg}
                </button>
                <div className="button-label">{label}</div>
            </div>
        );
    }
}

//------------------------------------------------------------------------
// colFilters[j] = {
//                     validFilter : in
//                     gt : { searchtext : 2024-01-23 , outcome :[] }
//                     lt : { searchtext : we , outcome :[] }
//                     between :  { betweenValue1 : we , betweenValue1:we1 , outcome :[] }
//                     contains: { searchtext : we , outcome :[] }
//                     in :[]
//                     validFilterContents : []
//
//                 }
// <ExcelFilter  data={vals} // data items in the filter
//               handleApplyFilter={self.handleApplyFilter} // call this function once the user clicks apply button in filter popup
//               handleCancelFilter={self.handleCancelFilter} // call this function once the user clicks cancel button  in filter popup
//               handleFilterButton={self.handleFilterButton} // call this function once the user clicks filter button to open the filter popup
//               colno={colno} // col no
//               colFilters={self.colFilters} //colfilter data structure mentioned above
//               column={args.column} //header column details (name etc..)
//               options={options}  // options
//               id={args.node.id}  /// id of the node
//               setColorForFilter={self.setColorForFilter} //color change once filter applied
//               getXAndYCoord={self.getXAndYCoord}  //return popuup x, y and maximum height of popup
//  />
//------------------------------------------------------------------------
export class ExcelFilter extends React.Component {
  constructor(props) {
    super(props);

    let tSelectedItems = []
    if (this.props.colFilters[this.props.colno] && this.props.colFilters[this.props.colno]["validFilterContents"])  {
      tSelectedItems = this.props.colFilters[this.props.colno]["validFilterContents"]
    }

    this.state = {
      isFilterOpen: false,
      selectedItems: tSelectedItems,
      search: '',
      filterType: 'contains',
      containsValue: ''
    };


    this.originalSelectedItems = this.props.data;
    this.selectAllRef = React.createRef();
    this.rootRef = React.createRef();
  }

  handleOutsideClick = (event) => {
    if (this.state.isFilterOpen && this.rootRef.current && !this.rootRef.current.contains(event.target)) {
      this.cancelFilter();
    }
  }

  uniqueItems = [...new Set(this.props.data)];
  betweenValue1 = '';
  betweenValue2 = '';
  gtValue       = '';
  ltValue       = '';
  maxPopUpHeight = 200
  popUpXCord     = 0
  popUpYCord     = 0

  applySelectedFilterItems = () => {
    var colFilters = this.props.colFilters
    var colno      = this.props.colno
    var selectedItems = []
    let filterType = this.state.filterType
    let setState = false

    if ( colFilters[colno] && colFilters[colno].validFilter) {
      if ( colFilters[colno].validFilter == "between") {
        this.betweenValue1 = colFilters[colno].between.betweenValue1
        this.betweenValue2 = colFilters[colno].between.betweenValue2
        filterType = 'between'
        setState = true
      } else if ( colFilters[colno].validFilter == "gt") {
        this.gtValue = colFilters[colno].gt.gtValue
        filterType = 'gt'
        setState = true
      } else if ( colFilters[colno].validFilter == "lt") {
        this.ltValue = colFilters[colno].lt.ltValue
        filterType = 'lt'
        setState = true
      }
    }
    if (colFilters[colno] && colFilters[colno]["validFilterContents"])  {
      selectedItems = colFilters[colno]["validFilterContents"]
      setState = true
    }

    this.originalSelectedItems = [...selectedItems]
    setState ?
      this.setState({
        filterType: filterType,
        selectedItems: [...selectedItems]
      }) : null ;

  }

  toggleItem = (item) => {
    this.setState(prevState => {
      const selectedItems = prevState.selectedItems.includes(item)
        ? prevState.selectedItems.filter(i => i !== item)
        : [...prevState.selectedItems, item];
      this.selectAllRef.current.indeterminate = selectedItems.length > 0 && selectedItems.length < this.uniqueItems.length;
      return { selectedItems };
    });
  };

  toggleSelectAll = () => {
    this.setState(prevState => {
      if (prevState.selectedItems.length != 0) {
        this.selectAllRef.current.indeterminate = false;
        return { selectedItems: [] };
      } else {
        this.selectAllRef.current.indeterminate = false;
        return { selectedItems: [...this.uniqueItems] };
      }
    });
  };

  clearFilter = () => {
    this.props.handleApplyFilter({ selectedItems : [], props : this.props, filterDetails : { clearFilter:true } })
  }

  applyFilter = () => {
    let filterDetails = {}
    let bwDates = '';
    let selectedItemsCopy = [...this.state.selectedItems];
    if (this.state.search != '') {
      // Get items that match the search (visible items)
      const filteredItems = this.uniqueItems.filter(item => 
        item.toString().toLowerCase().includes(this.state.search.toLowerCase())
      );
      
      // Keep only the filtered items that are in selectedItems (user wants these excluded)
      const selectedFilteredItems = selectedItemsCopy.filter(item => filteredItems.includes(item));
      
      // Get all non-matching items (not visible in search)
      const nonMatchingItems = this.uniqueItems.filter(item => !filteredItems.includes(item));
      
      // Combine: selected filtered items + all non-matching items
      selectedItemsCopy = [...new Set([...selectedFilteredItems, ...nonMatchingItems])];
    }

    if (this.state.filterType == 'between') {

      switch (this.props.options.type) {
        case 'date' :
                      const startDate = new Date(this.betweenValue1);
                      const endDate = new Date(this.betweenValue2);
                      bwDates = this.uniqueItems.filter(date => new Date(date) >= startDate && new Date(date) <= endDate);
                      selectedItemsCopy = this.uniqueItems.filter(item => !bwDates.includes(item) );
                      filterDetails['between'] = { betweenValue1 : this.betweenValue1 , betweenValue2 : this.betweenValue2 }
                      filterDetails['validFilter'] = 'between'
                      break;
        case 'int'  :
        case 'double' :
                      bwDates = this.uniqueItems
                                .filter(val => parseFloat(val) && !isNaN(val) && parseFloat(val) >= parseFloat(this.betweenValue1) && parseFloat(val) <= parseFloat(this.betweenValue2));
                      selectedItemsCopy = this.uniqueItems.filter(item => !bwDates.includes(item) );
                      filterDetails['between'] = { betweenValue1 : this.betweenValue1 , betweenValue2 : this.betweenValue2 }
                      filterDetails['validFilter'] = 'between'
                      break;
      }

    } else if (this.state.filterType == 'gt') {

      switch (this.props.options.type) {
        case 'date' :
                      const startDate = new Date(this.gtValue);
                      bwDates = this.uniqueItems.filter(date => new Date(date) > startDate);
                      selectedItemsCopy = this.uniqueItems.filter(item => !bwDates.includes(item) );
                      filterDetails['gt'] = { gtValue : this.gtValue }
                      filterDetails['validFilter'] = 'gt'
                      break;
        case 'int'  :
        case 'double' :
                      bwDates = this.uniqueItems
                                .filter(val => parseFloat(val) && !isNaN(val) && parseFloat(val) > parseFloat(this.gtValue));
                      selectedItemsCopy = this.uniqueItems.filter(item => !bwDates.includes(item) );
                      filterDetails['gt'] = { gtValue : this.gtValue }
                      filterDetails['validFilter'] = 'gt'
                      break;
      }

    } else if (this.state.filterType == 'lt') {
      switch (this.props.options.type) {
        case 'date' :
                      const startDate = new Date(this.ltValue);
                      bwDates = this.uniqueItems.filter(date => new Date(date) < startDate);
                      selectedItemsCopy = this.uniqueItems.filter(item => !bwDates.includes(item) );
                      filterDetails['lt'] = { ltValue : this.ltValue }
                      filterDetails['validFilter'] = 'lt'
                      break;
        case 'int'  :
        case 'double' :
                      bwDates = this.uniqueItems
                                .filter(val => parseFloat(val) && !isNaN(val) && parseFloat(val) < parseFloat(this.ltValue));
                      selectedItemsCopy = this.uniqueItems.filter(item => !bwDates.includes(item) );
                      filterDetails['lt'] = { ltValue : this.ltValue }
                      filterDetails['validFilter'] = 'lt'
                      break;
      }

    }

    this.setState(prevState => ({
      isFilterOpen: false
    }));

    this.props.handleApplyFilter({ selectedItems : [...selectedItemsCopy], props : this.props, filterDetails :filterDetails})
  };

  cancelFilter = () => {
    this.setState({
      isFilterOpen: false,
      selectedItems: [...this.originalSelectedItems]
    });
    this.props.handleCancelFilter({props : this.props});

  };

  setColorForFilter = () => {
    return this.props.setColorForFilter({props : this.props, filterExist: this.state.selectedItems.length != 0});
  }

  handleSearch = (event) => {
    this.setState({ search: event.target.value });
  };

  componentDidMount() {
    if(this.selectAllRef.current) {
      this.selectAllRef.current.indeterminate = this.state.selectedItems.length > 0 && this.state.selectedItems.length < this.uniqueItems.length;
    }
    // capture phase so grid handlers calling stopPropagation cannot leave the popup stuck open
    document.addEventListener('mousedown', this.handleOutsideClick, true);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick, true);
  }

  componentDidUpdate() {
    if(this.selectAllRef.current) {
      this.selectAllRef.current.indeterminate = this.state.selectedItems.length > 0 && this.state.selectedItems.length < this.uniqueItems.length;
    }
  }

  getMinDate = () => {
    let dates = this.uniqueItems.filter(item => !isNaN(Date.parse(item)));
    dates = dates.map(date => new Date(date));
    return new Date(Math.min.apply(null, dates)).toISOString().split('T')[0];
  };

  getMaxDate = () => {
    let dates = this.uniqueItems.filter(item => !isNaN(Date.parse(item)));
    dates = dates.map(date => new Date(date));
    return new Date(Math.max.apply(null, dates)).toISOString().split('T')[0];
  };

  showPrompt = (filterType) => {
    this.setState({ filterType : filterType });
  };

  handleFilterButton = (event) => {
    let retVal = this.props.handleFilterButton({
                                                  isFilterOpen:this.state.isFilterOpen ,
                                                  props:this.props
                                                 })
    if (retVal) {
      let jsonXY = this.props.getXAndYCoord({ event:event,window:window })
      this.popUpXCord     = jsonXY.popUpXCord
      this.popUpYCord     = jsonXY.popUpYCord
      this.maxPopUpHeight = jsonXY.maxPopUpHeight
      this.setState({ isFilterOpen: !this.state.isFilterOpen })
    }
  }

  getGtTag = () => {
    let gtTag ='';
    if (this.state.filterType == 'gt' && this.props.options && this.props.options.enableGt) {
      switch (this.props.options.type) {
        case 'date' :
                      this.gtValue  = this.gtValue == '' ? this.getMinDate() : this.gtValue ;
                      gtTag = <div>
                                <input  type = "date"
                                        defaultValue = {this.gtValue}
                                        min = {this.getMinDate()}
                                        max = {this.getMaxDate()}
                                        id = "gtInput"
                                        style = {{ color: '#555', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '3px', outline: 'none', width:'200px', height: '28px' }}
                                        onChange={(e) => this.gtValue = e.target.value}
                                />
                            </div>
                      break;
        case 'int'  :
        case 'double'  :
                      let minValue = Math.min(...this.uniqueItems)
                      let maxValue = Math.max(...this.uniqueItems)
                      this.gtValue  = this.gtValue == '' ? minValue : this.gtValue ;
                      gtTag = <div>
                                <input  type="number"
                                        list = "gtNumbers"
                                        min = {minValue}
                                        max = {maxValue}
                                        defaultValue = {this.gtValue}
                                        id = "gtInput"
                                        style = {{ color: '#555', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '3px', outline: 'none', width:'200px', height: '28px' }}
                                        onChange={(e) => this.gtValue = e.target.value}
                                />
                                <datalist id="gtNumbers">
                                  {this.uniqueItems
                                    .map(value => parseFloat(value))
                                    .filter(number => !isNaN(number) && parseFloat(number) >= minValue && parseFloat(number) <= maxValue)
                                    .sort((a, b) => a - b)
                                    .map((number, index) =>
                                      <option key={index} value={number}></option>
                                  )}
                                </datalist>
                            </div>
                      let gtTag1 = <div>
                                <select defaultValue = {this.gtValue}
                                        id = "gtInput"
                                        style = {{ color: '#555', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '3px', outline: 'none', width:'200px' }}
                                        onChange={(e) => this.gtValue = e.target.value}
                                >
                                {this.uniqueItems
                                    .map(value => parseFloat(value))
                                    .filter(number => !isNaN(number) && parseFloat(number) >= minValue && parseFloat(number) <= maxValue)
                                    .sort((a, b) => a - b)
                                    .map((number, index) =>
                                      <option key={index} value={number}></option>
                                  )}
                                </select>
                            </div>
                      break;
      }
    }
    return gtTag
  }

  getLtTag = () => {
    let ltTag ='';
    if (this.state.filterType == 'lt' && this.props.options && this.props.options.enableLt) {
      switch (this.props.options.type) {
        case 'date' :
                      this.ltValue  = this.ltValue == '' ? this.getMaxDate() : this.ltValue ;
                      ltTag =  <div>
                                  <input  type = "date"
                                          defaultValue = {this.ltValue}
                                          min = {this.getMinDate()}
                                          max = {this.getMaxDate()}
                                          id = "ltInput"
                                          style = {{ color: '#555', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '3px', outline: 'none', width:'200px', height: '28px' }}
                                          onChange={(e) => this.ltValue = e.target.value}
                                  />
                                </div>
                      break;
        case 'int'  :
        case 'double'  :
                      let minValue = Math.min(...this.uniqueItems)
                      let maxValue = Math.max(...this.uniqueItems)
                      this.ltValue  = this.ltValue == '' ? maxValue : this.ltValue ;
                      ltTag = <div>
                                <input  type="number"
                                        list = "ltNumbers"
                                        min = {minValue}
                                        max = {maxValue}
                                        defaultValue = {this.ltValue}
                                        id = "ltInput"
                                        style = {{ color: '#555', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '3px', outline: 'none', width:'200px', height: '28px' }}
                                        onChange={(e) => this.ltValue = e.target.value}
                                        placeholder="Enter Here"
                                />
                                <datalist id="ltNumbers">
                                  {this.uniqueItems
                                    .map(value => parseFloat(value))
                                    .filter(number => !isNaN(number) && parseFloat(number) >= minValue && parseFloat(number) <= maxValue)
                                    .sort((a, b) => a - b)
                                    .map((number, index) =>
                                      <option key={index} value={number}></option>
                                  )}
                                </datalist>
                            </div>
                      break;
      }
    }
    return ltTag
  }

  getBetweenTag = () => {
    let betweenTag = ''
    if (this.state.filterType == 'between' && this.props.options && this.props.options.enableBetween) {
      switch (this.props.options.type) {
        case 'date' :
                      this.betweenValue1  = this.betweenValue1 == '' ? this.getMinDate() : this.betweenValue1 ;
                      this.betweenValue2  = this.betweenValue2 == '' ? this.getMaxDate() : this.betweenValue2 ;
                      betweenTag =  <>
                                      <div >
                                        <div>
                                            <input  type = "date"
                                                    defaultValue = {this.betweenValue1}
                                                    min = {this.getMinDate()}
                                                    max = {this.getMaxDate()}
                                                    id = "betweenInput1"
                                                    style = {{ color: '#555', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '3px', outline: 'none', width:'200px' }}
                                                    onChange={(e) => this.betweenValue1 = e.target.value}
                                            />
                                        </div>
                                        <div style= {{ textAlign: 'center'}}>and</div>
                                        <div>

                                            <input  type = "date"
                                                    defaultValue = {this.betweenValue2}
                                                    min = {this.getMinDate()}
                                                    max = {this.getMaxDate()}
                                                    id = "betweenInput2"
                                                    style = {{ color: '#555', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '3px', outline: 'none', width:'200px' }}
                                                    onChange={(e) => this.betweenValue2 = e.target.value}
                                            />
                                        </div>
                                      </div>
                                    </>
                      break;
        case 'int'  :
        case 'double'  :
                      let minValue = Math.min(...this.uniqueItems)
                      let maxValue = Math.max(...this.uniqueItems)
                      this.betweenValue1  = this.betweenValue1 == '' ? minValue : this.betweenValue1 ;
                      this.betweenValue2  = this.betweenValue2 == '' ? maxValue : this.betweenValue2 ;
                      betweenTag =  <>
                                      <div >
                                        <div>
                                            <input  type="number"
                                                    list = "bwNumbers1"
                                                    min = {minValue}
                                                    max = {maxValue}
                                                    defaultValue={this.betweenValue1}
                                                    id = "betweenInput1"
                                                    style = {{ color: '#555', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '3px', outline: 'none', width:'200px' }}
                                                    onChange={(e) => this.betweenValue1 = e.target.value}
                                            />
                                            <datalist id="bwNumbers1">
                                              {this.uniqueItems
                                                .map(value => parseFloat(value))
                                                .filter(number => !isNaN(number) && parseFloat(number) >= minValue && parseFloat(number) <= maxValue)
                                                .sort((a, b) => a - b)
                                                .map((number, index) =>
                                                <option key={index} value={number}></option>
                                              )}
                                            </datalist>
                                        </div>
                                        <div style= {{ textAlign: 'center'}}>and</div>
                                        <div>

                                            <input  type="number"
                                                    list = "bwNumbers2"
                                                    min = {minValue}
                                                    max = {maxValue}
                                                    defaultValue={this.betweenValue2}
                                                    id = "betweenInput1"
                                                    style = {{ color: '#555', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '3px', outline: 'none', width:'200px' }}
                                                    onChange={(e) => this.betweenValue2 = e.target.value}
                                            />
                                            <datalist id="bwNumbers2">
                                              {this.uniqueItems
                                                .map(value => parseFloat(value))
                                                .filter(number => !isNaN(number) && parseFloat(number) >= minValue && parseFloat(number) <= maxValue)
                                                .sort((a, b) => a - b)
                                                .map((number, index) =>
                                                  <option key={index} value={number}></option>
                                              )}
                                            </datalist>
                                        </div>
                                      </div>
                                    </>
                      break;

        }
      return betweenTag
    }
  }

  render() {

    const filteredItems = this.uniqueItems.filter(item =>
      item.toString().toLowerCase().includes(this.state.search.toLowerCase())
    );

    var jsonParam =  this.setColorForFilter()
    var color = jsonParam.color
    var filterStrokeColor = jsonParam.filterStrokeColor

    var columnHeader =  this.props.column && this.props.column.name ? this.props.column.name : 'No Header Column'

    let betweenTag = this.getBetweenTag();
    let gtTag = this.getGtTag();
    let ltTag = this.getLtTag();

    let selectionBox =  (this.props.options && ( this.props.options.enableBetween || this.props.options.enableBetween || this.props.options.enableBetween) )
                        ?
                          <div className="afc-row"> 
                          <select  onChange={(e) => this.showPrompt(e.target.value)} value={this.state.filterType} style = {{ color: '#555', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '3px', outline: 'none', height :'30px', width:'-webkit-fill-available',minWidth: '200px'}} >
                              { this.state.filterType == 'contain' ? <option value="contains" selected>Contains</option>  : <option value="contains" >Contains</option> }
                              { this.props.options.enableBetween ?
                                (this.state.filterType == 'between' ? <option value="between"  selected>Between</option>   : <option value="between" >Between</option>)
                                :''
                              }
                              { this.props.options.enableGt ?
                                (this.state.filterType == 'gt' ? <option value="gt"  selected>Greater Than</option>   : <option value="gt" >Greater Than</option>)
                                :''
                              }
                              { this.props.options.enableLt ?
                                (this.state.filterType == 'lt' ? <option value="lt"  selected>Less Than</option>   : <option value="lt" >Less Than</option>)
                                :''
                              }
                          </select>
                          </div>
                        : null ;

    return (
      <div ref={this.rootRef}>
        <div style= {{ backgroundColor: color }}>
          <button onClick={(event) => { this.applySelectedFilterItems(); this.handleFilterButton(event) ;}} style= {{ background: 'transparent', border: 'transparent', width:'-webkit-fill-available'}}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke={filterStrokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14"
               style={{float: 'right', marginTop: "1px"}
            }>
              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
            </svg>
          </button>
        </div>

        {this.state.isFilterOpen && (
          <div className="modal" style={{ "display": "block", maxWidth: 'fit-content', maxHeight: 'fit-content', top: this.popUpYCord +'px', left: this.popUpXCord+'px', overflow: 'visible', }}>
            <div className="modal-dialog modal-lg" style = {{ width: "fit-content" }} >
              <div className="modal-content">

                <div className="modal-header" style= {{ textAlign: 'center',
                                                        backgroundColor: '#0096d6',
                                                        fontSize: '13px',
                                                        borderRadius: '5px 5px 0px 0px' ,
                                                        color: '#fff',
                                                        padding: '3px 5px 2px'
                       }}> {columnHeader}</div>


                <div className="modal-body afc-body" style = {{ height :'auto', maxHeight: 'fit-content' }}>
                {selectionBox}
                <div className="afc-row">

                    <div>
                      <div style={{ width: "fit-content", minWidth: '200px' }} >

                        {(this.state.filterType == 'contains') ? (
                            <>
                              <input  type="text" value={this.state.search} onChange={this.handleSearch} placeholder="Search..."
                                      style = {{ outline : 'none', width:'-webkit-fill-available',
                                                 color: '#555',
                                                 backgroundColor: '#fff',
                                                 border: '1px solid #aaa',
                                                 borderRadius: '3px',
                                                 padding: '1px 5px',
                                                 height :'27px',
                                                 minWidth: '200px' }} />

                              <div style={{ maxHeight: this.maxPopUpHeight+'px',
                                            border: '1px solid #e5e5e5',
                                            padding: '3px 6px',
                                            overflow: 'auto',
                                            color: '#555',
                                            marginTop: '0' }}>

                                { filteredItems.length > 0 ? (
                                  <div style = {{ padding: '1px 5px',
                                                  backgroundColor: '#f3f3f3',
                                                  border: '0',
                                                  fontSize: '12px',
                                                  marginTop: '2px' }} >
                                      <label style={{
                                           fontWeight: "400",
                                           color: "#0096d6",
                                           width: "100%",
                                           margin: "2px 0 0 0",
                                           verticalAlign: "text-top"
                                       }}>
                                          <input
                                            type="checkbox"
                                            ref={this.selectAllRef}
                                            checked={this.state.selectedItems.length === 0 }
                                            onChange={this.toggleSelectAll}
                                            style={{ height: '14px',
                                                     width:  '14px',
                                                     margin: '0 6px 0 0',
                                                     verticalAlign: "text-top",
                                                     accentColor: '#0096d6'
                                            }}
                                          />
                                          {this.state.selectedItems.length === 0 ? ' Deselect All' : ' Select All'  }
                                      </label>
                                  </div>
                                  ) : 'No Match Found'
                                }

                                {filteredItems.map((item, index) => (
                                  <div key={index} style = {{ padding: '1px 5px',
                                                              backgroundColor: '#f3f3f3',
                                                              border: '0',
                                                              fontSize: '12px',
                                                              marginTop: '2px' }} >
                                    <label style={{
                                         fontWeight: "400",
                                         width: "100%",
                                         margin: "2px 0 0 0",
                                         verticalAlign: "text-top"
                                     }}>
                                        <input
                                          type="checkbox"
                                          checked={!this.state.selectedItems.includes(item)}
                                          onChange={() => this.toggleItem(item)}
                                          style={{ height: '14px',
                                                   width:  '14px',
                                                   margin: '0 6px 0 0',
                                                   verticalAlign: "text-top",
                                                   accentColor: '#0096d6'
                                                }}
                                        />
                                        {item.toString() == "" ? '(blank)' : item.toString()}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </>
                          ) : null
                        }

                        { (this.state.filterType == 'between') ? ( betweenTag ) : null }
                        { (this.state.filterType == 'gt') ? ( gtTag ) : null }
                        { (this.state.filterType == 'lt') ? ( ltTag ) : null }
                      </div>

                    </div>

                  </div>

                    <div className="modal-footer" style={{ padding:'5px 5px 5px'}}>
                      <button onClick={this.clearFilter} type="button" className="btn btn-primary"  style = {{ outline :'none' }} >
                        <MouseOverPopUp field="Clear" tableContent=<tbody><tr><th>Clear the filter for this column</th></tr></tbody> />
                      </button>
                      <button onClick={this.applyFilter} type="button" className="btn btn-primary"  style = {{ outline :'none' }} >
                        <MouseOverPopUp field="Apply" tableContent=<tbody><tr><th>Apply the filter to include only the selected items</th></tr></tbody> />
                      </button>
                      <button onClick={this.cancelFilter} type="button" className="btn btn-default" style = {{ outline :'none' }} >
                        <MouseOverPopUp field="Cancel" tableContent=<tbody><tr><th>Cancel</th></tr></tbody> />
                      </button>
                    </div>

                </div>

              </div>
            </div>
          </div>

        )}
      </div>
    );
  }
}

export class MaintMsgModal extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showModal: true,
      timeLeft: 5 * 60, // 5 minutes in seconds
    };

    this.handleRefresh = this.handleRefresh.bind(this);
    this.formatTime = this.formatTime.bind(this);
  }

  componentDidMount() {
    this.countdownInterval = setInterval(() => {
      this.setState(prevState => {
        if (prevState.timeLeft <= 1) {
          window.location.reload();
        }
        return { timeLeft: prevState.timeLeft - 1 };
      });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.countdownInterval);
  }

  handleRefresh() {
    window.location.reload();
  }

  formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins} minute(s) and ${secs} second(s)`;
  }

  render(){
    var maintMsg = this.props.msg || "Our site is currently down for a little maintenance magic behind the scenes. We are sprucing things up, ironing out the wrinkles, and making sure everything is running smoother and better than ever for you.<br><br>We truly appreciate your patience and understanding while we work our techy wizardry. It will not be long - we promise!";

    if (this.state.showModal) {
      return (
        <div className="maint-msg-overlay">
          <div className="maint-msg-modal-box">
            <span className="maint-msg-modal-title">HP - Order Status Suite (OSS)</span><br />
            <span className="maint-msg-modal-subtitle">We are taking a quick breather! Hang tight, we’ll be back online very soon.</span>
            <br /><hr />
            <div className="maint-msg-modal-text" dangerouslySetInnerHTML={{__html: maintMsg}} />
            <br />
            Please wait for some time and then try again.
            <br /><br />
            <button className="maint-msg-modal-btn" onClick={this.handleRefresh}>Try again &#x21bb;</button>
            <br /><br />
            <span className="maint-msg-modal-footer">This page will reload in {this.formatTime(this.state.timeLeft)}</span>
          </div>
        </div>
      )
    } else {
      return null;
    }
  }
}

export class OSSAIPersonaModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      showLangSel: false,
      language: 'English'
    };
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (event) => {
    if (event.key === "Escape" && this.state.isOpen) {
      this.closeModal();
    }
  };

  openModal = () => {
    this.setState({isOpen: true});
  };

  closeModal = () => {
    this.setState({isOpen: false});
    this.setState({showLangSel: false});
    this.setState({language: 'English'});
  };

  stopPropagation = (e) => {
    e.stopPropagation();
  };

  handlePersona = (prompt) => {
    window.promptChatbot(prompt);
    this.closeModal();
    // Special handling for internal widget
    if (!document.location.pathname.includes("osWidgetWrapperInt"))
      document.querySelector('button.close[data-dismiss="modal"]')?.click();
  };

  handleLanguage = (e) => {
    var {name, value} = e.target;
    this.setState({[name]: value});
  };

  render() {
    var order = this.props.order;
    var {isOpen, showLangSel, language} = this.state;

    return (
      <>
        <div className="ossai-persona-icon-container" title="OSS AI Assistants" onClick={this.openModal}
             style={{position: "absolute", right: "-54px", top: "2px", margin: "0px"}}>
          <div className="ossai-persona-icon-circle" style={{"--size": "30px", "--bg-color": "aliceblue", "--color": "#0096d6"}}>
            <i className="fa-solid fa-oss-sandy" style={{color: "#0096d6"}}></i>
          </div>
        </div>

        { isOpen && (
          <div className="ossai-persona-modal-overlay" onClick={this.closeModal}>
            <div className="ossai-persona-modal-box" onClick={this.stopPropagation}>
              <button type="button" class="close" style={{margin: "-20px -15px"}} onClick={this.closeModal}>x</button>

              <div className="ossai-persona-icon-container" title="OSS AI assistant that helps to summarize order details.">
                <div className="ossai-persona-icon-circle" style={{"--bg-color": "#EAE7FE", "--color": "#7864F7"}}
                     onClick={() => this.handlePersona("Get summary for order " + order.order_no)}>
                  <i className="fa-solid fa-list" style={{color: "#7864F7"}}></i>
                </div>
                <div className="ossai-persona-icon-label">Order Summary</div>
                <div className="ossai-persona-icon-label-sm">Blossom</div>
              </div>

              { order.order_overall_status != "Delivered" && order.order_status != "CLOSED" && (
                <div className="ossai-persona-icon-container" title="OSS AI assistant that helps to find issues related to an order.">
                  <div className="ossai-persona-icon-circle" style={{"--bg-color": "#FFE6E6", "--color": "#FF5050"}}
                       onClick={() => this.handlePersona("Get issues for order " + order.order_no)}>
                    <i className="fa-solid fa-magnifying-glass-chart" style={{color: "#FF5050"}}></i>
                  </div>
                  <div className="ossai-persona-icon-label">Outlier Analysis</div>
                  <div className="ossai-persona-icon-label-sm">Otto</div>
                </div>
              )}

              <div className="ossai-persona-icon-container" title="OSS AI assistant that helps to draft email with order summary in preferred language.">
                { !showLangSel
                  ? <>
                      <div className="ossai-persona-icon-circle" style={{"--bg-color": "#F8FFE6", "--color": "#98CF02"}}
                           onClick={() => this.setState({showLangSel: true})}>
                        <i className="fa-solid fa-envelope" style={{color: "#98CF02"}}></i>
                      </div>
                      <div className="ossai-persona-icon-label">Draft Email</div>
                      <div className="ossai-persona-icon-label-sm">Emily</div>
                    </>
                  : <>
                      <div className="ossai-persona-icon-circle" style={{"--size": "40px", "--bg-color": "#F8FFE6", "--color": "#98CF02", "marginBottom": "5px"}}>
                        <i className="fa-solid fa-envelope" style={{color: "#98CF02"}}></i>
                      </div>
                      Select Language:
                      <select className='form-control' name='language' id='language' onChange={this.handleLanguage}>
                        <option key={'lan-en'} value="English">English</option>
                        <option key={'lan-fr'} value="French">French</option>
                        <option key={'lan-ge'} value="German">German</option>
                        <option key={'lan-sp'} value="Spanish">Spanish</option>
                        <option key={'lan-it'} value="Italian">Italian</option>
                        <option key={'lan-po'} value="Portuguese">Portuguese</option>
                        <option key={'lan-hi'} value="Hindi">Hindi</option>
                        <option key={'lan-ch'} value="Chinese simplified">Chinese (simplified)</option>
                        <option key={'lan-ko'} value="Korean">Korean</option>
                      </select>
                      <button className="btn btn-primary btn-smallest" id="draftBtn" style={{margin: "2px"}}
                              onClick={() => this.handlePersona("Get email draft for order " + order.order_no + " in " + language)}>
                        Draft Email
                      </button>
                      <button className="btn btn-default btn-smallest" id="cancelBtn" style={{margin: "2px"}}
                              onClick={() => this.setState({showLangSel: false})}>
                        Cancel
                      </button>
                    </>
                }
              </div>
              { /*
              <div className="ossai-persona-icon-container" title="OSS AI assistant that helps CSRs when a customer calls.">
                <div className="ossai-persona-icon-circle" style={{"--bg-color": "#FFE6B8", "--color": "#FFA600"}}
                     onClick={() => this.handlePersona("Get CSR talking points for order " + order.order_no)}>
                  <i className="fa-solid fa-user-tie" style={{color: "#FFA600"}}></i>
                </div>
                <div className="ossai-persona-icon-label">CSR Buddy</div>
                <div className="ossai-persona-icon-label-sm">Macsen</div>
              </div>
              */ }
            </div>
          </div>
        )}
      </>
    );
  }
}

/*------------------------------------------------------------------
|
|   ChatbotExt (Oscar)
|
\-----------------------------------------------------------------*/
export class ChatbotExt extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      user: "",
      tenant: "",
      geo: "",
      page: "",
      session: "",
      userInput: "",
      chatHistory: [],
      genAICfg: {},
      chatPointer: 0,
      hasAccess: true,
      isProcessing: false,
      isProcessingRating: 0,
      processingMsg: "",
      processingMsgColor: "#f2f2f2",
      isNewUser: false,
      isOpened: false,
      isMaximized: false,
      status: "L",
      gStatus: false,
      cStatus: false,
      lStatus: false,
      uStatus: false
    }

    this.handleToggle = this.handleToggle.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handlePrompt = this.handlePrompt.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSend = this.handleSend.bind(this);
    this.handleStop = this.handleStop.bind(this);
    this.handleRating = this.handleRating.bind(this);
    this.handleHelp = this.handleHelp.bind(this);
    this.waitForUserSettings = this.waitForUserSettings.bind(this);
    this.waitForSession = this.waitForSession.bind(this);
    this.initUserData = this.initUserData.bind(this);
    this.getPageTitle = this.getPageTitle.bind(this);
    this.getGenAICfg = this.getGenAICfg.bind(this);
    this.createSession = this.createSession.bind(this);
    this.loadSession = this.loadSession.bind(this);
    this.checkIfReturningUser = this.checkIfReturningUser.bind(this);
    this.checkIfSessionExists = this.checkIfSessionExists.bind(this);
    this.renderCitations = this.renderCitations.bind(this);
    this.renderSuggQuest = this.renderSuggQuest.bind(this);
    this.generateProcessingMsg = this.generateProcessingMsg.bind(this);
    this.jsonToTable = this.jsonToTable.bind(this);

    this.myChatbotExt = React.createRef();
    this.myChatbox = React.createRef();

    this.showdownConv = new showdown.Converter() || null;
    if (this.showdownConv)
      this.showdownConv.setOption('tables', true);

    if (!window.toggleChatbotExt)
      window.toggleChatbotExt = this.handleToggle;

    if (!window.promptChatbotExt)
      window.promptChatbotExt = this.handlePrompt;
  }

  componentDidMount() {
    if (this.props.open)
      this.handleToggle();
  }

  handleToggle() {
    this.waitForUserSettings((userSettings) => {
      if (!this.state.gStatus)
        this.getGenAICfg(userSettings);

      const chatbot = this?.myChatbotExt?.current || document.getElementById("chatbot");

      if (chatbot) {
        chatbot.classList.toggle("show-chatbot");

        if (this.state.hasAccess) {
          if (!this.state.isOpened)
            this.initUserData(userSettings);

        } else {
          this.setState({user: "N/A"});
          this.setState({status: "N"})
        }
      }
    });
  }

  handleResize() {
    const chatbot = this.myChatbotExt.current;
    chatbot.classList.toggle("maximize-chatbot");

    this.state.isMaximized ? this.setState({isMaximized: false}) : this.setState({isMaximized: true});
  }

  handlePrompt(prompt) {
    this.waitForUserSettings((userSettings) => {
      if (!this.state.gStatus)
        this.getGenAICfg(userSettings);

      const chatbot = this.myChatbotExt.current;
      if (!chatbot.classList.contains("show-chatbot"))
        chatbot.classList.add("show-chatbot");

      if (this.state.hasAccess) {
        if (!this.state.isOpened)
          this.initUserData(userSettings);

        this.setState({userInput: prompt});

        this.waitForSession((session) => {setTimeout(() => {this.handleSend()}, 500)});

      } else {
        this.setState({user: "N/A"});
        this.setState({status: "N"})
      }
    });
  }

  handleKeyDown(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      this.handleSend();

    } else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();

      var chatHist = [];
      this.state.chatHistory.map((chat) => {
        if (chat.role && chat.role == "user")
          chatHist.push(chat.content);
      })

      var cp = this.state.chatPointer;
      if (e.key === 'ArrowUp')
        cp = (cp > 0 ? cp - 1 : cp);
      else
        cp = (cp < chatHist.length ? cp + 1 : cp);

      this.setState({userInput: (chatHist[cp] ? chatHist[cp]: "")});
      this.setState({chatPointer: cp});
    }
  }

  handleChange(e) {
    this.setState({userInput: e.target.value});
  }

  handleSend() {
    var userInput = this.state.userInput.trim();

    if (!userInput)
      return;

    // Sanitize input
    userInput.replace(/[&<>]/g, " ");

    var cp = 1;
    this.state.chatHistory.map((chat) => {
      if (chat.role && chat.role == "user")
        cp++;
    });

    var pmc = {msgs:[], colors:[]};
    this.generateProcessingMsg(pmc);
    var handleProcessMsg = setInterval(() => {this.generateProcessingMsg(pmc)}, 5000);

    this.setState({isProcessing: true});
    this.setState({chatPointer: cp});

    setTimeout(() => {
      this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
    }, 100)

    this.abortController = new AbortController();
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: {
          role: "user",
          content: userInput
        },
        session: this.state.session,
        page: this.state.page
      }),
      signal: this.abortController.signal
    };

    if (userInput.substr(0, 11) == "[tool_call]") {
      var tcJSON = JSON.parse(userInput.match(/{([^}]+)}/g))
      userInput = tcJSON.key.replace(/_/g, " ").replace(/^./, c => c.toUpperCase()) + ": " + tcJSON.value;
    }

    this.setState({chatHistory: [...this.state.chatHistory, {role: "user", content: userInput, ts: new Date().toLocaleString()}]});
    this.setState({userInput: ""});

    fetch("/os/ossui/v1/ex/chatbot/chat/user", requestOptions)
      .then(async function (response) {
        const resJSON = await response.json();

        if (!response.ok)
          throw new Error(resJSON.message || response.statusText);

        return resJSON;

      }).then(function (resJSON) {
        if (resJSON.status && resJSON.status == "S" && resJSON.data) {
          var msgID = resJSON.data.id ? resJSON.data.id : ""
          var suggestedQuestions = [];

          if (resJSON.message && resJSON.message == "json") {
            var content = resJSON.data.content ? this.jsonToTable(JSON.parse(resJSON.data.content)) : (this.state.genAICfg.empty_response_msg ? this.state.genAICfg.empty_response_msg : "Sorry, I don't know... I am still learning.");
            var citations = [];

          } else {
            var content = resJSON.data.content ? resJSON.data.content : (this.state.genAICfg.empty_response_msg ? this.state.genAICfg.empty_response_msg : "Sorry, I don't know... I am still learning.");
            //content = content.replace(/(\b(https?|ftp|file):\/\/[\-A-Z0-9+&@#\/%?=~_|!:,.;]*[\-A-Z0-9+&@#\/%=~_|])/img, '<a target="_blank" href="$1">$1</a>');
            //content = content.replace(/(?:\r\n|\r|\n)/g, '<br>');
            //content = content.replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi, '<a href="mailto:$1">$1</a>');

            // Handle links
            var links = content.match(/\[.*?\)/g);
            if (links != null && links.length > 0) {
              for (var link of links) {
                var linkTxt = link.match(/\[(.*?)\]/)[1];
                var linkUrl = link.match(/\((.*?)\)/)[1];
                content = content.replace(link, '<a href="'+linkUrl+'" target="_blank">'+linkTxt+'</a>');
              }
            }

            // Handle suggested questions
            const sqRegex = /\[suggested_questions\](\[[^\]]*\])/;
            const sqMatch = content.match(sqRegex);

            if (sqMatch) {
              try {
                suggestedQuestions = JSON.parse(sqMatch[1]);
                content = content.replace(sqRegex, '').trim();
              } catch (err) {
                console.log("Failed to parse suggested questions:", err);
              }
            }

            if (this.showdownConv && this.showdownConv.makeHtml) {
              content = this.showdownConv.makeHtml(content.replace(/<h./g,'<label').replace(/<\/h.>/g,'</label>'));
              content = content.replace(/<table>/g, '<table class="table table-striped">');
            }

            var citations = [];
            /* Disable citations for Oscar
            if (resJSON.data.citations && resJSON.data.citations.length > 0)
              for (var i=0; i<resJSON.data.citations.length; i++)
                if (resJSON.data.citations[i].title && !citations.includes(resJSON.data.citations[i].title))
                  citations.push(resJSON.data.citations[i].title)
            */
          }

          this.setState({chatHistory: [...this.state.chatHistory, {id: msgID, role: "assistant", content: content, citations: citations, ts: new Date().toLocaleString(), rating: 0, sq: suggestedQuestions}]});
          this.setState({isProcessing: false});
          this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
          clearInterval(handleProcessMsg);

        } else {
          throw Error(resJSON.message);
        }

      }.bind(this)).catch(function (error) {
        console.log(error);

        if (error.name === "AbortError")
          this.setState({chatHistory: [...this.state.chatHistory, {role: "assistant", content: this.state.genAICfg.abort_msg ? this.state.genAICfg.abort_msg : "You aborted the request."}]});
        else if (error?.message?.startsWith("STSU:"))
          this.setState({chatHistory: [...this.state.chatHistory, {role: "assistant", content: error.message.slice(5)}]});
        else
          this.setState({chatHistory: [...this.state.chatHistory, {role: "assistant", content: this.state.genAICfg.error_msg ? this.state.genAICfg.error_msg : "Sorry, error occurred. Please try again later."}]});

        this.setState({isProcessing: false});
        this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
        clearInterval(handleProcessMsg);

      }.bind(this));
  }

  handleStop() {
    if (this.abortController) {
      console.log("Stopping request... request aborted by user.");
      this.abortController.abort();
    }
  }

  handleRating(message, rating) {
    this.setState({isProcessingRating: message});
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session: this.state.session,
        message: message,
        rating: rating
      })
    };

    fetch("/os/ossui/v1/ex/chatbot/rate/", requestOptions)
      .then(function (response) {
        if (response.ok)
          return response.json();
        else
          throw Error(response.statusText);

      }).then(function (resJSON) {
        if (resJSON.status && resJSON.status == "S" && resJSON.data) {
          var chatHistory = [...this.state.chatHistory]

          for (var i = 0; i < chatHistory.length; i++)
            if (chatHistory[i].id && chatHistory[i].id == message)
              chatHistory[i].rating = rating

          this.setState({chatHistory: chatHistory});
          this.setState({isProcessingRating: 0});

          if (rating) {
            var lastIdx = chatHistory.length - 1
            if (chatHistory[lastIdx].id && chatHistory[lastIdx].id == message)
              setTimeout(() => {
                this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
              }, 100)
          }

        } else {
          throw Error(resJSON.message);
        }

      }.bind(this)).catch(function (error) {
        console.log(error);
        this.setState({isProcessingRating: 0});

      }.bind(this));
  }

  handleHelp() {
    var helpContent = this.state.genAICfg.help_msg ? this.state.genAICfg.help_msg : "";

    if (helpContent) {
      this.setState({chatHistory: [...this.state.chatHistory, {role: "assistant", content: helpContent, ts: new Date().toLocaleString()}]});
      setTimeout(() => {
        this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
      }, 100)
    }
  }

  waitForUserSettings(callback) {
    if (!this.state.uStatus) {
      const interval = setInterval(() => {
        var userSettings = typeof window.GlobalUserSettings != 'undefined' && window.GlobalUserSettings.user_id
          ? window.GlobalUserSettings
          : typeof window.UserSettings != 'undefined' && window.UserSettings.user_id
            ? window.UserSettings
            : undefined
        if (userSettings !== undefined) {
          clearInterval(interval);
          this.setState({uStatus: true});
          callback(userSettings);
        }
      }, 500);
    } else {
      callback(typeof window.GlobalUserSettings != 'undefined' && window.GlobalUserSettings.user_id
        ? window.GlobalUserSettings
        : typeof window.UserSettings != 'undefined' && window.UserSettings.user_id
          ? window.UserSettings
          : undefined);
    }
  }

  waitForSession(callback) {
    const interval = setInterval(() => {
      if (this.state.session) {
        clearInterval(interval);
        callback(this.state.session);
      }
    }, 250);
  }

  initUserData(userSettings) {
    var user = "";
    var tenant = "";
    var geo = "";

    if (typeof userSettings != 'undefined' && userSettings.user_id) {
      user = userSettings.user_id;
      tenant = userSettings.tenant;
      geo = userSettings.geo;
    }

    this.setState({tenant: (tenant ? tenant : "HPI")});
    this.setState({geo: geo});

    if (user) {
      this.setState({user: user}, () => {
        this.getPageTitle();
        this.checkIfReturningUser();
        this.checkIfSessionExists();
      });

    } else {
      this.setState({user: user});
    }

    this.setState({isOpened: true});
  }

  getPageTitle() {
    var pageTitle = this.state.genAICfg.unknown_page ? this.state.genAICfg.unknown_page : "Order Status";
    var pageTitleElm = document.getElementById("tmb-page-title");

    if (pageTitleElm && pageTitleElm.innerHTML)
      pageTitle = pageTitleElm.innerHTML;

    this.setState({page: pageTitle});
  }

  getGenAICfg(us) {
    this.setState({status: "L"});

    if (us && us.genAICfg) {
      this.setState({genAICfg: us.genAICfg});
      this.setState({gStatus: true});

      if (this.state.cStatus || this.state.lStatus)
        this.setState({status: "S"});

      if (us.genAICfg.authorized_users && us.genAICfg.authorized_users.length > 0 && us.user_id)
        this.setState({hasAccess: us.genAICfg.authorized_users.includes(us.user_id)});

      if (us.genAICfg.restricted_geos && us.genAICfg.restricted_geos.length > 0)
        if (us.geo && us.genAICfg.restricted_geos.includes(us.geo))
          this.setState({hasAccess: false});

    } else {
      console.log("Error while getting generative ai config");
      this.setState({status: "E"});
    }
  }

  createSession() {
    this.setState({status: "L"});
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    };

    fetch("/os/ossui/v1/ex/chatbot/session?source=oscar", requestOptions)
      .then(function (response) {
        if (response.ok)
          return response.json();
        else
          throw Error(response.statusText);

      }).then(function (resJSON) {
        if (resJSON.status && resJSON.status == "S" && resJSON.data) {
          var date = new Date();
          date.setTime(date.getTime() + (this.state.genAICfg.session_duration_seconds ? (this.state.genAICfg.session_duration_seconds * 1000) : (2*60*60*1000))); // default 2 hours
          document.cookie = "HPOSS_CHATBOT_EXT_SESSION_ID="+resJSON.data+";expires="+date.toUTCString()+";path=/;";

          this.setState({chatHistory: [{role: "system", content: <>---------- New session started ----------<br/>[ ID: {resJSON.data} ]</>, ts: new Date().toLocaleString()}]});
          this.setState({session: resJSON.data});
          this.setState({cStatus: true});

          if (this.state.gStatus)
            this.setState({status: "S"});

          setTimeout(() => {
            this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
          }, 100)

        } else {
          throw Error(resJSON.message);
        }

      }.bind(this)).catch(function (error) {
        console.log("Error while getting session=", error);
        this.setState({status: "E"});

      }.bind(this));
  }

  loadSession(session) {
    this.setState({status: "L"});
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    };

    fetch("/os/ossui/v1/ex/chatbot/session/" + session, requestOptions)
      .then(function (response) {
        if (response.ok)
          return response.json();
        else
          throw Error(response.statusText);

      }).then(function (resJSON) {
        if (resJSON.status && resJSON.status == "S" && resJSON.data) {
          var chatHistoryDB = []
          var chatHistoryResp = resJSON.data.chat ? resJSON.data.chat : []

          for (var i = 0; i < chatHistoryResp.length; i++) {
            if (chatHistoryResp[i].role == 'tool' || chatHistoryResp[i].content.match(/^\s*\[([a-zA-Z]+)\]\s*(\{.*\})\s*$/))
              continue;

            var chRole = ""
            var chContent = chatHistoryResp[i].content;
            var chTs = Formatter.fmDateTime(chatHistoryResp[i].ts);
            var chId = chatHistoryResp[i].id ? chatHistoryResp[i].id : 0;
            var chRating = chatHistoryResp[i].rating ? chatHistoryResp[i].rating : 0;
            var chSuggQuest = [];

            if (chatHistoryResp[i].role != "user")
              chRole = 'assistant';
            else
              chRole = chatHistoryResp[i].role;

            if (chRole == 'assistant') {
              //chContent = chContent.replace(/(?:\r\n|\r|\n)/g, '<br>');
              //chContent = chContent.replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi, '<a href="mailto:$1">$1</a>');

              // Handle links
              var links = chContent.match(/\[.*?\)/g);
              if (links != null && links.length > 0) {
                for (var link of links) {
                  var linkTxt = link.match(/\[(.*?)\]/)[1];
                  var linkUrl = link.match(/\((.*?)\)/)[1];
                  chContent = chContent.replace(link, '<a href="'+linkUrl+'" target="_blank">'+linkTxt+'</a>');
                }
              }

              // Handle suggested questions
              const sqRegex = /\[suggested_questions\](\[[^\]]*\])/;
              const sqMatch = chContent.match(sqRegex);

              if (sqMatch) {
                try {
                  chSuggQuest = JSON.parse(sqMatch[1]);
                  chContent = chContent.replace(sqRegex, '').trim();
                } catch (err) {
                  console.log("Failed to parse suggested questions:", err);
                }
              }

              if (this.showdownConv && this.showdownConv.makeHtml) {
                chContent = this.showdownConv.makeHtml(chContent.replace(/<h./g,'<label').replace(/<\/h.>/g,'</label>'));
                chContent = chContent.replace(/<table>/g, '<table class="table table-striped">');
              }
            } else {
              if (chContent.substr(0, 11) == "[tool_call]") {
                var tcJSON = JSON.parse(chContent.match(/{([^}]+)}/g))
                chContent = tcJSON.key.replace(/_/g, " ").replace(/^./, c => c.toUpperCase()) + ": " + tcJSON.value;
              }
            }

            if (chRole)
              chatHistoryDB.push({id: chId, role: chRole, content: chContent, ts: chTs, rating: chRating, sq: chSuggQuest});
          }

          this.setState({chatHistory: chatHistoryDB});
          this.setState({lStatus: true});

          if (this.state.gStatus)
            this.setState({status: "S"});

          setTimeout(() => {
            this.myChatbox?.current?.scrollTo(0, this.myChatbox?.current?.scrollHeight);
          }, 100)

        } else {
          throw Error(resJSON.message);
        }

      }.bind(this)).catch(function (error) {
        console.log("Error while getting session history data=", error);
        this.setState({status: "E"});

      }.bind(this));
  }

  checkIfReturningUser() {
    if (document.cookie.match(/^(.*;)?\s*HPOSS_CHATBOT_EXT_RETURNED_USER\s*=\s*[^;]+(.*)?$/)) {
      this.setState({isNewUser: false});

    } else {
      var date = new Date();
      var seconds = Math.round(date.getTime() / 1000);
      date.setTime(date.getTime() + (400 * 86400 * 1000));
      document.cookie = "HPOSS_CHATBOT_EXT_RETURNED_USER="+seconds+"; expires="+date.toUTCString()+";path=/;";
      this.setState({isNewUser: true});
    }
  }

  checkIfSessionExists() {
    var session = document.cookie.match(/^(.*;)?\s*HPOSS_CHATBOT_EXT_SESSION_ID\s*=\s*[^;]+(.*)?$/);

    if (session) {
      var cookies = document.cookie.split(';');
      var cvalue = "";
      for (var i=0; i < cookies.length; ++i) {
        var pair = cookies[i].trim().split('=');
        if(pair[0] == "HPOSS_CHATBOT_EXT_SESSION_ID")
          cvalue = pair[1];
      }

      if (cvalue) {
        this.setState({session: cvalue});
        this.loadSession(cvalue);

      } else {
        this.createSession();
      }

    } else {
      this.createSession();
    }
  }

  renderCitations(citations, ts) {
    return (
      <div style={{marginTop: "5px"}}>
        {
          citations.map((value, index) => {
            var fRef = "file-" + (Math.random() + 1).toString(36).substring(2) + new Date(ts).getTime();
            var cLink = this.state.genAICfg.citation_links && this.state.genAICfg.citation_links[value] && this.state.genAICfg.citation_links[value][0]
              ? this.state.genAICfg.citation_links[value][0]
              : "";

            if (cLink)
              return (<div id={fRef} style={{fontSize: "12px"}}><a target="_blank" href={cLink}>{value}</a></div>)
            else
              return (<div id={fRef} style={{fontSize: "12px"}}>{value}</div>)
          })
        }
      </div>
    );
  }

  renderSuggQuest(sq) {
    return (
      <div style={{marginTop: "5px"}}>
        Do you want me to follow up further with one of the below options?
        <br/>
        {
          sq.map((value, index) => {
            if (value)
              return (
                <button type="button" className="btn btn-smallest btn-secondary" style={{marginRight: "5px", marginBottom: "5px"}}
                  onClick={(e) => {
                    this.setState({userInput: value}, () => {
                      setTimeout(() => {
                        this.handleSend();
                      }, 250);
                    });
                  }}
                >
                  <i className="fa-solid fa-oss-sandy fac-white"></i>&nbsp;&nbsp;{value}
                </button>
              )
          })
        }
      </div>
    );
  }

  generateProcessingMsg(pmc) {
    var msgs = this.state.genAICfg.processing_msgs ? this.state.genAICfg.processing_msgs : [
      "OSS is designed to provide timely and accurate order status, shipping and reporting information.",
      "OSS is your single source for real‑time visibility into HP order status, shipping, and delivery - from validation to completion.",
      "OSS is designed to provide a simple at-a-glance view of your orders by minimizing steps to retrieve order status."
    ];

    var colors = ["#cdc6fc", "#e5fea3", "#ffdd9d"];

    if (pmc.msgs.length === msgs.length)
      pmc.msgs = [];

    const unusedIndexesM = msgs.map((_, index) => index).filter(index => !pmc.msgs.includes(index));
    const randomIndexM = unusedIndexesM[Math.floor(Math.random() * unusedIndexesM.length)];

    pmc.msgs.push(randomIndexM);

    this.setState({processingMsg: msgs[randomIndexM]});

    if (pmc.colors.length === colors.length)
      pmc.colors = [];

    const unusedIndexesC = colors.map((_, index) => index).filter(index => !pmc.colors.includes(index));
    const randomIndexC = unusedIndexesC[Math.floor(Math.random() * unusedIndexesC.length)];

    pmc.colors.push(randomIndexC);

    this.setState({processingMsgColor: colors[randomIndexC]});
  }

  jsonToTable(json) {
    var table = "<table>";

    for (var key in json) {
      if (json.hasOwnProperty(key)) {
        var val = json[key];

        if (typeof val !== "string")
          continue; // TODO - handle nested objects

        if (val.startsWith('https'))
          val = val.replace(/(\b(https?):\/\/[\-A-Z0-9+&@#\/%?=~_|!:,.;]*[\-A-Z0-9+&@#\/%=~_|])/img, '<a target="_blank" href="$1"><i class="glyphicon glyphicon-new-window"></i>&nbsp;More details...</a>');

        table += "<tr><td style='background-color: #0096d6; color: #fff; border: 1px solid #bbb; padding: 5px;'>"
              + key
              + "</td><td style='background-color: #f5f5f5; border: 1px solid #bbb; padding: 5px;'>"
              + val
              + "</td></tr>";
      }
    }

    table += "</table>";

    if (table == "<table></table>")
      return "";

    return table;
  }

  render() {
    var welcomeMsg = this.state.genAICfg.returning_user_greeting ? this.state.genAICfg.returning_user_greeting : "Hi, I am <strong>HP Order Status AI Assistant</strong>, your Order Status assistant!<br/>How can I help you today?";
    var disclaimerMsg = this.state.genAICfg.disclaimer ? this.state.genAICfg.disclaimer : "This conversation is being recorded for improving AI response quality.<br/>By using this service, you consent to all actions taken by us with respect<br/>to your information in accordance with the Privacy Policy.";
    var noAccessMsg = this.state.genAICfg.no_access_msg ? this.state.genAICfg.no_access_msg : "Sorry, you don't have access to this functionality of Order Status.";
    var footerMsg = this.state.genAICfg.footer_msg ? this.state.genAICfg.footer_msg : "AI may assist. Don't share personal data. <a target='_blank' href='https://www.hp.com/privacy'>HP.com/privacy</a>";
    var copyTableCSS = "<style> table, th, td { border: 1px solid black; padding: 5px } table { border-collapse: collapse; } thead { background-color: #767676; color: #fff; } </style> ";

    if (this.state.isNewUser)
      welcomeMsg = this.state.genAICfg.new_user_greeting ? this.state.genAICfg.new_user_greeting : "Hi, I am <strong>HP Order Status AI Assistant</strong>, your Order Status assistant!<br/><br/>A couple of years ago I got retired and enjoyed a peaceful life at a farm in Arkansas. But I got recalled recently to work again with my old team, as the new Order Status AI Chatbot. I will be trying to help you learn more about the tool, how to access it and how to use the capabilities.<br/><br/>Since I was away for some time, please bare with me and provide feedback on how I am doing, so my team can know on how to improve my knowledge.";

    return (
      <div id="chatbot" ref={this.myChatbotExt}>
        <div className="chatbot-ext">

          <div className="chatbot-ext-header">
            <div className="chatbot-ext-title">
              <div className="chatbot-ext-name">HP Order Status AI Assistant</div>
            </div>
            <div className="chatbot-ext-win-actions">
              {
                this.state.isMaximized
                ? <a title="Resize" onClick={this.handleResize}>
                    <i className="glyphicon glyphicon-resize-small" />
                  </a>
                : <a title="Resize" onClick={this.handleResize}>
                    <i className="glyphicon glyphicon-resize-full" />
                  </a>
              }
              <a title="Close" onClick={this.handleToggle}>
                <i className="glyphicon glyphicon-remove" />
              </a>
            </div>
          </div>

          <div className="chatbot-ext-content">
            <div className="chatbot-ext-sidebar">
              <a title="Reset chat session" target="_blank" onClick={this.createSession}>
                <i className="glyphicon glyphicon-repeat" />
              </a>
              <a title="Feedback" onClick={() => {window.location.href = "mailto:OSS_Feedback@external.groups.hp.com?subject=OSS%3A%20HP%20Order%20Status%20AI%20Assistant%20Feedback"}}>
                <i className="glyphicon glyphicon-bullhorn" />
              </a>
              <a title="Help" onClick={this.handleHelp}>
                <i className="glyphicon glyphicon-info-sign" />
              </a>
            </div>

            <div className="chatbot-ext-container">
            {
              this.state.status == "S"
              ? this.state.hasAccess
                ? <>
                    <div className="chatbot-ext-messages" ref={this.myChatbox}>
                      <div className="chatbot-ext-message-row assistant">
                        <div className="chatbot-ext-avatar assistant">HP</div>
                        <div className="chatbot-ext-message-content">
                          <div className="chatbot-ext-bubble" dangerouslySetInnerHTML={{__html: welcomeMsg}}></div>
                          <div className="chatbot-ext-meta">HP Order Status AI Assistant</div>
                        </div>
                      </div>
                      <div className="chatbot-ext-message-row system">
                        <div className="chatbot-ext-message-content">
                          <div className="chatbot-ext-bubble" dangerouslySetInnerHTML={{__html: disclaimerMsg}}></div>
                        </div>
                      </div>
                      {
                        this.state.chatHistory.map((msg, idx) => {
                          var key = "cb-msg-" + idx
                          if (msg.role == "user")
                            return (
                              <div key={key} className="chatbot-ext-message-row user">
                                <div className="chatbot-ext-message-content">
                                  <div className="chatbot-ext-bubble">{msg.content}</div>
                                  <div className="chatbot-ext-meta">{this.state.user}&nbsp;&nbsp;{msg.ts}</div>
                                </div>
                                <div className="chatbot-ext-avatar user">ME</div>
                              </div>
                            )
                          else if (msg.role == "assistant")
                            return (
                              <div key={key} className="chatbot-ext-message-row assistant">
                                <div className="chatbot-ext-avatar assistant">HP</div>
                                <div className="chatbot-ext-message-content">
                                  <div className="chatbot-ext-bubble" dangerouslySetInnerHTML={{__html: msg.content}}></div>
                                  <div className="chatbot-ext-meta">
                                    HP Order Status AI Assistant&nbsp;&nbsp;{msg.ts}
                                    <span>
                                      { msg.content
                                        ? <span title="Copy" style={{marginLeft: "10px"}}
                                            onClick={() => {
                                              navigator.clipboard.write([
                                                new ClipboardItem({
                                                  'text/html': new Blob([copyTableCSS + msg.content], {type: 'text/html'}),
                                                  'text/plain': new Blob([
                                                    (() => {
                                                      const div = document.createElement('div');
                                                      div.innerHTML = msg.content;
                                                      return div.innerText;
                                                    })()
                                                  ], {type: 'text/plain'})
                                                })
                                              ])
                                            }}>
                                            <i className="fa-solid fa-copy" style={{color: "#777", fontSize: "14px", cursor: "pointer"}} />
                                          </span>
                                        : null
                                      }
                                      { msg.id
                                        ? msg.rating && msg.rating === 1
                                          ? <>
                                              <i title="Like" onClick={() => this.handleRating(msg.id, 0)}  className="glyphicon glyphicon-thumbs-up" style={{cursor: "pointer", color: "#0096d6", fontSize: "14px", marginLeft: "5px"}}></i>
                                              <i title="Dislike" onClick={() => this.handleRating(msg.id, -1)} className="glyphicon glyphicon-thumbs-down" style={{cursor: "pointer", fontSize: "14px", marginLeft: "5px", transform: "scaleX(-1)"}}></i>
                                            </>
                                          : msg.rating && msg.rating === -1
                                            ? <>
                                                <i title="Like" onClick={() => this.handleRating(msg.id, 1)}  className="glyphicon glyphicon-thumbs-up" style={{cursor: "pointer", fontSize: "14px", marginLeft: "5px"}}></i>
                                                <i title="Dislike" onClick={() => this.handleRating(msg.id, 0)} className="glyphicon glyphicon-thumbs-down" style={{cursor: "pointer", color: "#d9534f", fontSize: "14px", marginLeft: "5px", transform: "scaleX(-1)"}}></i>
                                              </>
                                            : <>
                                                <i title="Like" onClick={() => this.handleRating(msg.id, 1)}  className="glyphicon glyphicon-thumbs-up" style={{cursor: "pointer", fontSize: "14px", marginLeft: "5px"}}></i>
                                                <i title="Dislike" onClick={() => this.handleRating(msg.id, -1)} className="glyphicon glyphicon-thumbs-down" style={{cursor: "pointer", fontSize: "14px", marginLeft: "5px", transform: "scaleX(-1)"}}></i>
                                              </>
                                        : null
                                      }
                                      {
                                        this.state.isProcessingRating && this.state.isProcessingRating == msg.id
                                        ? <i style={{color: "#999", fontSize: "11px", marginLeft: "10px"}}>sending...</i>
                                        : null
                                      }
                                      {
                                        (msg.citations && Object.keys(msg.citations).length > 0)
                                        ? this.renderCitations(msg.citations, msg.ts)
                                        : null
                                      }
                                      {
                                        (msg.sq && msg.sq.length > 0)
                                        ? this.renderSuggQuest(msg.sq)
                                        : null
                                      }
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )
                          else
                            return (null)
                        })
                      }
                      {
                        this.state.isProcessing
                          ? <div className="chatbot-ext-message-row assistant" key="cb-msg-loading">
                              <div className="chatbot-ext-avatar assistant">HP</div>
                              <div className="chatbot-ext-message-content">
                                <div className="chatbot-ext-bubble" style={{background: this.state.processingMsgColor}}>
                                  {this.state.processingMsg}
                                </div>
                                <div className="chatbot-ext-meta">HP Order Status AI Assistant is processing your query... until then, here are some interesting OSS facts</div>
                              </div>
                            </div>
                          : null
                      }
                    </div>

                    <div className="chatbot-ext-input-area">
                      <div className="chatbot-ext-input-wrap">
                        <input placeholder={this.state.isProcessing ? "Please wait..." : "Ask anything about Order Status"}
                               readOnly={this.state.isProcessing}
                               value={this.state.userInput}
                               onKeyDown={this.handleKeyDown}
                               onChange={this.handleChange}
                               autoFocus />
                        {
                          this.state.isProcessing
                          ? <button className="chatbot-ext-send-btn" id="stop-btn" onClick={this.handleStop}>
                              <i className="glyphicon glyphicon-stop" />
                            </button>
                          : <button className="chatbot-ext-send-btn" id="send-btn" onClick={this.handleSend}>
                              <i className="glyphicon glyphicon-chevron-right" />
                            </button>
                        }
                      </div>
                    </div>

                    <div className="chatbot-ext-footer" dangerouslySetInnerHTML={{__html: footerMsg}} />
                  </>
                : <BasicAlert type="I" msg={noAccessMsg} />
              : this.state.status == "L"
                ? <div className="chatbot-spinner-container">
                    <div className="chatbot-spinner" />
                  </div>
                : <BasicAlert type={this.state.status} />
            }
            </div>
          </div>
        </div>
      </div>
    )
  }
}
